var ECXHelper = window.ECXHelper || {},
    TRAP_FOCUS_HANDLERS = {};
(ECXHelper.fetchConfigHTTP = {
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
}),
    (ECXHelper.fetchConfigJSON = {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
    }),
    (ECXHelper.debounce = function (t, s) {
        let i = null;
        return function (e) {
            clearTimeout(i),
                (i = null),
                (i = setTimeout(function () {
                    t.call(this, e);
                }, s));
        };
    }),
    (ECXHelper.removeTrapFocus = function (e = null) {
        document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown),
            e && e.focus();
    }),
    (ECXHelper.trapFocus = function (t, e = t) {
        var s = ECXHelper.qs(".js-header-logo-link"),
            i = t.querySelectorAll(
                `a[href]:not([disabled]), [tabindex]:not([tabindex^='-']), summary, button:not([disabled]), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])`
            );
        let n = i[0],
            r = i[i.length - 1];
        1 === i.length && s && (r = s);
        ECXHelper.removeTrapFocus(),
            (TRAP_FOCUS_HANDLERS.focusin = (e) => {
                (e.target !== t && e.target !== r && e.target !== n) ||
                    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.focusout = function () {
                document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.keydown = function (e) {
                ("Tab" !== e.key && 9 !== e.keyCode) ||
                    (e.shiftKey
                        ? (e.target !== t && e.target !== n) || (r.focus(), e.preventDefault())
                        : e.target === r && (n.focus(), e.preventDefault()));
            }),
            document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            e.focus();
    }),
    (ECXHelper.isColor = function (e) {
        var t = new Option().style;
        return (t.color = e), t.color == e;
    }),
    (ECXHelper.isHexColor = function (e) {
        return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(e);
    }),
    (ECXHelper.isImage = function (e) {
        return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(e);
    }),
    (ECXHelper.preventStickyHeaderReveal = function () {
        var e = ECXHelper.qs("ecx-sticky-header");
        e && e.dispatchEvent(new Event("preventStickyHeaderReveal"));
    }),
    (ECXHelper.formatMoney = function (e, t = "") {
        "string" == typeof e && (e = e.replace(".", ""));
        var s = /\{\{\s*(\w+)\s*\}\}/,
            t = t || window.theme_variables.settings.money_format;
        let i = "";
        switch (t.match(s)[1]) {
            case "amount":
                i = ECXHelper.formatWithDelimiters(e, 2);
                break;
            case "amount_no_decimals":
                i = ECXHelper.formatWithDelimiters(e, 0);
                break;
            case "amount_with_space_separator":
                i = ECXHelper.formatWithDelimiters(e, 2, " ", ".");
                break;
            case "amount_with_comma_separator":
                i = ECXHelper.formatWithDelimiters(e, 2, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = ECXHelper.formatWithDelimiters(e, 2, "'", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = ECXHelper.formatWithDelimiters(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = ECXHelper.formatWithDelimiters(e, 0, " ");
                break;
            case "amount_no_decimals_with_apostrophe_separator":
                i = ECXHelper.formatWithDelimiters(e, 0, "'");
        }
        return t.indexOf("with_comma_separator"), t.replace(s, i);
    }),
    (ECXHelper.defaultTo = function (e, t) {
        return null == e || e != e ? t : e;
    }),
    (ECXHelper.formatWithDelimiters = function (e, t, s, i) {
        return (
            (t = ECXHelper.defaultTo(t, 2)),
            (s = ECXHelper.defaultTo(s, ",")),
            (i = ECXHelper.defaultTo(i, ".")),
            isNaN(e) || null == e
                ? 0
                : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
                  (t[1] ? i + t[1] : "")
        );
    }),
    (ECXHelper.loadScript = function (e, t, s) {
        var i;
        ECXHelper.qs("#" + e)
            ? s()
            : ((i = document.createElement("script")).setAttribute("src", "" + t),
              i.setAttribute("id", "" + e),
              (i.onload = function () {
                  s();
              }),
              (i.onreadystatechange = function () {
                  ("complete" != this.readyState && "loaded" != this.readyState) || s();
              }),
              (i.onerror = function (e) {
                  console.log("Failed to load script file " + t, e), s();
              }),
              document.body.appendChild(i));
    }),
    (ECXHelper.forceUpdateCartStatus = function (e) {
        let t = [
                {
                    section: "cart-drawer",
                    selector: ".js-cart-drawer-wrapper",
                    space_selector: ".js-cart-drawer-wrapper",
                },
                {
                    section: "header-cart-status",
                    space_selector: ".shopify-section",
                    selector: "#headerCartStatus",
                    cart_notification: !1,
                },
                {
                    section: "main-cart",
                    space_selector: "#mainCartContainer",
                    selector: "#mainCartContainer",
                    cart_notification: !1,
                },
                {
                    section: "cart-notification-panel-product",
                    space_selector: ".js-cart-notification-panel-item-count",
                    selector: ".js-cart-notification-panel-item-count-content",
                    cart_notification: !1,
                },
                {
                    section: "cart-notification-panel-product",
                    space_selector: ".js-cart-notification-panel-product-" + e?.id,
                    selector: ".js-cart-notification-panel-content",
                    cart_notification: !0,
                },
            ],
            n = ECXHelper.qs("ecx-cart-noti"),
            s = ECXHelper.qs("ecx-sticky-header");
        e = t.map((e) => e.section).join(",");
        fetch(window.location.pathname + "?sections=" + e)
            .then((e) => e.json())
            .then((i) => {
                s && s.dataset.isEnabled && s.reveal(),
                    t.forEach((e) => {
                        var t = i[e.section],
                            s = ECXHelper.qs(e.selector);
                        t &&
                            s &&
                            ((t = new DOMParser().parseFromString(t, "text/html").querySelector(e.space_selector)) &&
                                (s.innerHTML = t.innerHTML),
                            e.cart_notification) &&
                            n &&
                            n.open();
                    });
            })
            .catch((e) => {
                console.log("Cannot force Update Cart Status");
            });
    });
class ECXPopupEditorHelper {
    constructor(e, t) {
        (this.popupSource = e),
            (this.sectionId = t),
            (this.boundHandler = this.handleSectionEvent.bind(this)),
            (this.isSectionSelected = !1),
            (this.getPopupElement = () =>
                "function" == typeof this.popupSource ? this.popupSource() : this.popupSource),
            "undefined" != typeof Shopify && Shopify.designMode && this.bindEditorEvents();
    }
    bindEditorEvents() {
        document.addEventListener("shopify:section:select", this.boundHandler),
            document.addEventListener("shopify:section:deselect", this.boundHandler),
            document.addEventListener("shopify:section:load", this.boundHandler);
    }
    destroy() {
        document.removeEventListener("shopify:section:select", this.boundHandler),
            document.removeEventListener("shopify:section:deselect", this.boundHandler),
            document.removeEventListener("shopify:section:load", this.boundHandler);
    }
    handleSectionEvent(e) {
        var t = e?.detail;
        t?.sectionId &&
            ((t = t.sectionId === this.sectionId),
            "shopify:section:select" === e.type && t
                ? ((this.isSectionSelected = !0), this.getPopupElement(), this.showPopup())
                : "shopify:section:deselect" === e.type && t
                  ? ((this.isSectionSelected = !1), this.hidePopup())
                  : "shopify:section:load" === e.type &&
                    t &&
                    (this.getPopupElement(),
                    setTimeout(() => {
                        this.isSectionSelected && this.showPopup();
                    }, 150)));
    }
    showPopup() {
        var e = this.getPopupElement();
        e && ("function" == typeof e.togglePopup ? e.togglePopup(!0) : e.toggleAttribute("open", !0));
    }
    hidePopup() {
        var e = this.getPopupElement();
        e && ("function" == typeof e.togglePopup ? e.togglePopup(!1) : e.toggleAttribute("open", !1));
    }
}
class ECXPredictiveSearchEditorHelper extends ECXPopupEditorHelper {
    getNotificationMessage() {
        var e = this.getPopupElement() || document.querySelector("ecx-predictive-srch");
        return e && e.dataset.noti
            ? e.dataset.noti
            : "Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature.";
    }
    isSectionVisible(e) {
        var t;
        return !(
            !e ||
            e.hasAttribute("hidden") ||
            "none" === (t = window.getComputedStyle(e)).display ||
            "hidden" === t.visibility ||
            "0" === t.opacity ||
            (null === e.offsetParent && "fixed" !== t.position && "absolute" !== t.position)
        );
    }
    showPopup() {
        var e = this.sectionId ? document.querySelector("#shopify-section-" + this.sectionId) : null,
            t = this.getPopupElement() || document.querySelector("ecx-predictive-srch"),
            s = this.isSectionVisible(e);
        e && s && t
            ? (t.toggleAttribute("open", !0),
              document.body.classList.add("header--predictive-search-open", "o-hidden"),
              (this.predictiveSearchElm = document.querySelector(".js-predictive-search")),
              (this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input")),
              Shopify.designMode
                  ? "function" == typeof ECXHelper?.removeTrapFocus && ECXHelper.removeTrapFocus()
                  : setTimeout(() => {
                        try {
                            this.predictiveSearchElm &&
                                this.predictiveSearchInputElm &&
                                "function" == typeof ECXHelper?.trapFocus &&
                                ECXHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
                        } catch (e) {
                            console.warn("[PredictiveSearch] trapFocus failed:", e);
                        }
                    }, 300))
            : Shopify.designMode && alert(this.getNotificationMessage());
    }
    hidePopup() {
        var e = this.getPopupElement() || document.querySelector("ecx-predictive-srch");
        e && e.toggleAttribute("open", !1),
            document.body.classList.remove("header--predictive-search-open", "o-hidden");
        try {
            "function" == typeof ECXHelper?.releaseTrapFocus && ECXHelper.releaseTrapFocus();
        } catch (e) {}
    }
}
class ECXElementLazyLoad {
    constructor() {
        (this.elements = ECXHelper.qsa(".js-main-body .js-animate")),
            (this.sequential_elements = ECXHelper.qsa(".js-main-body .js-seq-animate")),
            this.setupEventListeners();
    }
    setupEventListeners() {
        var s = new IntersectionObserver((s, i) => {
            for (let e = 0, t = s.length; e < t; e++)
                s[e].isIntersecting && (s[e].target.classList.add("animated"), i.unobserve(s[e].target));
        });
        for (let e = 0, t = this.elements.length; e < t; e++) s.observe(this.elements[e]);
        var i = new IntersectionObserver(
            (s, i) => {
                for (let e = 0, t = s.length; e < t; e++) {
                    var n = 100 * e;
                    s[e].isIntersecting &&
                        (setTimeout(() => {
                            s[e].target.classList.add("animated");
                        }, n),
                        i.unobserve(s[e].target));
                }
            },
            { threshold: 0.2 }
        );
        for (let e = 0, t = this.sequential_elements.length; e < t; e++) i.observe(this.sequential_elements[e]);
    }
}
setTimeout(() => {
    void 0 !== ECXElementLazyLoad && new ECXElementLazyLoad();
}),
    Shopify.designMode &&
        document.addEventListener("shopify:section:load", function (e) {
            void 0 !== ECXElementLazyLoad && new ECXElementLazyLoad();
        });
class ECXCustomComponent extends HTMLElement {
    constructor() {
        super(), (this.$ = this.querySelector.bind(this)), (this.$$ = this.querySelectorAll.bind(this));
    }
    static initGlobalFeatures() {
        ECXCustomComponent.globalFeaturesInitialized ||
            ((ECXCustomComponent.globalFeaturesInitialized = !0), ECXCustomComponent.initPaymentButtonEnhancement());
    }
    static enhancePaymentButton(e) {
        if (e)
            if (
                (e.classList.contains("btn") || e.classList.add("btn"),
                e.classList.contains("btn-primary--animate") || e.classList.add("btn-primary--animate"),
                e.querySelector(".btn-primary__content"))
            )
                e.dataset.enhanced || (e.dataset.enhanced = "true");
            else {
                var t = document.createElement("span"),
                    s = ((t.className = "d-block o-hidden p-relative"), document.createElement("span"));
                for (s.className = "btn-primary__content"; e.firstChild; ) s.appendChild(e.firstChild);
                t.appendChild(s), e.appendChild(t), (e.dataset.enhanced = "true");
            }
    }
    static enhancePaymentButtons(e = document) {
        e = e.querySelectorAll(".shopify-payment-button__button--unbranded");
        return (
            e.forEach((e) => {
                ECXCustomComponent.enhancePaymentButton(e);
            }),
            0 < e.length
        );
    }
    static waitForPaymentButtons(i, n = 2e3) {
        return new Promise((t) => {
            let s = () => {
                var e = i.querySelectorAll(".shopify-payment-button__button--unbranded");
                return 0 < e.length && (e.forEach((e) => ECXCustomComponent.enhancePaymentButton(e)), !0);
            };
            if (s()) t();
            else {
                let e = new MutationObserver(() => {
                    s() && (e.disconnect(), t());
                });
                e.observe(i, { childList: !0, subtree: !0 }),
                    setTimeout(() => {
                        e.disconnect(), s(), t();
                    }, n);
            }
        });
    }
    static initPaymentButtonEnhancement() {
        ECXCustomComponent.enhancePaymentButtons();
        var e = () => {
            document.querySelectorAll(".shopify-payment-button").forEach((s) => {
                if ("true" !== s.dataset.observed) {
                    let t = null;
                    new MutationObserver((e) => {
                        e.some((e) =>
                            Array.from(e.addedNodes).some(
                                (e) =>
                                    1 === e.nodeType &&
                                    (e.classList?.contains("shopify-payment-button__button--unbranded") ||
                                        e.querySelector?.(".shopify-payment-button__button--unbranded"))
                            )
                        ) &&
                            (clearTimeout(t),
                            (t = setTimeout(() => {
                                ECXCustomComponent.enhancePaymentButtons(s);
                            }, 100)));
                    }).observe(s, { childList: !0, subtree: !0, attributes: !1 }),
                        (s.dataset.observed = "true");
                }
            });
        };
        e(),
            document.addEventListener("shopify:section:load", e),
            document.addEventListener("shopify:section:select", e);
    }
}
class LoadingBar extends HTMLElement {
    constructor() {
        super(), this.bindEventHandlers();
    }
    bindEventHandlers() {
        document.addEventListener("page:loaded", this.handleLoaded.bind(this), { once: !0 }),
            window.addEventListener("load", this.handleLoaded.bind(this), { once: !0 });
    }
    handleLoaded() {
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? (this.style.display = "none")
            : requestAnimationFrame(() => {
                  this.classList.add("is-hidden");
              });
    }
}
customElements.define("loading-bar", LoadingBar);
class ECXHeader extends ECXCustomComponent {
    constructor() {
        super(),
            (this.searchHeaderOpenBtn = this.$$(".js-search-open-trigger")),
            (this.predictiveSearchElm = document.querySelector(".js-predictive-search")),
            (this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input")),
            (this.headerNavigation = this.$(".js-header-navigation")),
            (this.bodyElement = document.body),
            (this.toggleNavItemBtn = this.$$(".js-toggle-nav-item")),
            (this.headerBounds = {}),
            this.searchHeaderOpenBtn.forEach((e) => e.addEventListener("click", this.openPredictiveSearch.bind(this)));
    }
    getPredictiveSearchNotificationMessage() {
        var e = document.querySelector("ecx-predictive-srch");
        return e && e.dataset.noti
            ? e.dataset.noti
            : "Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature.";
    }
    isPredictiveSearchVisible() {
        var e,
            t = document.querySelector("ecx-predictive-srch");
        return (
            !!t &&
            !!(t = t.dataset.sectionId) &&
            !(
                !(t = document.querySelector("#shopify-section-" + t)) ||
                t.hasAttribute("hidden") ||
                "none" === (e = window.getComputedStyle(t)).display ||
                "hidden" === e.visibility ||
                "0" === e.opacity ||
                (null === t.offsetParent && "fixed" !== e.position && "absolute" !== e.position)
            )
        );
    }
    openPredictiveSearch(e) {
        this.isPredictiveSearchVisible() &&
        ((this.predictiveSearchElm && this.predictiveSearchInputElm) ||
            ((this.predictiveSearchElm = document.querySelector(".js-predictive-search")),
            (this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input"))),
        this.predictiveSearchElm) &&
        this.predictiveSearchInputElm
            ? (document.body.classList.add("header--predictive-search-open"),
              this.bodyElement.classList.add("o-hidden"),
              setTimeout(() => {
                  ECXHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
              }, 650))
            : Shopify.designMode && alert(this.getPredictiveSearchNotificationMessage());
    }
}
customElements.define("ecx-header", ECXHeader);
class ECXMenuHeader extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.header = ECXHelper.qs("ecx-header")),
            (this.enableDrawerDesk = "true" === this.header.dataset.enableDrawer),
            (this.isHover = "hover" === this.header.dataset.enableHover),
            (this.details = this.$("details")),
            (this.summaries = this.$$("summary")),
            (this.summary = this.details.querySelector("summary")),
            (this.content = this.summary.nextElementSibling),
            (this.content_animations = null),
            (this.isMegaMenu = "Megamenu" === this.dataset.menuDropdownType),
            (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            this.bindEventHandlers(),
            this.isMegaMenu &&
                ((this.onWindowResizeBound = this.onWindowResize.bind(this)),
                window.addEventListener("resize", this.onWindowResizeBound)),
            !1 === this.isMegaMenu && this.isDesktop && this.initSubmenuPositioning();
    }
    disconnectedCallback() {
        if (
            (this.onWindowResizeBound && window.removeEventListener("resize", this.onWindowResizeBound),
            this.megaMenuResizeObserver)
        ) {
            try {
                this.megaMenuResizeObserver.disconnect();
            } catch (e) {}
            (this.megaMenuResizeObserver = null), (this.megaMenuWrapper = null);
        }
    }
    initSubmenuPositioning() {
        (this.resizeObserver = new ResizeObserver(this.checkSubmenuPositions.bind(this))),
            this.resizeObserver.observe(document.body),
            this.checkSubmenuPositions();
    }
    checkSubmenuPositions() {
        this.$$(".menu-dropdown-lv2").forEach((e) => {
            var t,
                s = e.closest(".menu__item");
            s &&
                ((s = s.getBoundingClientRect()),
                (s = window.innerWidth - s.right),
                (t = e.offsetWidth + ((t = e.querySelector(".menu-dropdown-lv3")) ? t.offsetWidth : 0)),
                e.classList.remove("menu-dropdown--right"),
                s <= t) &&
                e.classList.add("menu-dropdown--right");
        });
    }
    bindEventHandlers() {
        (this.mobileBreakpoint = window.matchMedia("(max-width: 1025px)")),
            this.details.addEventListener("focusout", this.onFocusOutEvent.bind(this)),
            this.addEventListener("mousedown", () => {
                this._mouseDownInside = !0;
            }),
            !this.isHover || this.enableDrawerDesk || this.mobileBreakpoint.matches
                ? this.handleMenuClick()
                : this.handleMenuHover();
    }
    isAnyMegaMenuOpen() {
        var e = document.querySelector(
            'ecx-menu-header[data-menu-dropdown-type="Megamenu"] details[data-level="1"][open]'
        );
        return Boolean(e);
    }
    ensureHeaderMegaClass() {
        "Megamenu" === this.dataset.menuDropdownType && this.header.classList.add("header-mega--open");
    }
    updateHeaderMegaClassOnClose() {
        this.isAnyMegaMenuOpen() || this.header.classList.remove("header-mega--open");
    }
    getMegaMenuHeight(e) {
        e = e?.querySelector(".js-mega-menu-wrapper");
        return e ? e.offsetHeight : 0;
    }
    measureAndEmitMegaMenuHeight(t) {
        "Megamenu" === this.dataset.menuDropdownType &&
            "1" === t?.dataset.level &&
            requestAnimationFrame(() => {
                var e = this.getMegaMenuHeight(t),
                    e =
                        ((this.currentMegaMenuHeight = e),
                        this.header?.style?.setProperty("--mega-menu-height", e + "px"),
                        new CustomEvent("ecx:mega-menu:height", { bubbles: !0, detail: { height: e, details: t } }));
                this.dispatchEvent(e);
            });
    }
    observeMegaMenu(e) {
        if (e) {
            var t = e.querySelector(".js-mega-menu-wrapper");
            if (t) {
                if (
                    (this.megaMenuResizeObserver ||
                        (this.megaMenuResizeObserver = new ResizeObserver(() => {
                            this.measureAndEmitMegaMenuHeight(e);
                        })),
                    this.megaMenuWrapper && this.megaMenuWrapper !== t)
                )
                    try {
                        this.megaMenuResizeObserver.unobserve(this.megaMenuWrapper);
                    } catch (e) {}
                this.megaMenuWrapper = t;
                try {
                    this.megaMenuResizeObserver.observe(t);
                } catch (e) {}
            }
        }
    }
    unobserveMegaMenu(e) {
        var t = e ? e.querySelector(".js-mega-menu-wrapper") : this.megaMenuWrapper;
        if (this.megaMenuResizeObserver && t)
            try {
                this.megaMenuResizeObserver.unobserve(t);
            } catch (e) {}
        e && this.megaMenuWrapper === t && (this.megaMenuWrapper = null);
    }
    onWindowResize() {
        this.isMegaMenu &&
            this.details &&
            "1" === this.details.dataset.level &&
            this.details.hasAttribute("open") &&
            this.measureAndEmitMegaMenuHeight(this.details);
    }
    handleMenuClick() {
        for (let e = 0, t = this.summaries.length; e < t; e++) {
            var s = this.summaries[e];
            s.addEventListener("click", (e) => {
                let t = e.currentTarget.closest("details");
                e.preventDefault(),
                    t.hasAttribute("open")
                        ? (e.currentTarget.setAttribute("aria-expanded", !1),
                          t.classList.remove("is-open"),
                          setTimeout(() => {
                              (t.open = !1),
                                  "1" == t.dataset.level &&
                                      (this.header.classList.remove("header-menu--open"),
                                      this.updateHeaderMegaClassOnClose(),
                                      this.unobserveMegaMenu(t));
                          }, 300))
                        : ("1" == t.dataset.level
                              ? this.closeOtherLevel1Menus(t)
                              : "2" == t.dataset.level && this.closeOtherLevel2Menus(t),
                          t.classList.remove("is-open"),
                          e.currentTarget.setAttribute("aria-expanded", !0),
                          (t.open = !0),
                          t.offsetHeight,
                          requestAnimationFrame(() => {
                              t.classList.add("is-open");
                          }),
                          "1" == t.dataset.level &&
                              (this.header.classList.add("header-menu--open"),
                              this.ensureHeaderMegaClass(),
                              this.measureAndEmitMegaMenuHeight(t),
                              this.observeMegaMenu(t)));
            }),
                s.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
        }
    }
    closeOtherLevel1Menus(s) {
        this.querySelectorAll('details[data-level="1"]').forEach((e) => {
            var t;
            e !== s &&
                e.hasAttribute("open") &&
                ((t = e.querySelector("summary")),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    (e.open = !1), this.unobserveMegaMenu(e);
                }, 300));
        });
    }
    closeOtherLevel1MenusImmediate(s) {
        this.querySelectorAll('details[data-level="1"]').forEach((e) => {
            var t;
            e !== s &&
                e.hasAttribute("open") &&
                ((t = e.querySelector("summary")),
                e.classList.add("hover-no-animation"),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                (e.open = !1),
                this.unobserveMegaMenu(e),
                setTimeout(() => {
                    e.classList.remove("hover-no-animation");
                }, 10));
        });
    }
    closeOtherLevel2Menus(s) {
        var e = s.closest('details[data-level="1"]');
        e &&
            e.querySelectorAll('details[data-level="2"]').forEach((e) => {
                var t;
                e !== s &&
                    e.hasAttribute("open") &&
                    ((t = e.querySelector("summary")),
                    e.classList.remove("is-open"),
                    t.setAttribute("aria-expanded", !1),
                    setTimeout(() => {
                        e.open = !1;
                    }, 300));
            });
    }
    closeOtherLevel2MenusImmediate(s) {
        var e = s.closest('details[data-level="1"]');
        e &&
            e.querySelectorAll('details[data-level="2"]').forEach((e) => {
                var t;
                e !== s &&
                    e.hasAttribute("open") &&
                    ((t = e.querySelector("summary")),
                    e.classList.add("hover-no-animation"),
                    e.classList.remove("is-open"),
                    t.setAttribute("aria-expanded", !1),
                    (e.open = !1),
                    setTimeout(() => {
                        e.classList.remove("hover-no-animation");
                    }, 10));
            });
    }
    onKeyUpEscEvent(t) {
        if ("ESCAPE" === t.code.toUpperCase()) {
            let e = t.target.closest("details[open]");
            e &&
                ((t = e.querySelector("summary")),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    e.removeAttribute("open"),
                        "1" == e.dataset.level &&
                            (this.header.classList.remove("header-menu--open"),
                            this.updateHeaderMegaClassOnClose(),
                            "Megamenu" === this.dataset.menuDropdownType) &&
                            this.unobserveMegaMenu(e);
                }, 300),
                t.focus());
        }
    }
    onFocusOutEvent() {
        setTimeout(() => {
            this._mouseDownInside
                ? (this._mouseDownInside = !1)
                : this.contains(document.activeElement) || this.close();
        });
    }
    handleMenuHover() {
        (this.hoverTimeout = null),
            (this.level2HoverTimeouts = new Map()),
            (this.entryDelayTimeouts = new Map()),
            (this.currentOpenMenu = null),
            (this.currentOpenLevel2Menus = new Set());
        for (let e = 0, t = this.summaries.length; e < t; e++) {
            let t = this.summaries[e].closest("details");
            if ("1" === t.dataset.level)
                if ("Megamenu" === this.dataset.menuDropdownType)
                    this.addEventListener("mouseenter", (e) => {
                        this.onMenuHover(t, !0);
                    }),
                        this.addEventListener("mouseleave", (e) => {
                            this.onMenuHover(t, !1);
                        });
                else {
                    var s = t.closest(".menu__item");
                    if (!s) return;
                    s.addEventListener("mouseenter", (e) => {
                        this.onMenuHover(t, !0);
                    }),
                        s.addEventListener("mouseleave", (e) => {
                            this.onMenuHover(t, !1);
                        });
                }
            if ("2" === t.dataset.level) {
                s = t.closest('details[data-level="1"]');
                if (!(s && s.closest(".menu__item-megamenu"))) {
                    var i = t.closest(".submenu__item");
                    if (!i) return;
                    i.addEventListener("mouseenter", (e) => {
                        this.onLevel2MenuHover(t, !0);
                    }),
                        i.addEventListener("mouseleave", (e) => {
                            this.onLevel2MenuHover(t, !1);
                        });
                }
            }
        }
        for (let e = 0, t = this.summaries.length; e < t; e++)
            this.summaries[e].addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    }
    onMenuHover(e, t) {
        clearTimeout(this.hoverTimeout),
            this.entryDelayTimeouts.has(e) &&
                (clearTimeout(this.entryDelayTimeouts.get(e)), this.entryDelayTimeouts.delete(e));
        var s = "Megamenu" === this.dataset.menuDropdownType;
        t
            ? !(this.currentOpenMenu && this.currentOpenMenu !== e) && s && !this.currentOpenMenu
                ? ((t = setTimeout(() => {
                      this.closeOtherLevel1MenusImmediate(e),
                          this.openHoverMenu(e),
                          (this.currentOpenMenu = e),
                          this.entryDelayTimeouts.delete(e);
                  }, 250)),
                  this.entryDelayTimeouts.set(e, t))
                : (this.closeOtherLevel1MenusImmediate(e), this.openHoverMenu(e), (this.currentOpenMenu = e))
            : s
              ? (this.hoverTimeout = setTimeout(() => {
                    this.closeHoverMenu(e), this.currentOpenMenu === e && (this.currentOpenMenu = null);
                }, 300))
              : (this.closeHoverMenu(e), this.currentOpenMenu === e && (this.currentOpenMenu = null));
    }
    onLevel2MenuHover(t, e) {
        let s = t.closest('details[data-level="1"]');
        this.level2HoverTimeouts.has(t) &&
            (clearTimeout(this.level2HoverTimeouts.get(t)), this.level2HoverTimeouts.delete(t)),
            this.entryDelayTimeouts.has(t) &&
                (clearTimeout(this.entryDelayTimeouts.get(t)), this.entryDelayTimeouts.delete(t)),
            e
                ? Array.from(this.currentOpenLevel2Menus).some(
                      (e) => e !== t && e.closest('details[data-level="1"]') === s
                  )
                    ? ((e = setTimeout(() => {
                          this.closeOtherLevel2MenusImmediate(t),
                              this.openHoverMenu(t),
                              this.currentOpenLevel2Menus.add(t),
                              this.entryDelayTimeouts.delete(t);
                      }, 150)),
                      this.entryDelayTimeouts.set(t, e))
                    : (this.closeOtherLevel2MenusImmediate(t),
                      this.openHoverMenu(t),
                      this.currentOpenLevel2Menus.add(t))
                : ((e = setTimeout(() => {
                      this.closeHoverMenu(t), this.currentOpenLevel2Menus.delete(t), this.level2HoverTimeouts.delete(t);
                  }, 50)),
                  this.level2HoverTimeouts.set(t, e));
    }
    openHoverMenu(e) {
        e.hasAttribute("open") ||
            ((e.open = !0),
            e.querySelector("summary").setAttribute("aria-expanded", !0),
            e.offsetHeight,
            requestAnimationFrame(() => {
                e.classList.add("is-open");
            }),
            "1" === e.dataset.level &&
                (this.header.classList.add("header-menu--open"),
                this.ensureHeaderMegaClass(),
                this.measureAndEmitMegaMenuHeight(e),
                this.observeMegaMenu(e)));
    }
    closeHoverMenu(e) {
        e.hasAttribute("open") &&
            (e.classList.remove("is-open"),
            e.querySelector("summary").setAttribute("aria-expanded", !1),
            setTimeout(() => {
                (e.open = !1),
                    "1" === e.dataset.level && this.header.classList.remove("header-menu--open"),
                    this.updateHeaderMegaClassOnClose(),
                    "1" === e.dataset.level && this.unobserveMegaMenu(e);
            }, 300));
    }
    close() {
        this.hoverTimeout && (clearTimeout(this.hoverTimeout), (this.hoverTimeout = null)),
            this.level2HoverTimeouts &&
                (this.level2HoverTimeouts.forEach((e) => clearTimeout(e)), this.level2HoverTimeouts.clear()),
            this.entryDelayTimeouts &&
                (this.entryDelayTimeouts.forEach((e) => clearTimeout(e)), this.entryDelayTimeouts.clear());
        var e = "1" == this.details.dataset.level && this.details.hasAttribute("open");
        for (let t = 0, e = this.summaries.length; t < e; t++) {
            var s = this.summaries[t];
            let e = s.closest("details");
            e.hasAttribute("open") &&
                (e.classList.remove("is-open"),
                s.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    e.removeAttribute("open");
                }, 300));
        }
        e &&
            setTimeout(() => {
                this.header.classList.remove("header-menu--open");
            }, 300),
            (this.currentOpenMenu = null),
            this.currentOpenLevel2Menus && this.currentOpenLevel2Menus.clear(),
            setTimeout(() => {
                this.updateHeaderMegaClassOnClose();
            }, 300);
    }
    disconnectedCallback() {
        this.hoverTimeout && clearTimeout(this.hoverTimeout),
            this.level2HoverTimeouts &&
                (this.level2HoverTimeouts.forEach((e) => clearTimeout(e)), this.level2HoverTimeouts.clear()),
            this.entryDelayTimeouts &&
                (this.entryDelayTimeouts.forEach((e) => clearTimeout(e)), this.entryDelayTimeouts.clear());
    }
}
customElements.define("ecx-menu-header", ECXMenuHeader);
class ECXStickyHeader extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        if (
            ((this.header_sticky = this.dataset.headerSticky),
            (this.prevent_reveal = !1),
            (this.css_ary = ["top-0", "zi-4", "header--sticky", "is-header-hide"]),
            (this.header = ECXHelper.qs(".js-section-header")),
            (this.cartNotificationPanel = this.$(".js-cartNotificationPanel")),
            (this.currentScrollTop = 0),
            (this.headerBounds = {}),
            this.bindEventHandlers(),
            "disable" == this.header_sticky)
        )
            return !1;
        "always" == this.header_sticky
            ? (this.header.classList.add("header--sticky-always"),
              this._checkStickyAlwaysPosition(),
              this._bindStickyAlwaysScrollHandler())
            : this.createObserver();
    }
    bindEventHandlers() {
        if ("disable" == this.header_sticky) return !1;
        (this.preventStickyHeaderReveal = () => (this.prevent_reveal = !0)),
            this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.addEventListener("scroll", this.onScrollHandle.bind(this), !1);
    }
    _checkStickyAlwaysPosition() {
        this.header &&
            (0.5 < this.header.getBoundingClientRect().top
                ? this.header.classList.remove("header--sticky-always")
                : this.header.classList.add("header--sticky-always"));
    }
    _bindStickyAlwaysScrollHandler() {
        (this.stickyAlwaysScrollHandler = () => {
            this._checkStickyAlwaysPosition();
        }),
            window.addEventListener("scroll", this.stickyAlwaysScrollHandler, !1);
    }
    createObserver() {
        new IntersectionObserver((e, t) => {
            (this.header_bounds = e[0].intersectionRect), t.disconnect();
        }).observe(this.header);
    }
    onScrollHandle() {
        if (this.header_bounds) {
            var e = window.pageYOffset || ECXHelper.qde.scrollTop;
            if (e > this.currentScrollTop && e > this.header_bounds.bottom) {
                if (this.prevent_reveal)
                    return (
                        window.clearTimeout(this.is_scrolling),
                        void (this.is_scrolling = setTimeout(() => {
                            this.prevent_reveal = !1;
                        }, 20))
                    );
                requestAnimationFrame(this.hide.bind(this));
            } else if (e < this.currentScrollTop && e > this.header_bounds.bottom) {
                if (this.prevent_reveal)
                    return (
                        requestAnimationFrame(this.hide.bind(this)),
                        window.clearTimeout(this.is_scrolling),
                        void (this.is_scrolling = setTimeout(() => {
                            this.prevent_reveal = !1;
                        }, 20))
                    );
                requestAnimationFrame(this.reveal.bind(this));
            } else e <= this.header_bounds.top && requestAnimationFrame(this.reset.bind(this));
            this.currentScrollTop = e;
        }
    }
    hide() {
        this.header.classList.add("is-header-hide", "p-sticky", "top-0", "zi-4", "header--sticky"),
            (this.cartNotificationPanel.hidden = !0),
            this.closeMenu();
    }
    reveal() {
        this.header.classList.add("top-0", "animate", "zi-4", "p-sticky", "header--sticky"),
            this.header.classList.remove("is-header-hide");
    }
    reset() {
        this.header.classList.remove("is-header-hide", "top-0", "animate", "header--sticky", "p-sticky");
    }
    closeMenu() {
        this.menus = this.header.querySelectorAll("ecx-menu-header");
        for (let e = 0, t = this.menus.length; e < t; e++) this.menus[e].close();
    }
    disconnectedCallback() {
        this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.removeEventListener("scroll", this.onScrollHandle.bind(this));
    }
}
customElements.define("ecx-sticky-header", ECXStickyHeader);
class ECXCartNotificationPanel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.elms = {
                notification_wrapper: this.$(".js-cart-notification-panel-wrapper"),
                notification_container: this.$(".js-cart-notification-panel-container"),
                close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
                sticky_header: ECXHelper.qs("ecx-sticky-header"),
            }),
            (this.dismiss_timeout = null);
        for (let e = 0, t = this.elms.close_buttons.length; e < t; e++)
            this.elms.close_buttons[e].addEventListener("click", this.close.bind(this));
    }
    async open() {
        this.togglePanel(!0),
            await this.animationsComplete(),
            this.elms.notification_container.focus(),
            this.addEventListener("mouseover", this.onMouseOverHandle.bind(this)),
            this.addEventListener("mouseout", this.onMouseOutHandle.bind(this)),
            this.setDismissTimeout(),
            ECXHelper.trapFocus(this);
    }
    async close() {
        this.clearDismissTimeout(),
            this.togglePanel(!1),
            await this.animationsComplete(),
            this.dispatchEvent(new Event("closed")),
            this.element_to_focus
                ? (ECXHelper.removeTrapFocus(this.element_to_focus), (this.element_to_focus = null))
                : ECXHelper.removeTrapFocus();
    }
    animationsComplete() {
        return Promise.allSettled(this.getAnimations().map((e) => e.finished));
    }
    clearDismissTimeout() {
        clearTimeout(this.dismiss_timeout);
    }
    renderContents(s, e = !0, t = null) {
        (this.element_to_focus = t), (this.productId = s.id);
        var i = this.getSectionsToRender();
        for (let e = 0, t = i.length; e < t; e++) {
            var n = ECXHelper.qs(i[e].space_selector);
            n &&
                ("#headerCartStatus" == i[e].space_selector && n.classList.add("header-cart-status--animate"),
                (n.innerHTML = this.getSectionInnerHTML(s.sections[i[e].id], i[e].selector)));
        }
        e && this.open();
    }
    getSectionsToRender() {
        return [
            {
                id: "cart-notification-panel-product",
                selector: ".js-cart-notification-panel-product-" + this.productId,
                space_selector: ".js-cart-notification-panel-content",
            },
            {
                id: "free-shipping-notification",
                selector: ".js-free-shipping-notification",
                space_selector: ".js-cart-notification-free-shipping",
            },
            { id: "header-cart-status", section: "header-cart-status", space_selector: "#headerCartStatus" },
            {
                id: "cart-notification-panel-product",
                selector: ".js-cart-notification-panel-item-count",
                space_selector: ".js-cart-notification-panel-item-count-content",
            },
        ];
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    onMouseOverHandle(e) {
        this.clearDismissTimeout();
    }
    onMouseOutHandle(e) {
        this.setDismissTimeout();
    }
    togglePanel(e) {
        e ? this.toggleAttribute("hidden", !1) : this.setAttribute("hidden", !0);
    }
    setDismissTimeout() {
        (this.dismiss_timeout = setTimeout(
            function () {
                this.close();
            }.bind(this),
            5e3
        )),
            "false" == this.elms.sticky_header.dataset.isEnabled &&
                setTimeout(() => {
                    this.elms.sticky_header.reset();
                }, 6e3);
    }
}
customElements.define("ecx-cart-noti", ECXCartNotificationPanel);
class ECXCarousel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        "false" != this.dataset.enable &&
            ((this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel()));
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML = this.currentPage),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement?.setAttribute("disabled", "disabled")
                : this.prevBtnElement?.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement?.setAttribute("disabled", "disabled")
                : this.nextBtnElement?.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    togglePagination(e) {
        e
            ? this.paginationElement?.classList.remove("d-none-important")
            : this.paginationElement?.classList.add("d-none-important");
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t + 1;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft - 1;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 459px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - s + t * this.itemOffset
                    : this.container.scrollLeft + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        "false" != this.dataset.enable &&
            (new ResizeObserver((e) => this.init()).observe(this.container),
            new IntersectionObserver(
                ((e, t) => {
                    e[0].isIntersecting && (this.init(), t.unobserve(this));
                }).bind(this)
            ).observe(this),
            this.prevBtnElement?.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement?.addEventListener("click", this.onButtonClick.bind(this)),
            this.container?.addEventListener("scroll", ECXHelper.debounce(this.updateCarousel.bind(this), 100)));
    }
}
customElements.define("ecx-carousel", ECXCarousel);
class ECXCarouselTrigger extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
    init() {
        (this.trigger = this.$$(".js-carousel-trigger")),
            (this.carouselWebElement = ECXHelper.qs("#" + this.dataset.carouselTarget)),
            (this.carousel = this.carouselWebElement.querySelector(".js-carousel-items")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        for (let e = 0, t = this.trigger.length; e < t; e++)
            this.trigger[e].addEventListener("click", (e) => {
                this.setActiveCarouselElement(e.currentTarget);
            });
        this.carouselWebElement.addEventListener("itemChanged", (e) => {
            this.setButtonVisibility(!1);
            e = this.$(`[aria-describedby="${e.detail.currentElement.id}"]`);
            e.setAttribute("aria-current", "true"), e.classList.add("hotspot-item--active");
        });
    }
    setActiveCarouselElement(e) {
        e = this.carousel.querySelector("#" + e.getAttribute("aria-describedby", ""));
        e && this.carousel.scrollTo({ left: e.offsetLeft, behavior: "smooth" });
    }
    setButtonVisibility(s) {
        if (this.trigger)
            for (let e = 0, t = this.trigger.length; e < t; e++)
                s
                    ? (this.trigger[e].setAttribute("aria-current", "true"),
                      this.trigger[e].classList.add("hotspot-item--active"))
                    : (this.trigger[e].removeAttribute("aria-current"),
                      this.trigger[e].classList.remove("hotspot-item--active"));
    }
}
customElements.define("ecx-carousel-trig", ECXCarouselTrigger);
class ECXCoreDrawer extends ECXCustomComponent {
    constructor() {
        super(),
            (this.drawerWrapperElement = this.$(".js-drawer-wrapper")),
            (this.drawerOverlayElement = this.$(".js-drawer-overlay")),
            (this.closeBtnElement = this.$(".js-drawer-btn-close")),
            (this.opener = null),
            (this.bodyElement = document.body),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this)),
            this.closeBtnElement.addEventListener("click", this.closeDrawer.bind(this)),
            window.addEventListener("load", () => {
                this.removeAttribute("hidden");
            }),
            this.addEventListener("keyup", (e) => "ESCAPE" === e.code.toUpperCase() && this.closeDrawer()),
            this.drawerAttrObserve();
    }
    drawerAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "open" == e.attributeName &&
                    (this.hasAttribute("open")
                        ? (this.opener?.removeAttribute("disabled"),
                          this.opener?.setAttribute("aria-expanded", "true"),
                          this.setAttribute("aria-hidden", "false"),
                          this.dispatchEvent(new Event("opening")),
                          this.bodyElement.classList.add("o-hidden"),
                          this.classList.add("active"),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("opened")),
                          ECXHelper.trapFocus(this))
                        : (ECXHelper.removeTrapFocus(this.opener),
                          this.setAttribute("aria-hidden", "true"),
                          this.opener?.setAttribute("aria-expanded", "false"),
                          this.opener?.removeAttribute("disabled"),
                          this.dispatchEvent(new Event("closing")),
                          this.bodyElement.classList.remove("o-hidden"),
                          this.classList.remove("active"),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("closed"))));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.drawerWrapperElement.getAnimations().map((e) => e.finished));
    }
    openDrawer(e) {
        ECXHelper.preventStickyHeaderReveal(),
            (this.opener = e),
            this.removeAttribute("hidden"),
            this.toggleAttribute("open", !0);
    }
    closeDrawer() {
        this.toggleAttribute("open", !1);
    }
}
class ECXDrawer extends ECXCoreDrawer {}
customElements.define("ecx-drwr", ECXDrawer);
class ECXDrawerTrigger extends ECXCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-drawer-trigger")),
            (this.drawerElement = ECXHelper.qs("ecx-drwr#" + this.dataset.drawerId)),
            this.triggerBtnElement &&
                this.drawerElement &&
                ((this.mediaElement = this.$(".js-drawer-trigger-media")),
                (this.headingElement = this.$(".js-drawer-trigger-heading")),
                (this.contentElements = this.$$(".js-drawer-trigger-content")),
                (this.footerElement = this.$(".js-drawer-trigger-footer")),
                this.bindEventHandlers());
    }
    bindDataToDrawer() {
        let t = "";
        (this.drawerElement.querySelector(".js-drawer-media").innerHTML = this.mediaElement.innerHTML),
            (this.drawerElement.querySelector(".js-drawer-heading").innerHTML = this.headingElement.innerHTML),
            this.drawerElement
                .querySelector(".js-drawer-wrapper")
                .setAttribute("aria-label", this.headingElement.innerHTML),
            this.contentElements.forEach((e) => {
                t += e.innerHTML;
            }),
            (this.drawerElement.querySelector(".js-drawer-content").innerHTML = t),
            this.footerElement &&
                ((this.drawerElement.querySelector(".js-drawer-footer").innerHTML = this.footerElement.innerHTML),
                this.drawerElement
                    .querySelector(".js-drawer-footer")
                    .querySelectorAll(".js-drawer-trigger-footer-btn")
                    .forEach((e) => {
                        e.classList.add("btn-drawer");
                    }));
    }
    bindEventHandlers() {
        this.triggerBtnElement.addEventListener("click", (e) => {
            setTimeout(() => {
                this.bindDataToDrawer(), this.drawerElement.openDrawer(e.target);
            }, 100);
        });
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
}
customElements.define("ecx-drwr-trg", ECXDrawerTrigger);
class ECXCartDrawer extends ECXCoreDrawer {
    getSectionsToRender() {
        return [{ id: "cart-drawer", section: "cart-drawer", space_selector: "#cartDrawer" }];
    }
}
customElements.define("ecx-cart-drwr", ECXCartDrawer);
class ECXCartDrawerCartNote extends ECXCustomComponent {
    constructor() {
        super(),
            this.addEventListener(
                "change",
                ECXHelper.debounce((e) => {
                    e = JSON.stringify({ note: e.target.value });
                    fetch("" + window.routes.cart_update_url, { ...ECXHelper.fetchConfigJSON, body: e });
                }, 300)
            );
    }
}
customElements.define("ecx-cart-drwr-note", ECXCartDrawerCartNote);
class ECXCartDrawerQuantityInput extends ECXCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-cart-drawer-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.button = this.$$(".js-cart-drawer-quantity-btn"));
        for (let e = 0, t = this.button.length; e < t; e++)
            this.button[e].addEventListener("click", this.onButtonClickHandler.bind(this));
    }
    onButtonClickHandler(e) {
        e.preventDefault();
        var t = this.input.value;
        "plus" === e.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define("ecx-cart-drwr-qty-inp", ECXCartDrawerQuantityInput);
class ECXCartDrawerRemoveButton extends ECXCustomComponent {
    constructor() {
        super(),
           console.log("Remove button initialized");
            this.addEventListener("click", (e) => {
             
                console.log("Remove button clicked");
                e.preventDefault(), this.closest("ecx-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
            });
    }
}
customElements.define("ecx-cart-drwr-rmv-btn", ECXCartDrawerRemoveButton);
class ECXCartDrawerForm extends ECXCustomComponent {
    constructor() {
        super(),
            (this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce(
                (e, t) => e + parseInt(t.value),
                0
            )),
            (this.drawerCartElement = ECXHelper.qs("ecx-cart-drwr")),
            (this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper")),
            (this.cartNotification = ECXHelper.qs("ecx-cart-noti")),
            (this.isProcessingCartUpdate = !1),
            this.addEventListener(
                "change",
                ECXHelper.debounce((e) => {
                    this.onChange(e);
                }, 150)
                
            );
            if (typeof window.freeGift === "function") {
                    // This constructor runs on EVERY drawer re-render, and freeGift's
                    // own cart changes trigger further re-renders. Collapse render
                    // bursts into a single trailing gift sync instead of one per render.
                    clearTimeout(window.__freeGiftKick);
                    window.__freeGiftKick = setTimeout(() => window.freeGift(), 250);
                }
            document.addEventListener("cart:update", this.handleCartUpdate.bind(this));
    }
    onChange(e) {
        this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.dataset.name);
    }
    renderContents(i) {
        this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty"),
            this.getSectionsToRender().forEach((s) => {
                s.selectors?.forEach((e) => {
                    var t = ECXHelper.qid(s.id);
                    t &&
                        i.sections[s.section] &&
                        ((t.querySelector(e) || t).innerHTML = this.getSectionInnerHTML(i.sections[s.section], e));
                });
            });
    }
    handleCartUpdate(e) {
        if (!this.isProcessingCartUpdate) {
            this.isProcessingCartUpdate = !0;
            let i = this.getSectionsToRender().filter((s) => ECXHelper.qid(s.id));
            this.cartNotification && (i = [...i, ...this.cartNotification.getSectionsToRender()]),
                fetch("" + window.routes.cart_url, {
                    ...ECXHelper.fetchConfig,
                    headers: { Accept: "application/json" },
                })
                    .then((e) => e.json())
                    .then((e) => {
                        var t, s;
                        0 === e.item_count
                            ? ((e = ECXHelper.qs(".js-drawer-empty")),
                              (t = ECXHelper.qs(".js-cart-drawer-wrapper")),
                              (s = ECXHelper.qs(".js-cart-count-number")),
                              (t.innerHTML = e.innerHTML),
                              (s.innerHTML = 0))
                            : fetch("?sections=" + i.map((e) => e.section).join(","))
                                  .then((e) => e.text())
                                  .then((e) => {
                                      e = JSON.parse(e);
                                      this.renderContentsDiscount({ sections: e });
                                  })
                                  .catch((e) => {
                                      console.error("Error fetching cart sections:", e);
                                  });
                    })
                    .catch((e) => {
                        console.error("Error fetching cart:", e);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.isProcessingCartUpdate = !1;
                        }, 500);
                    });
        }
    }
    renderContentsDiscount(i) {
        this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty"),
            this.getSectionsToRenderDiscount().forEach((s) => {
                s.selectors?.forEach((e) => {
                    var t = ECXHelper.qid(s.id);
                    // A missing selector used to throw here, aborting the rest of
                    // the partial update and leaving stale totals in the drawer.
                    var n = t && t.querySelector(e);
                    n &&
                        i.sections[s.section] &&
                        (n.innerHTML = this.getSectionInnerHTML(i.sections[s.section], e));
                });
            });
    }
    getSectionsToRenderDiscount() {
        return [
            {
                id: "cartDrawer",
                section: "cart-drawer",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
            {
                id: "mainCart",
                section: "main-cart",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
        ];
    }
    getSectionsToRender() {
        return [
            { id: "cartDrawer", section: "cart-drawer", selectors: [".js-cart-drawer-wrapper"] },
            { id: "mainCart", section: "main-cart", selectors: ["#mainCartContainer"] },
        ];
    }
    updateQuantity(t, e, s) {
        // Only ask the server to render sections that exist on this page —
        // main-cart is absent everywhere except /cart, and rendering it
        // added ~hundreds of ms to every quantity change.
        let i = this.getSectionsToRender().filter((s) => ECXHelper.qid(s.id)),
            n;
        this.cartNotification && (i = [...i, ...this.cartNotification.getSectionsToRender()]);
        e = JSON.stringify({
            line: t,
            quantity: e,
            sections: i.map((e) => e.section),
            sections_url: window.location.pathname,
        });
        this.updateButtonState(!0),
            fetch("" + window.routes.cart_change_url, { ...ECXHelper.fetchConfigJSON, body: e })
                .then((e) => e.text())
                .then((e) => {
                    (n = JSON.parse(e)),
                        console.log(n),
                        n.errors
                            ? setTimeout(() => {
                                  this.updateErrorRegions(t, n.errors);
                              }, 100)
                            : (((this.closest(".js-cart-drawer-wrapper") ||
                                  // The form can be detached mid-flight when a concurrent
                                  // cart:update re-rendered the drawer; fall back to the
                                  // live wrapper instead of crashing and aborting the render.
                                  ECXHelper.qs(".js-cart-drawer-wrapper"))?.classList.toggle("is-empty", 0 === n.item_count)),
                              this.getSectionsToRender().forEach((s) => {
                                  s.selectors.forEach((e) => {
                                      var t = ECXHelper.qid(s.id);
                                      t &&
                                          ((t.querySelector(e) || t).innerHTML = this.getSectionInnerHTML(
                                              n.sections[s.section],
                                              e
                                          ));
                                  });
                              }),
                              (e = ECXHelper.qid("cartDrawerItem-" + t)) &&
                                  (e = e.querySelector(".js-cart-drawer-quantity-btn-" + s)) &&
                                  e.focus(),
                              this.cartNotification &&
                                  this.cartNotification.getSectionsToRender().forEach((e) => {
                                      "header-cart-status" == e.id &&
                                          (ECXHelper.qs(e.space_selector).innerHTML =
                                              this.cartNotification.getSectionInnerHTML(n.sections[e.id], e.selector));
                                  }));
                   
                })
                .catch((e) => {
                    (this.$(".js-cart-drawer-errors").textContent = ECXLanguage.cart.ERROR),
                        console.log(e.message, e.stack);
                })
                .finally(() => {
                    this.updateButtonState(!1);
                    // Kick the free-gift sync directly after every quantity change /
                    // removal instead of relying on the re-render -> constructor
                    // chain, so an ineligible gift can never be left stranded in
                    // the cart (it is a ₹0 catalog product and would be orderable
                    // for free). freeGift is single-flight + idempotent.
                    if (typeof window.freeGift === "function") {
                        clearTimeout(window.__freeGiftKick);
                        window.__freeGiftKick = setTimeout(() => window.freeGift(), 250);
                    }
                });
    }
    updateErrorRegions(e, t) {
        e = ECXHelper.qs("#cart-drawer-line-item-error-" + e);
        (e.querySelector(".js-cart-drawer-form-item-error-message").innerHTML = t),
            e.classList.remove("d-none-important");
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    updateButtonState(e) {
        var s = this.$$(".js-cart-drawer-btn"),
            t = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
        if (e) {
            for (let e = 0, t = s.length; e < t; e++) s[e].setAttribute("disabled", "disabled");
            t && t.setAttribute("disabled", "disabled");
        } else {
            for (let e = 0, t = s.length; e < t; e++) s[e].removeAttribute("disabled", "disabled");
            t && t.removeAttribute("disabled");
        }
    }
}
customElements.define("ecx-cart-drwr-frm", ECXCartDrawerForm);
class ECXMenuDrawer extends ECXCoreDrawer {}
customElements.define("ecx-menu-drwer", ECXMenuDrawer);
class ECXMenuDrawerOpener extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-menu-drawer-trigger")),
            (this.menuDrawerElement = ECXHelper.qs("ecx-menu-drwer")),
            this.triggerBtnElement.addEventListener("click", (e) => {
                this.menuDrawerElement?.openDrawer(e.target);
            });
    }
}
customElements.define("ecx-menu-drwer-opner", ECXMenuDrawerOpener);
class ECXMegaMenuDrawer extends ECXCoreDrawer {
    constructor() {
        super();
    }
}
customElements.define("ecx-mega-menu-drawer", ECXMegaMenuDrawer);
class ECXColorSwatch extends ECXCustomComponent {
    constructor() {
        super(),
            (this.json = null),
            (this.jsonDataElement = ECXHelper.qs('#colorSwatchData[type="application/json"]') || null),
            (this.variantSwatchItems = this.$$(".js-variant-swatch-item") || []),
            this.jsonDataElement && 0 != this.variantSwatchItems.length && this.bindEventHandlers();
    }
    onObserverHandler() {
        new IntersectionObserver((e, t) => {
            e.forEach((e) => {
                e.isIntersecting && (this.init(), t.unobserve(this));
            });
        }).observe(this);
    }
    init() {
        (this.json = JSON.parse(this.jsonDataElement.textContent)), this.processJsonData();
        for (let e = 0, t = this.variantSwatchItems.length; e < t; e++) {
            let i = this.variantSwatchItems[e];
            var s = this.json["" + i.dataset.optionValue];
            let n = "";
            var r,
                o = i.dataset.optionValue,
                a = i.dataset.swatchOptionValue,
                l = (e, t = "", s = "") => {
                    (n = e),
                        (i.style.backgroundColor = t),
                        (i.style.backgroundImage = s ? `url("${s}")` : ""),
                        (i.style.backgroundSize = s ? "cover" : ""),
                        (i.style.backgroundRepeat = s ? "no-repeat" : "");
                };
            void 0 !== s
                ? ((r = ECXHelper.isHexColor(s)), ECXHelper.isImage(s) ? l("image", "", s) : r && l("color", s))
                : ECXHelper.isColor(o) && l("color", o),
                a && ((r = ECXHelper.isHexColor(a)), ECXHelper.isImage(a) ? l("image", "", a) : r && l("color", a)),
                i.style.backgroundImage || i.style.backgroundColor
                    ? (n && i.classList.add("clr-swh__type--" + n), i.classList.add("clr-swh__has-value"))
                    : i.querySelector(".js-variant-option-label")?.classList.remove("opacity-0");
        }
    }
    processJsonData() {
        this.json &&
            (this.json = Object.assign.apply(
                {},
                this.json.color_swatch_name.map((e, t) => ({ [e]: this.json.color_swatch_value[t] }))
            ));
    }
    bindEventHandlers() {
        this.onObserverHandler();
    }
}
class ECXMainProductVariantSwatch extends ECXColorSwatch {}
customElements.define("ecx-prd-variant-swtch", ECXMainProductVariantSwatch);
class ECXMainProductVariantSwatchWSelect extends ECXColorSwatch {}
customElements.define("ecx-prd-variant-swtch-w-select", ECXMainProductVariantSwatchWSelect);
class ECXProductQuickViewVariantSwatch extends ECXColorSwatch {}
customElements.define("ecx-prd-qck-vw-variant-swtch", ECXProductQuickViewVariantSwatch);
class ECXMainCollectionProductVariantSwatch extends ECXColorSwatch {}
customElements.define("ecx-coll-prd-variant-swtch", ECXMainCollectionProductVariantSwatch);
class ECXFeaturedProductVariantSwatch extends ECXColorSwatch {}
customElements.define("ecx-featured-prd-variant-swtch", ECXFeaturedProductVariantSwatch);
class ECXMainSearchVariantSwatch extends ECXColorSwatch {}
customElements.define("ecx-srch-variant-swtch", ECXMainSearchVariantSwatch);
class ECXVariantSwatch extends ECXColorSwatch {
    bindEventHandlers() {
        this.onObserverHandler(),
            this.variantSwatchItems.forEach((e) => {
                e.addEventListener("click", (e) => {
                    this.changeVariantImage(e.currentTarget);
                });
            });
    }
    changeVariantImage(e) {
        var s = ECXHelper.qs("#" + e.dataset.productImageId),
            i = ECXHelper.qsa("." + e.dataset.productLinkClass),
            n = e.querySelector("template");
        if (s && n) {
            this.setButtonVisibility(!1);
            let t = n.content.firstElementChild.cloneNode(!0);
            s.src && (s.src = t.src),
                s.srcset && (n.srcset ? (s.srcset = t.srcset) : (s.srcset = t.src)),
                i &&
                    i.forEach((e) => {
                        e.href = t.getAttribute("data_url");
                    }),
                e.setAttribute("aria-current", "true"),
                e.classList.add("btn-active"),
                e.focus();
        }
    }
    setButtonVisibility(t) {
        this.variantSwatchItems &&
            this.variantSwatchItems.forEach((e) => {
                t
                    ? (e.setAttribute("aria-current", "true"), e.classList.add("btn-active"))
                    : (e.removeAttribute("aria-current"), e.classList.remove("btn-active"));
            });
    }
}
customElements.define("ecx-variant-swtch", ECXVariantSwatch);
class ECXDialogCore extends ECXCustomComponent {
    constructor() {
        super(),
            (this.dialog = this.$(".dialog")),
            (this.closeBtn = this.$$(".js-dialog-close-btn")),
            (this.body = this.$(".js-dialog-body")),
            (this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true"),
            (this.opener = null),
            (this.bodyElement = document.body),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.closeBtn.forEach((e) => {
            e.addEventListener("click", (e) => {
                this.closeModal();
            });
        }),
            this.addEventListener("click", (e) => {
                e.target.nodeName === this.tagName && "true" === this.closeModalOnOverlayClick && this.closeModal();
            }),
            this.addEventListener("keyup", (e) => "ESCAPE" === e.code.toUpperCase() && this.closeModal()),
            this.dialogAttrObserve();
    }
    dialogAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "hidden" == e.attributeName &&
                    (!this.hasAttribute("hidden")
                        ? (this.dispatchEvent(
                              new CustomEvent("opening", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("opened", { detail: { opener: this.opener, dialog: this } })
                          ),
                          ECXHelper.trapFocus(this),
                          this.bodyElement.classList.add("o-hidden"))
                        : (ECXHelper.removeTrapFocus(this.opener),
                          this.dispatchEvent(
                              new CustomEvent("closing", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("closed", { detail: { opener: this.opener, dialog: this } })
                          ),
                          this.bodyElement.classList.remove("o-hidden")));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.dialog.getAnimations({ subtree: !0 }).map((e) => e.finished));
    }
    processBodyContent() {
        var e;
        (this.template = this.$("template")), this.template && ((e = this.template.content), this.body.appendChild(e));
    }
    showModal(e, t = !1) {
        ECXHelper.preventStickyHeaderReveal(),
            t && this.processBodyContent(),
            (this.opener = e),
            this.toggleAttribute("hidden", !1);
    }
    closeModal() {
        this.setAttribute("hidden", !0);
    }
}
class ECXDialog extends ECXDialogCore {
    constructor() {
        super();
    }
}
customElements.define("ecx-dialog", ECXDialog);
class ECXDialogQuickShop extends ECXDialogCore {
    constructor() {
        super();
    }
    showModal(e) {
        ECXHelper.preventStickyHeaderReveal(),
            (this.opener = e),
            this.opener?.setAttribute("disabled", "disabled"),
            this.processData(e);
    }
    processData(e) {
        (this.productElement = null),
            fetch(e.getAttribute("data-product-url"))
                .then((e) => e.text())
                .then((e) => {
                    e = new DOMParser().parseFromString(e, "text/html");
                    (this.productElement = e.querySelector(".section-product-quick-view")),
                        (this.body.innerHTML = this.productElement.innerHTML),
                        this.executeScriptElements(this.body),
                        ECXCustomComponent.waitForPaymentButtons(this.body),
                        window.Shopify?.PaymentButton && Shopify.PaymentButton.init(),
                        this.setupPaymentButtonObserver();
                })
                .finally(() => {
                    this.toggleAttribute("hidden", !1),
                        this.opener?.removeAttribute("disabled"),
                        this.bodyElement.classList.add("o-hidden");
                });
    }
    setupPaymentButtonObserver() {
        requestAnimationFrame(() => {
            var e = this.body.querySelectorAll(".shopify-payment-button");
            if (0 === e.length) {
                let e = new MutationObserver(() => {
                    var e = this.body.querySelectorAll('.shopify-payment-button:not([data-observed="true"])');
                    0 < e.length && this.observePaymentContainers(e);
                });
                e.observe(this.body, { childList: !0, subtree: !0 }), setTimeout(() => e.disconnect(), 3e3);
            } else this.observePaymentContainers(e);
        });
    }
    observePaymentContainers(e) {
        e.forEach((e) => {
            "true" !== e.dataset.observed &&
                (ECXCustomComponent.enhancePaymentButtons(e),
                new MutationObserver(() => ECXCustomComponent.enhancePaymentButtons(e)).observe(e, {
                    childList: !0,
                    subtree: !0,
                }),
                (e.dataset.observed = "true"));
        });
    }
    closeModal() {
        this.setAttribute("hidden", !0),
            this.bodyElement.classList.remove("o-hidden"),
            setTimeout(() => {
                this.body.innerHTML = "";
            }, 300);
    }
    executeScriptElements(e) {
        e = e.querySelectorAll("script");
        Array.from(e).forEach((e) => {
            let t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
                t.setAttribute(e.name, e.value);
            }),
                t.appendChild(document.createTextNode(e.innerHTML)),
                e.parentNode.replaceChild(t, e);
        });
    }
}
customElements.define("ecx-dialog-quickshop", ECXDialogQuickShop),
    document.addEventListener("DOMContentLoaded", function () {
        window.dialogQuickShop = document.getElementById("dialogQuickShop");
    });
class ECXDetailsExposal extends ECXCustomComponent {
    constructor() {
        super(),
            (this.detailsElm = this.$("details")),
            (this.content = this.detailsElm.querySelector("summary").nextElementSibling),
            this.detailsElm.addEventListener("focusout", this.onFocusOutHandler.bind(this)),
            this.detailsElm.addEventListener("toggle", this.onToggleHandler.bind(this));
    }
    onFocusOutHandler() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    onToggleHandler() {
        this.detailsElm.hasAttribute("open")
            ? this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !0)
            : this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !1);
    }
    close() {
        this.detailsElm.removeAttribute("open"),
            this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !1);
    }
}
customElements.define("ecx-dtl-exposal", ECXDetailsExposal);
class ECXShareProductButton extends ECXCustomComponent {
    constructor() {
        super(),
            (this.webShareApiContainer = this.$(".js-web-share-api-container")),
            (this.webShareApiButton = this.$(".js-web-share-api-btn")),
            (this.noneWebShareApiContainer = this.$(".js-none-web-share-api-container")),
            (this.noneWebShareApiButton = this.$(".js-none-web-share-api-btn")),
            (this.copyLinkButton = this.$(".js-social-share-copy-link")),
            this.init();
    }
    init() {
        navigator.share
            ? (this.webShareApiContainer.removeAttribute("hidden"),
              this.noneWebShareApiContainer.setAttribute("hidden", !0),
              this.webShareApiButton.addEventListener("click", () => {
                  navigator
                      .share({ url: this.dataset.productUrl, title: document.title })
                      .then(() => {
                          console.log("Thanks for sharing!");
                      })
                      .catch(console.error);
              }))
            : (this.noneWebShareApiContainer.removeAttribute("hidden"),
              this.webShareApiContainer.setAttribute("hidden", !0),
              this.copyLinkButton.addEventListener("click", (e) => {
                  this.copyToClipboard(e.currentTarget);
              }));
    }
    copyToClipboard(e) {
        navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
            e.querySelector(".js-social-share-copy-link-label").textContent = e.dataset.linkCopiedToClipboard;
        });
    }
}
customElements.define("ecx-share-prd-btn", ECXShareProductButton);
class ECXCollapsibleRegion extends ECXCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.triggers = this.$$(".js-collapsible-region-trigger")),
            (this.contents = this.$$(".js-collapsible-region-content")),
            (this.bodyWidth = document.body.clientWidth),
            (this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop),
            (this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile),
            this.init(),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.isCollapsibleOnDesktop && this.isCollapsibleOnMobile) ||
            window.addEventListener("resize", (e) => {
                (this.bodyWidth = Math.floor(document.body.clientWidth)), this.init();
            }),
            this.triggers.forEach((e) => {
                e.addEventListener("click", (e) => {
                    this.onTriggerClick(e.currentTarget);
                });
            });
    }
    init() {
        ((!this.isCollapsibleOnDesktop && 769 < this.bodyWidth) ||
            (!this.isCollapsibleOnMobile && this.bodyWidth <= 769)) &&
            this.removeAriaProps(),
            ((this.isCollapsibleOnDesktop && 769 < this.bodyWidth) ||
                (this.isCollapsibleOnMobile && this.bodyWidth <= 769)) &&
                this.restoreAriaProps();
    }
    removeAriaProps() {
        this.triggers.forEach((e) => {
            (e.style.pointerEvents = "none"),
                e.setAttribute("tabindex", -1),
                e.removeAttribute("aria-controls"),
                e.removeAttribute("aria-expanded");
        }),
            this.contents.forEach((e) => {
                e.removeAttribute("aria-describedby"), e.removeAttribute("role"), e.removeAttribute("hidden");
            });
    }
    restoreAriaProps() {
        this.triggers.forEach((e) => {
            (e.style.pointerEvents = "auto"),
                e.setAttribute("aria-controls", this.properties.ariaControls),
                e.setAttribute("aria-expanded", "false"),
                e.removeAttribute("tabindex");
        }),
            this.contents.forEach((e) => {
                e.setAttribute("aria-describedby", this.properties.ariaDescribedby),
                    e.setAttribute("role", "region"),
                    e.setAttribute("hidden", "");
            });
    }
    onTriggerClick(e) {
        var t = "true" === e.getAttribute("aria-expanded");
        this.toggle(!t, e);
    }
    toggle(e, t) {
        t.setAttribute("aria-expanded", "" + e);
        var s = this.$("#" + t.getAttribute("aria-controls"));
        e
            ? (t.classList.add("open"), s.removeAttribute("hidden"))
            : (t.classList.remove("open"), s.setAttribute("hidden", ""));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
}
customElements.define("ecx-clps-rgn", ECXCollapsibleRegion);
class ECXQuantityInput extends ECXCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.$$(".js-quantity-btn").forEach((e) =>
                e.addEventListener("click", this.onButtonClickHandler.bind(this))
            );
    }
    onButtonClickHandler(e) {
        e.preventDefault();
        var t = this.input.value;
        "plus" === e.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define("ecx-qty-inp", ECXQuantityInput);
class ECXAccordion extends ECXCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.accordionItems = this.$$(".js-accordion-item")),
            (this.accordionTriggers = this.$$(".js-accordion-trigger")),
            (this.accordionTrigger = this.$(".js-accordion-trigger")),
            (this.accordionContents = this.$$(".js-accordion-content")),
            this.bindEventHandlers();
    }
    connectedCallback() {
        this.properties &&
            this.properties.default_open &&
            (!this.properties.multiple && this.accordionTrigger
                ? this.toggle(!0, this.accordionTrigger)
                : this.accordionTriggers &&
                  this.accordionTriggers.length &&
                  this.accordionTriggers.forEach((e) => this.toggle(!0, e)));
    }
    bindEventHandlers() {
        this.accordionTriggers.forEach((e) => {
            e.addEventListener("click", (e) => {
                e.preventDefault(), this.onTriggerClick(e.currentTarget);
            });
        });
    }
    onTriggerClick(e) {
        var t = "true" === e.getAttribute("aria-expanded");
        this.properties.multiple || this.toggleAll(), this.toggle(!t, e);
    }
    toggle(e, t) {
        t.setAttribute("aria-expanded", "" + e), e ? t.classList.add("open") : t.classList.remove("open");
        t = this.$("#" + t.getAttribute("aria-controls"));
        e
            ? (t.classList.add("open"), (t.style.maxHeight = this.calculateMaxHeightContent(t) + "px"))
            : (t.classList.remove("open"), (t.style.maxHeight = "0px"));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
    toggleAll() {
        this.accordionTriggers.forEach((e) => {
            e.setAttribute("aria-expanded", "false"), e.classList.remove("open");
        }),
            this.accordionContents.forEach((e) => {
                e.classList.remove("open"), (e.style.maxHeight = "0px");
            });
    }
    calculateMaxHeightContent(e) {
        return e.scrollHeight;
    }
}
customElements.define("ecx-accordion", ECXAccordion);
class ECXLazyLoadingVideo extends ECXCustomComponent {
    constructor() {
        super(), (this.video = this.$("iframe")), (this.isLoaded = !1), (this.isPlaying = !1), this.addObserver();
    }
    loadVideo() {
        var e;
        this.video &&
            !this.isLoaded &&
            (this.video.setAttribute("src", this.video.getAttribute("data-src")),
            (this.isLoaded = !0),
            this.video.addEventListener("load", () => {
                this.dispatchEvent(new CustomEvent("loadingEnd", { detail: { ele: this.video, parent: this } }));
            })),
            "local_video" != this.dataVideoType ||
                this.isLoaded ||
                ((this.local_video = this.$("video")),
                this.local_video &&
                    ((e = this.local_video.querySelector("source").getAttribute("data-src")),
                    (this.local_video.src = e)),
                (this.isLoaded = !0));
    }
    playVideo() {
        !this.isPlaying &&
            this.isLoaded &&
            ("youtube" == this.dataVideoType
                ? this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
                : "vimeo" == this.dataVideoType
                  ? this.video.contentWindow.postMessage('{"method":"play"}', "*")
                  : "local_video" == this.dataVideoType && this.local_video?.play(),
            (this.isPlaying = !0));
    }
    execute() {
        this.addObserver();
    }
    addObserver() {
        new IntersectionObserver(
            (e) => {
                e.forEach((e) => {
                    e.isIntersecting
                        ? (this.loadVideo(), this.playVideo())
                        : (this.pauseVideo(), (this.isPlaying = !1));
                });
            },
            { rootMargin: "0px 0px 200px 0px" }
        ).observe(this);
    }
    pauseVideo() {
        this.isPlaying &&
            (this.$(".js-media-item-youtube")?.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
            ),
            this.$(".js-media-item-vimeo")?.contentWindow.postMessage('{"method":"pause"}', "*"),
            this.$(".js-media-item-video")?.pause(),
            (this.isPlaying = !1));
    }
    static get observedAttributes() {
        return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(e) {
        this.setAttribute("data-video-type", e);
    }
    get dataVideoType() {
        return this.getAttribute("data-video-type");
    }
    set dataVideoId(e) {
        this.setAttribute("data-video-id", e);
    }
    get dataVideoId() {
        return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(e, t, s) {
        t !== s && this.execute();
    }
    connectedCallback() {
        this.execute();
    }
    disconnectedCallback() {}
}
customElements.define("ecx-load-video", ECXLazyLoadingVideo);
class ECXTabs extends ECXCustomComponent {
    constructor() {
        super(),
            (this.tabLinks = this.$$(".js-tab-link")),
            (this.tabPanels = this.$$(".js-tab-panel")),
            (this.tabHeader = this.$(".js-mega-menu-drawer-tabs-header")),
            (this.tabHeaderWrap = this.$(".js-drawer-tabs-header")),
            (this.isRTL = ECXHelper.isRTL),
            this.bindEventHandlers(),
            this.initializeDragToSlide(),
            this.initializeOnLoad();
    }
    initializeOnLoad() {
        var e, t;
        this.tabLinks &&
            0 < this.tabLinks.length &&
            (e = this.$(".js-tab-link.tab__link--active") || this.tabLinks[0]) &&
            ((t = e.getAttribute("href")) && t.includes("#") && this.tabLinkEventHandler(e),
            this.tabPanelMegaMenuPromotionEventHandler(e)),
            this.updateHeaderMasks();
    }
    bindEventHandlers() {
        this.tabLinks?.forEach((s) => {
            s.addEventListener("click", (e) => {
                var t;
                this.dragBlockUntil && Date.now() < this.dragBlockUntil
                    ? e.preventDefault()
                    : ((t = s.getAttribute("href")),
                      this.classList.contains("js-mega-menu-drawer-tabs") && this.tabHeader && this.revealInHeader(s),
                      t && t.includes("#")
                          ? (e.preventDefault(),
                            this.tabLinkEventHandler(s),
                            this.tabPanelMegaMenuPromotionEventHandler(s))
                          : this.classList.contains("js-mega-menu-drawer-tabs") &&
                            this.tabHeader &&
                            (this.isElementFullyVisibleInContainer(s, this.tabHeader) ||
                                (e.preventDefault(),
                                this.scrollTabHeaderTo(s).then(() => {
                                    try {
                                        s.focus({ preventScroll: !0 });
                                    } catch (e) {}
                                    var e = s.getAttribute("href"),
                                        t = s.getAttribute("target");
                                    e &&
                                        !e.includes("#") &&
                                        ("_blank" === t ? window.open(e, "_blank") : (window.location.href = e));
                                }))));
            });
        }),
            this.tabHeader &&
                (this.tabHeader.addEventListener("scroll", () => this.updateHeaderMasks(), { passive: !0 }),
                window.addEventListener("resize", () => this.updateHeaderMasks()),
                setTimeout(() => this.updateHeaderMasks(), 0));
    }
    initializeDragToSlide() {
        this.tabHeader &&
            ((this.isPointerDown = !1),
            (this.isDragging = !1),
            (this.hasMoved = !1),
            (this.dragPointerType = "mouse"),
            (this.dragBlockUntil = 0),
            (this.dragStartX = 0),
            (this.dragStartScrollLeft = 0),
            (this.dragThreshold = 10),
            (this.onDragStart = (e) => {
                ("mouse" === e.pointerType && 0 !== e.button) ||
                    ((this.isPointerDown = !0),
                    (this.isDragging = !1),
                    (this.hasMoved = !1),
                    (this.dragPointerType = e.pointerType || "mouse"),
                    (this.dragStartX = e.clientX),
                    (this.dragStartScrollLeft = this.tabHeader.scrollLeft),
                    "mouse" === this.dragPointerType &&
                        ((this.tabHeader.style.cursor = "grabbing"), (this.tabHeader.style.userSelect = "none")));
            }),
            (this.onDragMove = (e) => {
                if (this.isPointerDown) {
                    var t = e.clientX - this.dragStartX;
                    if (
                        Math.abs(t) > this.dragThreshold &&
                        ((this.hasMoved = !0), "mouse" === this.dragPointerType) &&
                        !this.isDragging
                    ) {
                        this.isDragging = !0;
                        try {
                            this.tabHeader.setPointerCapture(e.pointerId);
                        } catch (e) {}
                        this.tabHeader.classList.add("is-dragging");
                    }
                    if ("mouse" === this.dragPointerType && this.isDragging) {
                        try {
                            e.preventDefault();
                        } catch (e) {}
                        this.tabHeader.scrollLeft = this.dragStartScrollLeft + -t;
                    }
                }
            }),
            (this.onDragEnd = (e) => {
                if (this.isPointerDown) {
                    if ("mouse" === this.dragPointerType && this.isDragging) {
                        try {
                            this.tabHeader.releasePointerCapture(e.pointerId);
                        } catch (e) {}
                        this.tabHeader.classList.remove("is-dragging"),
                            (this.tabHeader.style.cursor = ""),
                            (this.tabHeader.style.userSelect = "");
                    }
                    this.hasMoved && (this.dragBlockUntil = Date.now() + 200),
                        (this.isPointerDown = !1),
                        (this.isDragging = !1),
                        this.updateHeaderMasks();
                }
            }),
            this.tabHeader.addEventListener("pointerdown", this.onDragStart),
            this.tabHeader.addEventListener("pointermove", this.onDragMove),
            this.tabHeader.addEventListener("pointerup", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("pointercancel", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("pointerleave", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("dragstart", (e) => {
                try {
                    e.preventDefault();
                } catch (e) {}
            }));
    }
    isElementFullyVisibleInContainer(e, t) {
        return (
            !e ||
            !t ||
            ((e = e.getBoundingClientRect()), (t = t.getBoundingClientRect()), e.left >= t.left && e.right <= t.right)
        );
    }
    scrollTabHeaderTo(e) {
        if (!this.tabHeader || !e) return Promise.resolve();
        let r = this.tabHeader,
            o;
        var t, s, i, n;
        return (
            (o = this.isRTL
                ? ((t = r.scrollWidth),
                  (s = r.clientWidth),
                  (i = e.getBoundingClientRect()),
                  (n = r.getBoundingClientRect()),
                  (i = i.left - n.left + e.clientWidth / 2),
                  (n = r.clientWidth / 2),
                  (o = r.scrollLeft + (i - n)),
                  (i = "scrollLeftMax" in r ? -r.scrollLeftMax : -(t - s)),
                  Math.max(i, Math.min(0, o)))
                : ((o = Math.max(0, e.offsetLeft - (r.clientWidth - e.clientWidth) / 2)),
                  (n = r.scrollWidth - r.clientWidth),
                  Math.min(o, n))),
            new Promise((s) => {
                let i = Date.now(),
                    n = () => {
                        var e = Math.abs(r.scrollLeft - o) < 2,
                            t = 700 < Date.now() - i;
                        e || t ? s() : requestAnimationFrame(n);
                    };
                requestAnimationFrame(n), r.scrollTo({ left: o, behavior: "smooth" });
            })
        );
    }
    revealInHeader(e) {
        this.tabHeader &&
            e &&
            (this.isElementFullyVisibleInContainer(e, this.tabHeader) || this.scrollTabHeaderTo(e),
            this.updateHeaderMasks());
    }
    updateHeaderMasks() {
        if (this.tabHeader && this.tabHeaderWrap) {
            let e, t;
            var s = this.tabHeader.scrollLeft,
                i = this.tabHeader.scrollWidth,
                n = this.tabHeader.clientWidth,
                r = i - n;
            (t = this.isRTL
                ? ((e =
                      "scrollLeftMax" in this.tabHeader
                          ? Math.abs(s) >= Math.abs(this.tabHeader.scrollLeftMax) - 1
                          : Math.abs(s) >= r - 1),
                  -1 <= s)
                : ((e = Math.floor(s) <= 0), Math.ceil(s + n) >= i - 1)),
                this.tabHeaderWrap.classList.toggle("is-at-start", e),
                this.tabHeaderWrap.classList.toggle("is-at-end", t);
        }
    }
    tabPanelMegaMenuPromotionEventHandler(e) {
        if (this.classList.contains("js-mega-menu-drawer-tabs")) {
            var s = e.getAttribute("href")?.replace("#", ""),
                s = this.$(`[data-tab-content-id="${s}"]`),
                i = this.closest(".js-drawer-wrapper");
            if (s && i) {
                "true" === s.getAttribute("data-mega-menu-promotion")
                    ? i.classList.add("have-promo")
                    : i.classList.remove("have-promo");
                let t = () => {
                    this.tabHeader && this.revealInHeader(e);
                };
                try {
                    requestAnimationFrame(() => requestAnimationFrame(t));
                } catch (e) {
                    setTimeout(t, 0);
                }
                try {
                    i.addEventListener(
                        "transitionend",
                        (e) => {
                            ("width" !== e.propertyName &&
                                "flex-basis" !== e.propertyName &&
                                "max-width" !== e.propertyName) ||
                                t();
                        },
                        { once: !0 }
                    );
                } catch (e) {}
            }
        }
    }
    tabLinkEventHandler(e) {
        var t = e.getAttribute("href"),
            t = t && t.startsWith("#") ? t.slice(1) : t,
            t =
                (this.tabPanels?.forEach((e) => {
                    e.classList.remove("d-block", "tab__panel--active"), e.classList.add("d-none");
                }),
                this.tabLinks.forEach((e) => {
                    e.classList.remove("tab__link--active");
                }),
                this.$(`[data-tab-content-id="${t}"]`));
        t && (t.classList.remove("d-none"), t.classList.add("d-block", "tab__panel--active")),
            e.classList.add("tab__link--active");
    }
}
customElements.define("ecx-tabs", ECXTabs);
class ECXLoadMedia extends ECXCustomComponent {
    constructor() {
        super(),
            (this.trigger = this.$(".js-load-media-trigger")),
            this.trigger.addEventListener("click", (e) => this.loadMedia());
    }
    loadMedia(s = !0, i = !0) {
        if ((this.pauseAllVideo(), !this.getAttribute("loaded"))) {
            let e = document.createElement("div");
            (e.className = "p-absolute center-middle"),
                (e.innerHTML =
                    '<span class="btn btn-secondary btn-large btn-icon"><svg class="icon-spinner" style="animation: spin 1s linear infinite;" width="20" height="20" viewBox="0 0 20 20"><path d="M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" fill="currentColor"/></svg></span>'),
                document.getElementById("ecx-video-loader-styles") ||
                    (((n = document.createElement("style")).id = "ecx-video-loader-styles"),
                    (n.textContent =
                        "@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }"),
                    document.head.appendChild(n));
            var n = this.trigger.querySelector(".js-btn-play"),
                n = (n && (n.classList.add("opacity-0"), this.trigger.appendChild(e)), document.createElement("div"));
            n.appendChild(this.$("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            let t = n.querySelector("video, iframe");
            (this.trigger.style.transition = "opacity 0.3s ease-out"),
                t.classList.add("p-absolute", "inset", "opacity-0"),
                (t.style.transition = "opacity 0.3s ease-in"),
                this.appendChild(t),
                "VIDEO" === t.tagName
                    ? (t.addEventListener("loadeddata", () => {
                          this.onMediaReady(t, s, i, e);
                      }),
                      t.load())
                    : "IFRAME" === t.tagName &&
                      t.addEventListener("load", () => {
                          setTimeout(() => {
                              this.onMediaReady(t, s, i, e);
                          }, 500);
                      });
        }
    }
    onMediaReady(e, t, s, i) {
        i && i.parentNode && i.remove(),
            (e.style.opacity = "1"),
            s &&
                ((this.trigger.style.opacity = "0"),
                setTimeout(() => {
                    this.trigger.classList.replace("d-block", "d-none"), (e.style.position = "relative");
                }, 300)),
            t && e.focus();
    }
    pauseAllVideo() {
        ECXHelper.qsa(".js-media-item-youtube").forEach((e) => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }),
            ECXHelper.qsa(".js-media-item-vimeo").forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            }),
            ECXHelper.qsa(".js-media-item-video").forEach((e) => e.pause());
    }
}
customElements.define("ecx-load-media", ECXLoadMedia);
class ECXAnnouncementBar extends ECXCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.items = this.$$(".js-anmb-item")),
            (this.container = this.$(".js-anmb-items")),
            (this.linkItems = this.$$(".js-anmb-link-items")),
            (this.totalItems = this.items.length),
            (this.previousButton = this.$(".js-anmb-control-prev")),
            (this.nextButton = this.$(".js-anmb-control-next")),
            (this.props = JSON.parse(this.dataset.props)),
            (this.delayTime = this.props.duration),
            (this.interval = null),
            (this.currentItemIndex = 1),
            (this.lastScrollTimeout = null),
            (this.messages = this.container.children),
            (this.isScrolling = !1),
            (this.isRTL = ECXHelper.isRTL),
            this.bindEventHandlers(),
            this.updateSort(),
            this.autoPlay();
    }
    connectedCallback() {
        this.init();
    }
    updateSort() {
        var e, t, s, i;
        this.totalItems <= 1 ||
            ((this.isScrolling = !0),
            (e = this.container.scrollLeft),
            (t = Math.round(e)),
            (s = this.container.offsetWidth),
            (i = this.container.scrollWidth),
            this.isRTL
                ? (Math.abs(t) < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = t - s)),
                  Math.floor(i + e) <= s &&
                      (this.container.append(this.messages[0]), (this.container.scrollLeft = t + s)))
                : (t < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = t + s)),
                  Math.floor(i - e) <= s &&
                      (this.container.append(this.messages[0]), (this.container.scrollLeft = t - s))),
            (this.isScrolling = !1));
    }
    onScrollEventHandle(e) {
        this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            ));
    }
    bindEventHandlers() {
        this.previousButton.addEventListener(
            "click",
            ECXHelper.debounce(this.onPrevButtonClickHandler.bind(this), 300)
        ),
            this.nextButton.addEventListener(
                "click",
                ECXHelper.debounce(this.onNextButtonClickHandler.bind(this), 300)
            ),
            this.onObserverHandler(),
            this.container.addEventListener("scroll", ECXHelper.debounce(this.onScrollEventHandle.bind(this), 100)),
            this.container.addEventListener(
                "wheel",
                function (e) {
                    ECXHelper.debounce(this.resetAutoPlay.bind(this), 0);
                }.bind(this),
                { passive: !0 }
            );
    }
    onPrevButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let e;
            this.isRTL
                ? ((e = this.currentItemIndex + 1), this.currentItemIndex == this.totalItems && (e = 1))
                : ((e = this.currentItemIndex - 1), 1 == this.currentItemIndex && (e = this.totalItems));
            var t = this.$(`div[data-item-index="${e}"]`);
            this.container.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
        }
    }
    onNextButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let e;
            this.isRTL
                ? ((e = this.currentItemIndex - 1), 1 == this.currentItemIndex && (e = this.totalItems))
                : ((e = this.currentItemIndex + 1), this.currentItemIndex == this.totalItems && (e = 1));
            var t = this.$(`div[data-item-index="${e}"]`);
            this.container.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
        }
    }
    onMouseOverHandle(e) {
        this.clearDismissInterval();
    }
    onMouseOutHandle(e) {
        this.setDismissInterval();
    }
    clearDismissInterval() {
        this.interval && clearInterval(this.interval);
    }
    setDismissInterval() {
        this.interval = setInterval(
            function () {
                this.isRTL ? this.onPrevButtonClickHandler() : this.onNextButtonClickHandler();
            }.bind(this),
            this.delayTime
        );
    }
    resetAutoPlay() {
        !this.props.autoPlay ||
            this.totalItems < 2 ||
            (this.clearDismissInterval(),
            setTimeout(() => {
                this.setDismissInterval();
            }));
    }
    autoPlay() {
        !this.props.autoPlay || this.totalItems < 2
            ? (this.clearDismissInterval(), this.container.setAttribute("aria-live", "polite"))
            : (this.container.addEventListener("mouseover", this.onMouseOverHandle.bind(this)),
              this.container.addEventListener("mouseout", this.onMouseOutHandle.bind(this)),
              this.container.setAttribute("aria-live", "off"),
              this.setDismissInterval());
    }
    onObserverHandler() {
        let t = new IntersectionObserver(
            (e, t) => {
                e.forEach((t) => {
                    if (t.isIntersecting) {
                        let e = t.target;
                        this.linkItems.forEach((e) => {
                            e.setAttribute("tabindex", "-1");
                        }),
                            window.requestAnimationFrame(() => {
                                var e = this.$(".anmb-item--active");
                                e && (e.classList.remove("anmb-item--active"), e.setAttribute("aria-hidden", "true"));
                            }),
                            (this.currentItemIndex = parseInt(e.dataset.itemIndex)),
                            e.setAttribute("aria-hidden", "false"),
                            window.requestAnimationFrame(() => e.classList.add("anmb-item--active"));
                        t = e.querySelector(".js-anmb-link-items");
                        t && t.removeAttribute("tabindex");
                    }
                });
            },
            { root: this.container, rootMargin: "0px", threshold: 0.5 }
        );
        this.items.forEach((e) => {
            t.observe(e);
        });
    }
}
customElements.define("ecx-ann-bar", ECXAnnouncementBar);
class ECXPopup extends ECXCustomComponent {
    constructor() {
        super(),
            (this.properties = JSON.parse(this.dataset.props)),
            (this.myStorage = window.sessionStorage),
            (this.sessionStorageName = Shopify.theme.name.toLowerCase() + "-popup-display"),
            (this.cartNotification = ECXHelper.qs("ecx-cart-noti")),
            (this.isOpen = !1),
            (this.buffer = 100),
            (this.myScrollHeight = document.body.scrollHeight || ECXHelper.qde.scrollHeight || 0),
            (this.myWindowHeight = window.innerHeight || ECXHelper.qde.clientHeight || 0),
            (this.elms = { close_btn: this.$(".js-popup-close-btn"), body: ECXHelper.qs("body") }),
            (this.triggerOn = this.properties.triggerOn),
            (this.scrollEventHandle = this.onScrollEventHandle.bind(this)),
            (this.onLoadUserAction = this.onUserAction.bind(this)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.elms.close_btn.addEventListener("click", this.onCloseBtnClickHandle.bind(this)),
            window.addEventListener("scroll", this.scrollEventHandle),
            this.cartNotification &&
                "after-closing-cart-notification" === this.triggerOn &&
                this.cartNotification.addEventListener("closed", (e) => {
                    this.getPopupStatus() || this.togglePopup(!0);
                }),
            ["mouseover"].forEach(
                function (e) {
                    ECXHelper.qs("body").addEventListener(e, this.onLoadUserAction);
                }.bind(this)
            ),
            this.popupAttrObserve();
    }
    onUserAction(e) {
        this.classList.contains("d-none") && this.classList.remove("d-none"),
            e.currentTarget.removeEventListener(e.type, this.onLoadUserAction);
    }
    onScrollEventHandle(e) {
        var t, s;
        "reaching-to-footer" !== this.triggerOn
            ? window.removeEventListener("scroll", this.scrollEventHandle)
            : ((this.myScrollHeight = document.body.scrollHeight || ECXHelper.qde.scrollHeight || 0),
              (t =
                  (window.pageYOffset || ECXHelper.qde.scrollTop || document.body.scrollTop || 0) +
                      this.buffer +
                      this.myWindowHeight >=
                  this.myScrollHeight),
              (s = this.getPopupStatus()),
              "reaching-to-footer" !== this.triggerOn ||
                  !t ||
                  (null !== this.getAttribute("open") && "" !== this.getAttribute("open")) ||
                  s ||
                  this.togglePopup(!0));
    }
    togglePopup(e) {
        var t = this.$(".js-success");
        e && !t ? this.toggleOpen(!0) : (this.toggleOpen(!1), this.setPopupStatus());
    }
    toggleOpen(e) {
        e
            ? (this.elms.body.classList.add("is-popup-show"), this.setAttribute("open", !0))
            : (this.elms.body.classList.remove("is-popup-show"),
              this.removeAttribute("open"),
              ECXHelper.removeTrapFocus());
    }
    onCloseBtnClickHandle(e) {
        e.preventDefault(), this.togglePopup(!1);
    }
    setPopupStatus() {
        this.myStorage.setItem(this.sessionStorageName, !1);
    }
    getPopupStatus() {
        return Shopify.designMode ? "" : this.myStorage.getItem(this.sessionStorageName);
    }
    popupAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "open" == e.attributeName &&
                    (this.hasAttribute("open")
                        ? (await this.animationsComplete(),
                          this.dispatchEvent(new Event("opened")),
                          ECXHelper.trapFocus(this))
                        : (ECXHelper.removeTrapFocus(),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("closed"))));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.getAnimations().map((e) => e.finished));
    }
}
customElements.define("ecx-popup", ECXPopup);
class ECXSlideShow extends ECXCustomComponent {
    constructor() {
        super(),
            (this.slideshow = this.$(".js-slideshow")),
            (this.slideshowItems = this.$(".js-slideshow-items")),
            (this.totalElm = this.$(".js-slideshow-total")),
            (this.currentElm = this.$(".js-slideshow-current")),
            (this.separatorElm = this.$(".js-slideshow-separator")),
            (this.prevBtn = this.$(".js-slideshow-prev-btn")),
            (this.nextBtn = this.$(".js-slideshow-next-btn")),
            (this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn")),
            (this.imageItems = this.$$(".js-slideshow-image")),
            (this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon")),
            (this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon")),
            (this.properties = JSON.parse(this.dataset.slideshowProperties)),
            (this.autoplay = this.properties.autoplay || !1),
            (this.image = null),
            (this.template = null),
            (this.current = 1),
            (this.anchors = []),
            (this.lastScrollTimeout = null),
            (this.autoplayInterval = null),
            (this.images = this.slideshowItems.children),
            (this.total = this.images.length),
            (this.slideshowItems.scrollLeft = 0),
            (this.observer = null),
            (this.isPaused = !1),
            (this.isRTL = ECXHelper.isRTL),
            (this.isDragging = !1),
            (this.dragStartX = 0),
            (this.dragCurrentX = 0),
            (this.dragStartScrollLeft = 0),
            (this.dragThreshold = 10),
            (this.totalDragDistance = 0),
            (this.dragStartTime = 0),
            (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            (this.draggedLinks = new Set());
    }
    cloneSlideItem() {
        var e, t;
        2 == this.total &&
            ((e = this.slideshowItems.querySelector(".js-slideshow-item:first-of-type")),
            (t = this.slideshowItems.querySelector(".js-slideshow-item:last-of-type")) &&
                ((t = t.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(t)),
            e) &&
            ((t = e.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(t));
    }
    execute() {
        this.total <= 1 ||
            (this.cloneSlideItem(), this.prepare(), this.bindEventHandlers(), this.initDragToSlide(), this.init());
    }
    connectedCallback() {
        this.execute();
    }
    init() {
        this.autoplay && (this.resumeAutoPlay(), (this.isPaused = !0)), this.updateSort();
    }
    updateSort() {
        var e, t, s, i;
        this.total <= 1 ||
            ((e = this.slideshowItems.scrollLeft),
            (t = Math.round(e)),
            (s = this.slideshowItems.offsetWidth),
            (i = this.slideshowItems.scrollWidth),
            this.isRTL
                ? (Math.abs(t) < s &&
                      (this.slideshowItems.prepend(this.images[this.total - 1]),
                      (this.slideshowItems.scrollLeft = t - s)),
                  Math.floor(i + e) <= s &&
                      (this.slideshowItems.append(this.images[0]), (this.slideshowItems.scrollLeft = t + s)))
                : (t < s &&
                      (this.slideshowItems.prepend(this.images[this.total - 1]),
                      (this.slideshowItems.scrollLeft = t + s)),
                  Math.floor(i - e) <= s &&
                      (this.slideshowItems.append(this.images[0]), (this.slideshowItems.scrollLeft = t - s))));
    }
    initDragToSlide() {
        this.total <= 1 ||
            (this.updateDesktopDetection(),
            window.addEventListener("resize", () => {
                this.updateDesktopDetection();
            }),
            this.isDesktop && this.bindDragEventHandlers());
    }
    updateDesktopDetection() {
        var e = this.isDesktop;
        (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            e && !this.isDesktop
                ? (this.cleanupLinkPrevention(), this.slideshowItems.classList.remove("slideshow--dragging"))
                : !e && this.isDesktop && this.bindDragEventHandlers();
    }
    bindDragEventHandlers() {
        this.slideshowItems.addEventListener("mousedown", this.onDragStart.bind(this)),
            document.addEventListener("mousemove", this.onDragMove.bind(this)),
            document.addEventListener("mouseup", this.onDragEnd.bind(this)),
            this.slideshowItems.addEventListener("mouseleave", this.onDragCancel.bind(this)),
            this.slideshowItems.addEventListener("dragstart", (e) => e.preventDefault());
    }
    onDragStart(e) {
        this.isDesktop &&
            0 === e.button &&
            ((this.isDragging = !0),
            (this.dragStartX = e.clientX),
            (this.dragCurrentX = e.clientX),
            (this.dragStartScrollLeft = this.slideshowItems.scrollLeft),
            (this.totalDragDistance = 0),
            (this.dragStartTime = Date.now()),
            this.autoplay && this.stopAutoPlay(),
            this.slideshowItems.classList.add("slideshow--dragging"),
            (document.body.style.userSelect = "none"),
            e.preventDefault());
    }
    onDragMove(t) {
        if (this.isDragging) {
            this.dragCurrentX = t.clientX;
            let e;
            (e = this.isRTL ? this.dragCurrentX - this.dragStartX : this.dragStartX - this.dragCurrentX),
                (this.totalDragDistance = Math.abs(e)),
                this.totalDragDistance > this.dragThreshold && this.preventLinksInCurrentSlide();
        }
    }
    onDragEnd(e) {
        if (this.isDragging) {
            this.isDragging = !1;
            let e;
            e = this.isRTL ? this.dragCurrentX - this.dragStartX : this.dragStartX - this.dragCurrentX;
            var t = this.slideshowItems.offsetWidth,
                t = Math.abs(e) / t,
                s = Date.now() - this.dragStartTime,
                s = this.totalDragDistance / s,
                t =
                    (this.slideshowItems.classList.remove("slideshow--dragging"),
                    (document.body.style.userSelect = ""),
                    0.1 < t || (0.3 < s && 30 < this.totalDragDistance));
            t && this.totalDragDistance > this.dragThreshold && this.performSlideTransition(0 < e ? "next" : "prev"),
                setTimeout(() => {
                    this.cleanupLinkPrevention();
                }, 500);
        }
    }
    performSlideTransition(t) {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft =
                      "next" === t
                          ? this.slideshowItems.scrollLeft - this.slideshow.scrollWidth
                          : this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft =
                      "next" === t
                          ? this.slideshowItems.scrollLeft + this.slideshow.scrollWidth
                          : this.slideshowItems.scrollLeft - this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e &&
                (e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft =
                              "next" === t
                                  ? this.slideshowItems.scrollLeft - this.slideshow.scrollWidth
                                  : this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              "next" === t
                                  ? this.slideshowItems.scrollLeft + this.slideshow.scrollWidth
                                  : this.slideshowItems.scrollLeft - this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400));
        }
    }
    onDragCancel() {
        this.isDragging &&
            ((this.isDragging = !1),
            this.slideshowItems.classList.remove("slideshow--dragging"),
            (document.body.style.userSelect = ""),
            setTimeout(() => {
                this.cleanupLinkPrevention();
            }, 100));
    }
    preventLinksInCurrentSlide() {
        var e = this.getCurrentSlide();
        e &&
            e.querySelectorAll(".js-slideshow-link").forEach((e) => {
                this.draggedLinks.has(e) ||
                    (e.addEventListener("click", this.preventLinkClick, !0), this.draggedLinks.add(e));
            });
    }
    preventLinkClick(e) {
        e.preventDefault(), e.stopPropagation();
    }
    cleanupLinkPrevention() {
        this.draggedLinks.forEach((e) => {
            e.removeEventListener("click", this.preventLinkClick, !0);
        }),
            this.draggedLinks.clear();
    }
    getCurrentSlide() {
        return this.querySelector(".js-slideshow-image--current")?.closest(".js-slideshow-item");
    }
    startAutoPlay() {
        this.autoplay &&
            (this.autoplayInterval = setInterval(
                function () {
                    this.nextSlide();
                }.bind(this),
                this.properties.duration
            ));
    }
    bindEventHandlers() {
        this.slideshowItems.addEventListener(
            "wheel",
            function (e) {
                5 == Math.abs(e.deltaX) && this.stopAutoPlay();
            }.bind(this),
            { passive: !0 }
        ),
            this.slideshowItems.addEventListener(
                "scroll",
                ECXHelper.debounce(this.onScrollEventHandle.bind(this), 100)
            ),
            this.nextBtn.addEventListener(
                "click",
                function () {
                    this.nextSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.prevBtn.addEventListener(
                "click",
                function () {
                    this.prevSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
    }
    onStartNStopEventHandle(e) {
        e.preventDefault(), this.autoplay ? this.stopAutoPlay() : this.resumeAutoPlay();
    }
    stopAutoPlay() {
        clearInterval(this.autoplayInterval),
            this.pauseIcon.classList.add("d-none"),
            this.playIcon.classList.remove("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
            this.slideshowItems.setAttribute("aria-live", "polite"),
            (this.autoplay = !1);
    }
    resumeAutoPlay() {
        (this.autoplay = !0),
            this.pauseIcon.classList.remove("d-none"),
            this.playIcon.classList.add("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]),
            this.slideshowItems.setAttribute("aria-live", "off"),
            this.startAutoPlay();
    }
    onScrollEventHandle(e) {
        e.preventDefault(),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            )),
            this.updateCurrent();
    }
    prepare() {
        (this.totalElm.textContent = this.total),
            (this.currentElm.textContent = this.current),
            (this.separatorElm.textContent = this.properties.separatorText),
            this.autoplay &&
                (this.startNStopBtn.toggleAttribute("hidden", !1),
                this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none"),
                this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
                this.slideshowItems.setAttribute("aria-live", "off"));
    }
    updateCurrent() {
        var e = this.$(".js-slideshow-image--current");
        e && (this.current = e.dataset.slideshowIndex), (this.currentElm.textContent = this.current);
    }
    prevSlide() {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e && e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              this.slideshowItems.scrollLeft - this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400);
        }
    }
    nextSlide() {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e && e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              this.slideshowItems.scrollLeft + this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400);
        }
    }
    observerSlideShow() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting && (this.dataset.viewport = 1), this.observer.unobserve(this);
                });
            },
            { threshold: 0.15 }
        )),
            this.observer.observe(this);
    }
    disconnectedCallback() {
        this.isDesktop &&
            (document.removeEventListener("mousemove", this.onDragMove.bind(this)),
            document.removeEventListener("mouseup", this.onDragEnd.bind(this))),
            this.cleanupLinkPrevention(),
            this.autoplayInterval && clearInterval(this.autoplayInterval),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout);
    }
}
customElements.define("ecx-slideshow", ECXSlideShow);
class ECXSlideshowLazyLoadingImage extends ECXCustomComponent {
    constructor() {
        super(),
            (this.picture = this.$(".js-slideshow-picture")),
            (this.image = this.picture ? this.picture.querySelector("img") : null),
            (this.spinner = this.$(".js-image-lazy-spinner")),
            (this.container = this.closest(".js-slideshow-items")),
            (this.currentItemClass = "js-slideshow-image--current"),
            (this.slideItem = this.closest(".js-slideshow-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.section = ECXHelper.qs("#shopify-section-" + this.sectionId)),
            (this.videoComponents = this.$$("ecx-load-video")),
            (this.videoComponentDesktop = this.$(
                "ecx-load-video.d-block-md, ecx-load-video:not(.d-block):not(.d-none-md)"
            )),
            (this.videoComponentMobile = this.$("ecx-load-video.d-block.d-none-md")),
            (this.isVideoSlide = 0 < this.videoComponents.length),
            (this.isImageSlide = !(!this.image && !this.picture)),
            (this.mediaQuery = window.matchMedia("(max-width: 767px)")),
            this.bindEventHandlers();
    }
    setSlideItemVisibility(e) {
        e
            ? (this.slideItem.setAttribute("aria-hidden", "false"),
              this.slideItem.removeAttribute("tabindex"),
              this.slideItem.classList.add("slider-slide--active"))
            : (this.slideItem.setAttribute("aria-hidden", "true"),
              this.slideItem.setAttribute("tabindex", "-1"),
              this.slideItem.classList.remove("slider-slide--active"));
    }
    observeContent(e) {
        var t = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.target;
                    var t = this.parentNode;
                    e.isIntersecting && !this.getAttribute("loaded")
                        ? (this.isImageSlide && this.image && this.image.removeAttribute("loading"),
                          this.isVideoSlide && this.loadResponsiveVideo(),
                          this.setAttribute("loaded", !0),
                          t.classList.add(this.currentItemClass),
                          this.setSlideItemVisibility(!0))
                        : 0 == e.intersectionRatio
                          ? (t.classList.remove(this.currentItemClass), this.setSlideItemVisibility(!1))
                          : this.getAttribute("loaded") &&
                            (t.classList.add(this.currentItemClass), this.setSlideItemVisibility(!0));
                });
            },
            { root: this.container, rootMargin: "100px -2px 100px -2px", threshold: 0 }
        );
        this.isImageSlide && e ? t.observe(e) : this.isVideoSlide && t.observe(this);
    }
    loadResponsiveVideo() {
        var e = this.mediaQuery.matches;
        let t = null;
        e && this.videoComponentMobile
            ? (t = this.videoComponentMobile)
            : !e && this.videoComponentDesktop
              ? (t = this.videoComponentDesktop)
              : 0 < this.videoComponents.length && (t = this.videoComponents[0]),
            t && "function" == typeof t.loadVideo && t.loadVideo();
    }
    loadContent() {
        ECXSlideshowLazyLoadingImage.sharedResizeObserver ||
            ((ECXSlideshowLazyLoadingImage.sharedResizeObserver = new ResizeObserver(
                ECXHelper.debounce(() => {
                    ECXSlideshowLazyLoadingImage.instances.forEach((e) => {
                        e.handleResize();
                    });
                }, 100)
            )),
            (ECXSlideshowLazyLoadingImage.instances = new Set())),
            ECXSlideshowLazyLoadingImage.instances.add(this),
            1 === ECXSlideshowLazyLoadingImage.instances.size &&
                ECXSlideshowLazyLoadingImage.sharedResizeObserver.observe(document.body),
            this.handleResize();
    }
    handleResize() {
        var e;
        this.isImageSlide
            ? (e = this.image || this.picture) && this.observeContent(e)
            : this.isVideoSlide && (this.observeContent(), this.getAttribute("loaded")) && this.loadResponsiveVideo();
    }
    bindEventHandlers() {}
    execute() {
        this.loadContent();
    }
    connectedCallback() {
        this.execute();
    }
    disconnectedCallback() {
        ECXSlideshowLazyLoadingImage.instances &&
            (ECXSlideshowLazyLoadingImage.instances.delete(this), 0 === ECXSlideshowLazyLoadingImage.instances.size) &&
            (ECXSlideshowLazyLoadingImage.sharedResizeObserver?.disconnect(),
            (ECXSlideshowLazyLoadingImage.sharedResizeObserver = null));
    }
}
customElements.define("ecx-slideshow-load-img", ECXSlideshowLazyLoadingImage);
class ECXSlideshowCTA extends ECXCustomComponent {
    constructor() {
        super(),
            (this.ctaButton = this.$$(".js-slideshow-cta")),
            (this.container = this.closest(".js-slideshow-items")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.observeItem();
    }
    observeItem() {
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting ? this.setCTAVisibility(!0) : this.setCTAVisibility(!1);
                });
            },
            { threshold: 0.25 }
        ).observe(this);
    }
    setCTAVisibility(s) {
        this.ctaButton.forEach((e, t) => {
            s
                ? (e.removeAttribute("tabindex"), e.setAttribute("aria-hidden", "false"))
                : (e.setAttribute("tabindex", "-1"), e.setAttribute("aria-hidden", "true"));
        });
    }
}
customElements.define("ecx-slideshow-cta", ECXSlideshowCTA);
class ECXHotSpotTooltip extends ECXCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.tooltip_content = this.$(".js-tooltip-content")),
            (this.tooltip_contents = this.$$(".js-tooltip-content")),
            (this.tooltip_placeholders = this.$$(".js-tooltip-placeholder")),
            (this.tooltip_container = ECXHelper.qs("#" + this.dataset.containerId)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        for (let e = 0, t = this.tooltip_placeholders.length; e < t; e++) {
            var s = this.tooltip_placeholders[e];
            s.addEventListener("mouseover", (e) => {
                this.handleToolTipContentPosition(e);
            }),
                s.addEventListener("mouseout", (e) => {
                    for (let e = 0, t = this.tooltip_contents.length; e < t; e++)
                        this.tooltip_contents[e].classList.remove(
                            "hotspot-content--right",
                            "hotspot-content--left",
                            "hotspot-content--top",
                            "hotspot-content--bottom",
                            "hotspot-content--show"
                        );
                });
        }
    }
    handleToolTipContentPosition(e) {
        var e = e.currentTarget,
            t = e.querySelector(".js-tooltip-content"),
            s = Math.round(e.offsetLeft + t.offsetWidth + e.offsetWidth),
            i = Math.round(e.offsetTop + t.offsetHeight + e.offsetHeight);
        0 <= e.offsetLeft && e.offsetLeft < this.tooltip_container.offsetWidth && s < this.tooltip_container.offsetWidth
            ? t.classList.add("hotspot-content--right", "hotspot-content--show")
            : 0 <= e.offsetLeft &&
              e.offsetLeft < this.tooltip_container.offsetWidth &&
              s >= this.tooltip_container.offsetWidth &&
              t.classList.add("hotspot-content--left", "hotspot-content--show"),
            0 <= e.offsetTop &&
            e.offsetTop < this.tooltip_container.offsetHeight &&
            i < this.tooltip_container.offsetHeight
                ? t.classList.add("hotspot-content--bottom")
                : 0 <= e.offsetTop &&
                  e.offsetTop < this.tooltip_container.offsetHeight &&
                  i >= this.tooltip_container.offsetHeight &&
                  t.classList.add("hotspot-content--top");
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
}
customElements.define("ecx-hotspot", ECXHotSpotTooltip);
class ECXMarquee extends ECXCustomComponent {
    constructor() {
        super(),
            (this.playNPauseBtn = this.$(".js-marquee-pause-n-play-btn")),
            (this.pauseIcon = this.$(".js-marqueen-pause-btn")),
            (this.playIcon = this.$(".js-marqueen-play-btn")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.playNPauseBtn.addEventListener("click", (e) => {
            var t = "false" === e.currentTarget.getAttribute("aria-pressed");
            this.classList.toggle("marquee--animation-pause", t),
                this.playIcon.classList.toggle("d-none", !t),
                this.pauseIcon.classList.toggle("d-none", t),
                e.currentTarget.setAttribute("aria-pressed", t.toString());
        });
    }
}
customElements.define("ecx-marquee", ECXMarquee);
class ECXMap extends ECXCustomComponent {
    constructor() {
        super(), (this.iframe = this.$(".js-map-iframe")), this.bindEventHandlers();
    }
    loadIframeContent() {
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting &&
                        (this.dispatchEvent(
                            new CustomEvent("loadingStart", { detail: { ele: this.iframe, parent: this } })
                        ),
                        this.execute(),
                        t.unobserve(e.target));
                });
            },
            { rootMargin: "0px 0px -100px 0px" }
        ).observe(this);
    }
    bindEventHandlers() {
        this.iframe.addEventListener(
            "load",
            function () {
                this.dispatchEvent(new CustomEvent("loadingEnd", { detail: { ele: this.iframe, parent: this } })),
                    this.setAttribute("loaded", !0);
            }.bind(this)
        );
    }
    execute() {
        this.setIframeSrc();
    }
    setIframeSrc() {
        var e = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
        (this.iframe.src = e), this.iframe.removeAttribute("srcdoc");
    }
    static get observedAttributes() {
        return ["data-zoom", "data-type", "data-location"];
    }
    attributeChangedCallback(e, t, s) {
        t !== s && (Shopify.designMode ? this.execute() : this.loadIframeContent());
    }
    connectedCallback() {}
    disconnectedCallback() {}
    get dataZoom() {
        return this.getAttribute("data-zoom");
    }
    get dataType() {
        return this.getAttribute("data-type");
    }
    get dataLocation() {
        return this.getAttribute("data-location");
    }
    set dataZoom(e) {
        this.setAttribute("data-zoom", e);
    }
    set dataType(e) {
        this.setAttribute("data-type", e);
    }
    set dataLocation(e) {
        this.setAttribute("data-location", e);
    }
}
customElements.define("ecx-map", ECXMap);
class ECXLoadDynamicCheckoutButtonDynamicCheckoutButton extends ECXCustomComponent {
    constructor() {
        super(),
            (this.template = this.$("template")),
            (this.onLoadDynamicCheckoutButton = this.onHandleLoadDynamicCheckoutButton.bind(this)),
            this.bindEventHandlers(),
            (this.isMouseenter = !1),
            (this.json = JSON.parse(ECXHelper.qs('#shopify-features[type="application/json"]').textContent)),
            Shopify.designMode
                ? this.loadDynamicCheckoutButton()
                : (window.addEventListener("scroll", this.onLoadDynamicCheckoutButton, !1),
                  window.addEventListener(
                      "load",
                      function (e) {
                          let t = setTimeout(
                              function () {
                                  this.isMouseenter || (this.loadDynamicCheckoutButton(), clearTimeout(t)),
                                      (this.isMouseenter = !0);
                              }.bind(this),
                              3e3
                          );
                      }.bind(this)
                  ),
                  ["mouseover"].forEach(
                      function (e) {
                          ECXHelper.qs("body").addEventListener(e, this.onLoadDynamicCheckoutButton);
                      }.bind(this)
                  ));
    }
    onHandleLoadDynamicCheckoutButton(e) {
        this.isMouseenter || this.loadDynamicCheckoutButton(),
            e.currentTarget.removeEventListener(e.type, this.onLoadDynamicCheckoutButton),
            (this.isMouseenter = !0);
    }
    loadDynamicCheckoutButton() {
        new IntersectionObserver(
            (e, s) => {
                e.forEach((e) => {
                    var t;
                    1 !== e.intersectionRatio ||
                        this.getAttribute("loaded") ||
                        ((e = this.template.content.firstElementChild.cloneNode(!0)),
                        ((t = document.createElement("script")).src = this.json.smart_payment_buttons_url),
                        t.setAttribute("data-source-attribute", "shopify.dynamic_checkout.product.init"),
                        this.parentNode.insertBefore(e, this.nextSibling),
                        this.parentNode.insertBefore(t, this.nextSibling),
                        this.setAttribute("loaded", !0),
                        s.unobserve(this));
                });
            },
            { root: null, rootMargin: "50px 0px", threshold: 0 }
        ).observe(this);
    }
    bindEventHandlers() {}
}
customElements.define("ecx-load-dyn-co-btn", ECXLoadDynamicCheckoutButtonDynamicCheckoutButton);
class ECXVerticalCarousel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) +
                      parseFloat(
                          window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom")
                      )),
                  (this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel());
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollTop
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    togglePagination(e) {
        e
            ? (this.paginationElement?.classList.remove("d-none"), this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"), this.paginationElement?.classList.add("d-none"));
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientHeight + this.container.scrollTop - t;
        return e.offsetTop + e.clientHeight - 1 <= Math.ceil(t) && e.offsetTop >= this.container.scrollTop;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 769px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollTop && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollTop - s + t * this.itemOffset
                    : this.container.scrollTop + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ top: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        new ResizeObserver((e) => this.init()).observe(this.container);
        new IntersectionObserver(
            ((e, t) => {
                e[0].isIntersecting && (this.init(), t.unobserve(this));
            }).bind(this)
        ).observe(this),
            this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", ECXHelper.debounce(this.updateCarousel.bind(this), 100));
    }
}
customElements.define("ecx-vert-carousel", ECXVerticalCarousel);
class ECXHorizontalCarousel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2 ||
                ((this.gutter =
                    parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                    parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                (this.itemsPerPage = Math.floor(
                    (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                )),
                (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                this.updateCarousel());
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled");
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 769px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - s + t * this.itemOffset
                    : this.container.scrollLeft + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        new ResizeObserver((e) => this.init()).observe(this.container);
        new IntersectionObserver(
            ((e, t) => {
                e[0].isIntersecting && (this.init(), t.unobserve(this));
            }).bind(this)
        ).observe(this),
            this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement && this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", ECXHelper.debounce(this.updateCarousel.bind(this), 100));
    }
}
customElements.define("ecx-horiz-carousel", ECXHorizontalCarousel);
class ECXProductSlideShowItem extends ECXCustomComponent {
    constructor() {
        super(),
            (this.openGalleryButton = this.$(".js-product-media-open-gallery-btn")),
            this.openGalleryButton &&
                this.openGalleryButton.addEventListener("click", (e) => {
                    this.openDialogGallery(e);
                }),
            (this.slideshow = this.closest("ecx-prd-slideshow")),
            (this.parent = this.closest("ecx-carousel-itm")),
            this.prepare();
    }
    openDialogGallery(e) {
        var t = ECXHelper.qs("#" + e.currentTarget.dataset.galleryDialogId);
        t && (t.showModal(e.currentTarget, !0), this.slideshow.pauseAllVideo());
    }
    prepare() {
        this.closest(".product__quickview") ||
            (window.matchMedia("(max-width: 459px)").matches
                ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
                : this.parent.classList.contains("d-block") ||
                  ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none")),
            new ResizeObserver((e) => {
                window.matchMedia("(max-width: 459px)").matches
                    ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
                    : this.parent.classList.contains("d-block") ||
                      ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none"));
            }).observe(document.body));
    }
}
customElements.define("ecx-prd-slideshow-itm", ECXProductSlideShowItem);
class ECXProductSlideShow extends ECXCustomComponent {
    constructor() {
        super(),
            (this.carousel = ECXHelper.qs(`ecx-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.thumb_carousel = ECXHelper.qs(`ecx-vert-carousel[data-section="${this.dataset.section}"]`)),
            this.bindEventHandlers(),
            (this.hide_variant = this.dataset.hideVariantImage);
    }
    bindEventHandlers() {
        this.closest(".product__quickview") ||
            this.$$(".js-slideshow-btn-thumb").forEach((e, t) => {
                0 === t && e.closest(".js-product-slideshow-thumb").classList.add("is-active-item"),
                    e.addEventListener("click", this.setActiveMedia.bind(this, e));
            });
    }
    setActiveMedia(e) {
        var t,
            s = this.$(`[data-media-id="${e.dataset.target}"]`),
            e = e.closest("ecx-vert-carousel-itm");
        s &&
            e &&
            (window.matchMedia("(max-width: 768px)").matches
                ? (this.pauseAllVideo(),
                  this.$$(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  e.classList.add("is-active-item"),
                  (t = this.carousel?.querySelector(".js-carousel-items")) &&
                      s &&
                      t.scrollTo({ left: s.offsetLeft, behavior: "smooth" }))
                : (this.$$(".js-product-slideshow-item").forEach((e) => {
                      e.classList.remove("d-block"), "true" == this.hide_variant && e.classList.add("d-none");
                  }),
                  this.$$(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  s.classList.add("d-block"),
                  "true" == this.hide_variant && s.classList.remove("d-none"),
                  e.classList.add("is-active-item"),
                  this.playActiveVideo(s),
                  this.playActiveModel(s)));
    }
    pauseAllModel() {
        ECXHelper.qsa("ecx-prd-media-itm-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
    }
    pauseAllVideo() {
        this.$$(".js-media-item-youtube").forEach((e) => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }),
            this.$$(".js-media-item-vimeo").forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            }),
            this.$$(".js-media-item-video").forEach((e) => e.pause());
    }
    playActiveVideo(e) {
        this.pauseAllVideo();
        e = e.querySelector(".js-product-media-deferred-video");
        e && e.loadContent();
    }
    playActiveModel(e) {
        e = e.querySelector(".js-product-media-deferred-model");
        e && e.loadContent();
    }
}
customElements.define("ecx-prd-slideshow", ECXProductSlideShow);
class ECXProductMediaItemDeferredVideo extends ECXCustomComponent {
    constructor() {
        super(),
            (this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image")),
            this.itemDeferredVideoImageElem &&
                this.itemDeferredVideoImageElem.addEventListener("click", (e) => {
                    this.loadContent();
                });
    }
    loadContent() {
        var e;
        if (!this.getAttribute("loaded"))
            return (
                (e = this.$("template").content.firstElementChild.cloneNode(!0)),
                this.appendChild(e),
                this.isLoaded(!0),
                this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove(),
                !0
            );
    }
    isLoaded(e) {
        e ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
    }
}
customElements.define("ecx-prd-media-itm-deferred-video", ECXProductMediaItemDeferredVideo);
class ECXProductMediaItemModel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.itemModelImageElem = this.$(".js-product-media-item-model-image")),
            this.itemModelImageElem &&
                this.itemModelImageElem.addEventListener("click", (e) => {
                    this.loadContent();
                });
    }
    loadModelViewerUICss() {
        var e;
        ECXHelper.qs("#model-viewer-ui") ||
            ((e = document.createElement("link")).setAttribute(
                "href",
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
            ),
            e.setAttribute("rel", "stylesheet"),
            e.setAttribute("media", "all"),
            e.setAttribute("id", "model-viewer-ui"),
            document.getElementsByTagName("head")[0].appendChild(e));
    }
    loadContent() {
        var e;
        this.getAttribute("loaded") ||
            ((e = document.createElement("div")).appendChild(
                this.$("template").content.firstElementChild.cloneNode(!0)
            ),
            this.setAttribute("loaded", !0),
            this.itemModelImageElem && this.itemModelImageElem.remove(),
            this.appendChild(e.querySelector("model-viewer")).focus(),
            this.loadModelViewerUICss(),
            Shopify.loadFeatures([
                { name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) },
            ]));
    }
    setupModelViewerUI(e) {
        e || (this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer")));
    }
}
customElements.define("ecx-prd-media-itm-model", ECXProductMediaItemModel),
    (window.ECXProductMediaItemModel = {
        isMouseenter: !1,
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(e) {
            e ||
                (window.ShopifyXR
                    ? (ECXHelper.qsa('[id^="ProductJSON-"]').forEach((e) => {
                          window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
    Shopify.designMode
        ? (ECXHelper.qsa("[data-shopify-xr-hidden]").forEach((e) => e.classList.add("hidden")),
          window.ECXProductMediaItemModel && window.ECXProductMediaItemModel.loadShopifyXR())
        : window.ECXProductMediaItemModel &&
          (window.addEventListener(
              "scroll",
              function (e) {
                  window.ECXProductMediaItemModel.isMouseenter || window.ECXProductMediaItemModel.loadShopifyXR(),
                      (window.ECXProductMediaItemModel.isMouseenter = !0);
              },
              !1
          ),
          ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
              ECXHelper.qs("body").addEventListener(e, function (e) {
                  window.ECXProductMediaItemModel.isMouseenter || window.ECXProductMediaItemModel.loadShopifyXR(),
                      (window.ECXProductMediaItemModel.isMouseenter = !0);
              });
          }));
class ECXFeaturedVariantSelector extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.$ = this.querySelector.bind(this)),
            (this.$$ = this.querySelectorAll.bind(this)),
            (this.elms = {
                radio_elms: this.$$(".js-featured-variant-radio-item"),
                form: ECXHelper.qs("#featuredProductForm-" + this.dataset.section),
                price: ECXHelper.qs("#featuredProductPrice-" + this.dataset.section),
                product_form: ECXHelper.qs(`ecx-featured-prd-frm[data-section="${this.dataset.section}"]`),
                inventory_tracking: ECXHelper.qs("#featuredInventoryTracking-" + this.dataset.section),
                variant_picker: ECXHelper.qs("#featuredVariantPicker-" + this.dataset.section),
                quantity_input: ECXHelper.qs("#featuredProductQuantity-" + this.dataset.section),
                slideshow: ECXHelper.qs(`ecx-prd-slideshow[data-section="${this.dataset.section}"]`),
                thumb_carousel: ECXHelper.qs(`ecx-vert-carousel[data-section="${this.dataset.section}"]`),
                carousel: ECXHelper.qs(`ecx-carousel[data-section-id="${this.dataset.section}"]`),
                variant_options: this.$$(".js-variant-option-value"),
                sku: ECXHelper.qs("#featuredSku-" + this.dataset.section),
            }),
            (this.price_selector = "#featuredProductPrice-" + this.dataset.section),
            (this.inventory_tracking_selector = "#featuredInventoryTracking-" + this.dataset.section),
            (this.variant_picker_selector = "#featuredVariantPicker-" + this.dataset.section),
            (this.quantity_input_selector = "#featuredProductQuantity-" + this.dataset.section),
            (this.slideshow_selector = `ecx-prd-slideshow[data-section="${this.dataset.section}"]`),
            (this.sku_selector = "#featuredSku-" + this.dataset.section),
            (this.variantData = this.setSelectedVariants(this)),
            this.updateSelectedVariants(this.variantData),
            this.bindEventHandlers();
    }
    updateSelectedVariants(e) {
        e?.options &&
            e.options.forEach((e, t) => {
                var s,
                    i,
                    t = (e + "-" + t).replace(/"/g, '\\"'),
                    t = this.$(`.js-variant-item[data-variant-value="${t}"]`);
                t &&
                    ((s = t.getAttribute("data-variant-name") || t.getAttribute("name")),
                    (t = t.dataset.optionVariantValue),
                    s) &&
                    ((i = this.$(`.js-variant-radio-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`)) &&
                        (i.innerHTML = e),
                    (i = this.$(`.js-variant-select-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`))) &&
                    (i.innerHTML = t || e);
            });
    }
    setSelectedVariants(e) {
        return JSON.parse(e.querySelector('[data-selected-variant][type="application/json"]').textContent);
    }
    bindEventHandlers() {
        this.addEventListener("change", () => this.onVariantChangeHandle());
    }
    onVariantChangeHandle() {
        this.toggleAddButton(!0), this.removeErrorMessage(), this.renderProductInfo();
    }
    toggleAddButton(e = !0, t, s) {
        var i,
            n = this.elms.form;
        n &&
            ((i = (n = n.querySelector(".js-featured-product-form-submit-btn")).querySelector(
                ".js-featured-product-form-submit-btn-text"
            )),
            n) &&
            (e
                ? (n.setAttribute("disabled", "disabled"), t && (i.textContent = t))
                : (n.removeAttribute("disabled"), (i.textContent = ECXLanguage.product.PRODUCT_ADD_TO_CART)));
    }
    removeErrorMessage() {
        this.elms.product_form && this.elms.product_form.handleErrorMessage();
    }
    getSelectedVariantValue() {
        return Array.from(this.querySelectorAll(".js-variant-item:checked")).map((e) => e.dataset.optionValueId);
    }
    buildRequestUrlWithParams(e, t) {
        var s = new URLSearchParams({ section_id: this.dataset.section });
        return t.length && s.append("option_values", t.join(",")), e + "?" + s.toString();
    }
    async renderProductInfo() {
        var e = this.dataset.url,
            t = this.getSelectedVariantValue(),
            e = this.buildRequestUrlWithParams(e, t);
        try {
            var s = await fetch(e);
            if (!s.ok) throw new Error("Network response was not ok");
            var i = await s.text(),
                n = new DOMParser().parseFromString(i, "text/html"),
                r = this.setSelectedVariants(n);
            if (!r) return this.setUnavailable();
            this.updateUI(n, r);
        } catch (e) {
            console.error("Error fetching product info:", e), this.setUnavailable();
        }
    }
    checkInventory(e) {
        var t = this.elms.inventory_tracking,
            e = e.querySelector(this.inventory_tracking_selector);
        t && (t.innerHTML = e?.innerHTML ?? "");
    }
    updateOptionValues(e) {
        var e = e.querySelector(".js-variant-picker"),
            t = this.elms.variant_picker;
        e && t && (t.innerHTML = e.innerHTML);
    }
    updateUI(e, t) {
        this.checkInventory(e),
            this.updateVariantInput(t),
            this.updateOptionValues(e),
            this.setActiveMedia(t),
            this.updatePrice(e),
            this.updateSku(e),
            this.updateQuantity(e),
            this.updateSelectOptions(e, t),
            this.updateSlideshow(e),
            this.updateAddToCartState(t);
    }
    updateSelectOptions(e, t) {
        e = e.querySelectorAll("ecx-select .js-variant-select-item");
        let s = this.querySelectorAll("ecx-select .js-variant-select-item");
        e.forEach((e, t) => {
            s[t] && (s[t].innerHTML = e.innerHTML);
        }),
            this.updateSelectedVariants(t);
    }
    updateSku(e) {
        e = e.querySelector(this.sku_selector);
        this.elms.sku && (this.elms.sku.innerHTML = e?.innerHTML ?? "");
    }
    updatePrice(e) {
        e = e.querySelector(this.price_selector);
        e &&
            this.elms.price &&
            ((this.elms.price.innerHTML = e.innerHTML), this.elms.price.classList.remove("d-none-important"));
    }
    updateQuantity(e) {
        var t = this.elms.quantity_input?.querySelector(".js-max-quantity-message"),
            s = e.querySelector(this.quantity_input_selector)?.querySelector(".js-max-quantity-message"),
            t =
                (t && (t.classList.add("d-none-important"), (t.innerHTML = s?.innerHTML ?? "")),
                e.querySelector(this.quantity_input_selector));
        this.elms.quantity_input && (this.elms.quantity_input.innerHTML = t?.innerHTML ?? "");
    }
    updateAddToCartState(e) {
        this.toggleAddButton(!e.available, ECXLanguage.product.PRODUCT_SOLD_OUT);
    }
    updateSlideshow(e) {
        "false" === this.elms.slideshow?.hide_variant &&
            (e = e.querySelector(this.slideshow_selector)) &&
            this.elms.slideshow &&
            ((this.elms.slideshow.innerHTML = e.innerHTML), this.elms.slideshow.bindEventHandlers());
    }
    updateVariantInput(t) {
        var e;
        t &&
            ((e = [this.elms.form, this.elms.installment_form]),
            ECXHelper.qs(".js-inventory-tracking")?.classList.remove("d-none"),
            e.forEach((e) => {
                e &&
                    (e = e.querySelector('input[name="id"]')) &&
                    ((e.value = t.id), e.dispatchEvent(new Event("change", { bubbles: !0 })));
            }));
    }
    setActiveMedia(e) {
        var t, s;
        e.featured_media &&
            ((e = e.featured_media.id),
            (t = this.elms.slideshow?.querySelector(`ecx-carousel-itm[data-media-id="${this.dataset.section}-${e}"]`)),
            (e = this.elms.slideshow?.querySelector(
                `ecx-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${e}"]`
            )),
            t) &&
            (window.matchMedia("(max-width: 768px)").matches
                ? (s = this.elms.carousel?.querySelector(".js-carousel-items")) &&
                  s.scrollTo({ left: t.offsetLeft, behavior: "smooth" })
                : (this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach((e) => {
                      e.classList.remove("d-block"),
                          "true" == this.elms.slideshow.hide_variant && e.classList.add("d-none");
                  }),
                  this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  t.classList.add("d-block"),
                  "true" == this.elms.slideshow.hide_variant && t.classList.remove("d-none")),
            e &&
                (e.classList.add("is-active-item"),
                (s = this.elms.thumb_carousel?.querySelector(".js-carousel-items"))) &&
                s.scrollTo({ top: e.offsetTop, behavior: "auto" }),
            this.elms.slideshow.pauseAllVideo());
    }
    setUnavailable() {
        var e,
            t = this.elms.form,
            s = this.elms.inventory_tracking;
        t &&
            ((e = (t = t.querySelector(".js-featured-product-form-submit-btn")).querySelector(
                ".js-featured-product-form-submit-btn-text"
            )),
            t) &&
            (s.setAttribute("hidden", "true"),
            (e.textContent = ECXLanguage.product.PRODUCT_UNAVAILABLE),
            this.elms.price) &&
            this.elms.price.classList.add("visibility-hidden");
    }
}
class ECXFeaturedVariantRadios extends ECXFeaturedVariantSelector {
    constructor() {
        super(), (this.select_type = "button");
    }
}
customElements.define("ecx-featured-variant-radios", ECXFeaturedVariantRadios);
class ECXFeaturedVariantSelects extends ECXFeaturedVariantSelector {
    constructor() {
        super(),
            (this.$ = this.querySelector.bind(this)),
            (this.$$ = this.querySelectorAll.bind(this)),
            (this.select_type = "dropdown");
    }
}
customElements.define("ecx-featured-variant-selects", ECXFeaturedVariantSelects);
class ECXFeaturedVariantSwatchSelect extends HTMLElement {
    constructor() {
        super(), (this.$ = this.querySelector.bind(this)), (this.$$ = this.querySelectorAll.bind(this));
    }
    init() {
        (this.radios = this.$$(".js-variant-radio-item")),
            (this.select_id = this.dataset.selectId),
            (this.select_element = document.querySelector("#" + this.select_id)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.radios.forEach((e) => {
            e.addEventListener("click", (e) => {
                e.preventDefault(),
                    Array.from(this.radios, (e) => {
                        e.checked = !1;
                    }),
                    setTimeout(() => {
                        e.target.checked = !0;
                    }),
                    this.select_element &&
                        ((this.select_element.querySelector(
                            `option[value="${e.target.value.replace(/"/g, '\\"')}"]`
                        ).selected = !0),
                        this.select_element.dispatchEvent(new Event("change", { bubbles: !0 })));
            });
        });
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("ecx-featured-variant-swatch-select", ECXFeaturedVariantSwatchSelect);
class ECXFeaturedProductForm extends ECXCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.elms = {
            form: this.$("form"),
            submit_btn: this.$('[type="submit"]'),
            error_wrapper: this.$(".js-featured-product-form-error-wrapper"),
            error_message: this.$(".js-featured-product-form-error-message"),
            spinner: this.$(".js-featured-product-form-spinner"),
            quantity_input_container: ECXHelper.qs("#featuredProductQuantity-" + this.dataset.section),
            sticky_header: ECXHelper.qs("ecx-sticky-header"),
            header: ECXHelper.qs("ecx-header"),
            announcement_bar: ECXHelper.qs("ecx-ann-bar"),
            header_cart_status: ECXHelper.qs("#headerCartStatus"),
        }),
            (this.cartNotiType = document.body.getAttribute("data-cart-show-type")),
            (this.cartType = document.body.getAttribute("data-cart-type")),
            (this.cartNotification = ECXHelper.qs("ecx-cart-noti")),
            (this.cartDrawer = ECXHelper.qs("ecx-cart-drwr")),
            (this.cartDrawerForm = ECXHelper.qs("ecx-cart-drwr-frm")),
            this.elms.form && ((this.elms.form.querySelector("[name=id]").disabled = !1), this.bindEventHandlers());
    }
    bindEventHandlers() {
        this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
    onSubmitHandler(s) {
        if ((s.preventDefault(), !this.elms.submit_btn.classList.contains("loading"))) {
            this.handleErrorMessage(),
                this.elms.submit_btn.setAttribute("aria-disabled", !0),
                this.elms.submit_btn.setAttribute("disabled", !0),
                this.elms.submit_btn.classList.add("loading"),
                this.elms.spinner.classList.remove("hidden"),
                this.elms.header_cart_status &&
                    this.elms.header_cart_status.classList.remove("header-cart-status--animate");
            let e = [];
            this.cartNotification && (e = this.cartNotification.getSectionsToRender()),
                this.cartDrawer && (e = [...e, ...this.cartDrawer.getSectionsToRender()]);
            var i = new FormData(this.elms.form);
            e.length &&
                i.append(
                    "sections",
                    e.map((e) => e.id)
                );
            let t = void 0 !== s.submitter ? this.elms.submit_btn : null;
            i.append("sections_url", window.location.pathname),
                (ECXHelper.fetchConfigHTTP.body = i),
                fetch("" + routes.cart_add_url, ECXHelper.fetchConfigHTTP)
                    .then((e) => e.json())
                    .then((e) => {
                        if (e.status) this.handleErrorMessage(e.description);
                        else {
                            switch (
                                (this.elms.sticky_header &&
                                    this.elms.sticky_header.dataset.isEnabled &&
                                    this.elms.sticky_header.reveal(),
                                this.cartNotiType)
                            ) {
                                case "show_popup_noti":
                                    this.handleShowNotification(e, t);
                                    break;
                                case "show_drawer":
                                    this.handleShowDrawer(e, t);
                            }
                            this.elms.quantity_input_container &&
                                "add-to-cart" == this.elms.quantity_input_container.dataset.show &&
                                (this.elms.quantity_input_container.classList.remove("d-none"),
                                (this.elms.quantity_input_container.querySelector("input").value = 1)),
                                this.elms.header || window.location.assign(window.routes.cart_url);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.elms.submit_btn.classList.remove("loading"),
                            this.elms.submit_btn.removeAttribute("aria-disabled"),
                            this.elms.submit_btn.removeAttribute("disabled"),
                            this.elms.spinner.classList.add("hidden");
                    });
        }
    }
    handleShowNotification(e, t) {
        this.cartNotification && this.cartNotification.renderContents(e, !0, t),
            this.cartDrawerForm && this.cartDrawerForm.renderContents(e);
    }
    handleShowDrawer(e, t) {
        "drawer" === this.cartType
            ? (this.cartNotification?.renderContents(e, !1),
              this.cartDrawerForm?.renderContents(e),
              this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage(),
              this.cartDrawer?.openDrawer(t))
            : "page" === this.cartType &&
              (this.cartNotification?.renderContents(e, !1), window.location.assign(window.routes.cart_url));
    }
    handleErrorMessage(e = !1) {
        this.elms.error_wrapper.toggleAttribute("hidden", !e), e && (this.elms.error_message.textContent = e);
    }
}
customElements.define("ecx-featured-prd-frm", ECXFeaturedProductForm),
    window.addEventListener("load", function () {
        if (!customElements.get("ecx-shape-parallax")) {
            class e extends ECXCustomComponent {
                constructor() {
                    super(),
                        (this.speed = -8),
                        (this.shape = this.$(".js-shape-parallax-shape")),
                        (this.shape_rotation = this.$(".js-shape-parallax-rotation")),
                        (this.content = this.$(".js-shape-parallax-content")),
                        (this.bound = {}),
                        (this.dataTransformContent = this.dataset.contentTransform),
                        (this.dataEnableParallaxScrolling = "true" == this.dataset.enableParallaxScrolling),
                        (this.inViewport = !1);
                }
                recalculate() {
                    var e = ECXHelper.qde.scrollTop;
                    (this.top = this.bound.top + e + this.offsetHeight / 2),
                        (this.windowH = window.innerHeight),
                        (this.maxY = this.windowH / 2),
                        (this.cA = this.top - this.windowH);
                }
                recalculateForEditor() {
                    var e = ECXHelper.qde.scrollTop,
                        t = this.getBoundingClientRect();
                    (this.top = t.top + e + this.offsetHeight / 2),
                        (this.windowH = window.innerHeight),
                        (this.maxY = this.windowH / 2),
                        (this.cA = this.top - this.windowH);
                }
                bindEventHandlers() {
                    document.addEventListener(
                        "scroll",
                        () => {
                            requestAnimationFrame(this.setAnimation.bind(this));
                        },
                        !0
                    ),
                        Shopify.designMode &&
                            (document.addEventListener(
                                "shopify:inspector:activate",
                                function (e) {
                                    setTimeout(() => {
                                        this.recalculateForEditor(),
                                            requestAnimationFrame(this.setAnimation.bind(this));
                                    });
                                }.bind(this)
                            ),
                            document.addEventListener(
                                "shopify:section:load",
                                function (e) {
                                    setTimeout(() => {
                                        this.recalculateForEditor(),
                                            requestAnimationFrame(this.setAnimation.bind(this));
                                    });
                                }.bind(this)
                            ));
                }
                calculatePercentage() {
                    var e = ECXHelper.qde.scrollTop,
                        t = e - this.cA;
                    let s = 0;
                    return (s = this.inViewport ? -e / this.top : 1 - t / this.maxY);
                }
                setAnimation() {
                    var e = ECXHelper.qde.scrollTop,
                        t = this.calculatePercentage(),
                        t = (this.windowH / 12) * t;
                    this.dataEnableParallaxScrolling && (this.shape.style.transform = `translate3d(0px, ${t}px, 0px)`),
                        (this.shape_rotation.style.transform = `rotate(${e / 4}deg)`),
                        (this.content.style.transform = this.dataTransformContent + ` rotate(-${e / 4}deg)`);
                }
                onObserverHandler() {
                    new IntersectionObserver((e, t) => {
                        e.forEach((e) => {
                            e.isIntersecting && ECXHelper.qde.scrollTop <= 0 && (this.inViewport = !0),
                                t.unobserve(this.shape);
                        });
                    }).observe(this.shape),
                        Shopify.designMode ||
                            new IntersectionObserver((e, t) => {
                                (this.bound = e[0].boundingClientRect),
                                    this.recalculate(),
                                    requestAnimationFrame(this.setAnimation.bind(this)),
                                    t.disconnect();
                            }).observe(this);
                }
                connectedCallback() {
                    this.bindEventHandlers(), this.onObserverHandler();
                }
                disconnectedCallback() {}
            }
            customElements.define("ecx-shape-parallax", e);
        }
    });
var VAR_LOCALIZATION_CACHE = new Map();
class ECXLocalization extends ECXCustomComponent {
    constructor() {
        super();
    }
    async init() {
        Shopify.designMode
            ? await this.getSearchResults()
            : new IntersectionObserver(
                  (async (e, t) => {
                      e[0].isIntersecting && (await this.getSearchResults(), t.unobserve(this));
                  }).bind(this),
                  { threshold: 0.25 }
              ).observe(this);
    }
    async getSearchResults() {
        ECXHelper.loadScript(
            this.dataset.jsFileId,
            this.dataset.jsFile,
            async function () {
                var e = this.dataset.url.replace(/\s/g, "-").toLowerCase(),
                    t = VAR_LOCALIZATION_CACHE.get(e);
                t
                    ? (this.innerHTML = t)
                    : ((t = await this.fetchResults()), VAR_LOCALIZATION_CACHE.set(e, t), (this.innerHTML = t));
            }.bind(this)
        );
    }
    async fetchResults() {
        return fetch(this.dataset.url)
            .then((e) => e.text())
            .then((e) => {
                var t = document.createElement("div"),
                    e = ((t.innerHTML = e), t.querySelector("#" + this.dataset.sectionId));
                return e && e.innerHTML.trim().length ? e.innerHTML : "";
            })
            .catch((e) => (console.error(e), ""));
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("ecx-localization", ECXLocalization);
class ECXFreeShippingBar extends ECXCustomComponent {
    constructor() {
        super(),
            (this.total_price = this.dataset.totalPrice),
            (this.threshold = 0),
            (this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice),
            (this.free_shipping_price = this.dataset.freeShippingPrice),
            (this.free_shipping_progress = this.$(".js-free-shipping-progress")),
            (this.free_shipping_progress_content = this.$(".js-free-shipping-progress-content")),
            (this.free_shipping_progress_message = this.$(".js-free-shipping-message")),
            this.init();
    }
    calculateCurrencyRate() {
        this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
    }
    init() {
        this.calculateCurrencyRate(),
            (this.free_shipping_progress.max = this.threshold),
            (this.free_shipping_progress.value = this.total_price),
            (this.free_shipping_progress_content.innerHTML = ECXHelper.formatMoney(
                this.threshold,
                window.theme_variables.settings.money_with_currency_format
            ));
        var e = this.threshold - this.total_price;
        this.free_shipping_progress_message.innerHTML =
            e <= 0
                ? ECXLanguage.free_shipping_bar.FULFILLED
                : ECXLanguage.free_shipping_bar.UNFULFILLED.replace(
                      "[remaining_amount]",
                      ECXHelper.formatMoney(e, window.theme_variables.settings.money_with_currency_format)
                  );
    }
}
customElements.define("ecx-free-shipping-bar", ECXFreeShippingBar);
class ECXCountDown extends ECXCustomComponent {
    constructor() {
        super();
    }
    init() {
        if (((this.isExpired = JSON.parse(this.dataset.isExpired)), this.isExpired)) return !0;
        (this.timeZoneName = this.dataset.timeZoneName),
            (this.timeZoneOffset = this.dataset.timeZoneOffset),
            (this.endTime = this.dataset.endTime),
            (this.endDate = this.dataset.endDate),
            (this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd)),
            this.validateDateValue(this.endDate) || (this.endDate = this.getCurrentDateTime(!0)),
            this.validateTimeValue(this.endTime) || (this.endTime = "23:59:59"),
            (this.expiredAt = new Date(this.convertDateStringToISOString(this.endDate + ":" + this.endTime)).getTime()),
            (this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime())),
            (this.daysElement = this.$(".js-counter-days")),
            (this.hoursElement = this.$(".js-counter-hours")),
            (this.minutesElement = this.$(".js-counter-minutes")),
            (this.secondsElement = this.$(".js-counter-seconds")),
            (this.messageElement = this.$(".js-counter-message")),
            (this.counterElement = this.$(".js-counter"));
        let n = setInterval(() => {
            var e,
                t,
                s,
                i = this.expiredAt - this.currentTime;
            i <= 0
                ? (clearInterval(n),
                  this.setCounter({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                  "" != this.messageElement.innerHTML && this.messageElement.classList.remove("d-none"),
                  this.hideOnEnd && this.counterElement.classList.add("d-none-important"))
                : ((e = Math.floor(i / 864e5)),
                  (t = Math.floor((i % 864e5) / 36e5)),
                  (s = Math.floor((i % 36e5) / 6e4)),
                  (i = Math.floor((i % 6e4) / 1e3)),
                  this.setCounter({ days: e, hours: t, minutes: s, seconds: i }),
                  (this.currentTime = this.currentTime + 1e3));
        }, 1e3);
    }
    connectedCallback() {
        this.init();
    }
    getCurrentDateTime(e = !1) {
        var t = new Date(),
            s = t.getFullYear(),
            i = String(t.getMonth() + 1).padStart(2, "0"),
            n = String(t.getDate()).padStart(2, "0"),
            r = String(t.getHours()).padStart(2, "0"),
            o = String(t.getMinutes()).padStart(2, "0"),
            t = String(t.getSeconds()).padStart(2, "0");
        return e ? s + `-${i}-` + n : s + `-${i}-${n} ${r}:${o}:` + t;
    }
    convertDateTimeToSpecificTimeZone(e, t = !0) {
        var e = new Date(e),
            s = "-" === this.timeZoneOffset[0];
        let i =
            60 *
            (60 * parseInt(this.timeZoneOffset.substring(1, 3)) + parseInt(this.timeZoneOffset.substring(3, 5))) *
            1e3;
        s && (i = -i);
        s = new Date(e.getTime() + i);
        return t ? s.getTime() : s.toISOString();
    }
    setCounter({ days: e, hours: t, minutes: s, seconds: i }) {
        (this.daysElement.textContent = e < 10 ? "0" + e : e),
            (this.hoursElement.textContent = t < 10 ? "0" + t : t),
            (this.minutesElement.textContent = s < 10 ? "0" + s : s),
            (this.secondsElement.textContent = i < 10 ? "0" + i : i);
    }
    convertDateStringToISOString(e) {
        return e.replace(/:/, "T") + ".000Z";
    }
    validateDateValue(e) {
        return !!/^\d{4}-\d{2}-\d{2}$/.test(e);
    }
    validateTimeValue(e) {
        return !!/^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(e);
    }
}
customElements.define("ecx-countdown", ECXCountDown);
class ECXHorizoltalCarousel extends ECXCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            (this.slideshow = ECXHelper.qs(`ecx-prd-slideshow[data-section="${this.dataset.section}"]`)),
            (this.carousel = ECXHelper.qs(`ecx-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.carouselLayout = this.getAttribute("data-layout")),
            (this.window_width =
                window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth),
            this.transform(),
            this.bindEventHandlers(),
            window.addEventListener("resize", (e) => {
                var t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.window_width != t && (this.transform(e), (this.window_width = t));
            });
    }
    bindEventHandlers() {
        this.closest(".product__quickview") ||
            this.$$(".js-slideshow-btn-thumb").forEach((e, t) => {
                0 === t && e.closest(".js-product-slideshow-thumb").classList.add("is-active-item"),
                    e.addEventListener("click", this.setActiveMedia.bind(this, e));
            });
    }
    setActiveMedia(e) {
        var t;
        this.slideshow &&
            ((t = this.slideshow.querySelector(`[data-media-id="${e.dataset.target}"]`)),
            (e = e.closest("ecx-vert-carousel-itm")),
            t) &&
            e &&
            window.matchMedia("(max-width: 768px)").matches &&
            (this.slideshow.pauseAllVideo(),
            this.$$(".js-product-slideshow-thumb").forEach((e) => {
                e.classList.remove("is-active-item");
            }),
            e.classList.add("is-active-item"),
            (e = this.carousel?.querySelector(".js-carousel-items"))) &&
            t &&
            e.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
    }
    transform(e) {
        setTimeout(() => {
            this.horizontalInit(), this.horizontalBindEventHandlers(), void 0 !== e && this.horizontalSetActiveMedia();
        }, 200);
    }
    horizontalInit() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.horizontalTogglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.horizontalUpdateCarousel());
    }
    horizontalUpdateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.horizontalIsItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled"),
            1 < this.totalPages && this.horizontalTogglePagination(!0),
            this.totalPages <= 1 && this.horizontalTogglePagination(!1);
    }
    horizontalIsItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft;
    }
    horizontalOnButtonClick(e) {
        e.preventDefault();
        let t = 0;
        (0 != this.container.scrollLeft &&
            !this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
            (t = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - t + +this.itemOffset
                    : this.container.scrollLeft + t - +this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    horizontalBindEventHandlers() {
        this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.nextBtnElement &&
                this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.container.addEventListener(
                "scroll",
                ECXHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100)
            );
    }
    horizontalTogglePagination(e) {
        e
            ? (this.paginationElement?.classList.remove("d-none-important"),
              this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"),
              this.paginationElement?.classList.add("d-none-important"));
    }
    horizontalSetActiveMedia() {
        var e = this.$("ecx-vert-carousel-itm.is-active-item");
        e &&
            (this.container.scrollTo({ left: e.offsetLeft, behavior: "auto" }),
            (e = this.slideshow.$(`ecx-carousel-itm[data-media-id="${e.dataset.mediaTargetId}"]`)),
            this.carousel.querySelector(".js-carousel-items").scrollTo({ left: e.offsetLeft, behavior: "auto" }));
    }
}
customElements.define("ecx-horizoltal-carousel", ECXHorizoltalCarousel);
class ECXCartDiscount extends ECXCustomComponent {
    static ENTER_KEY = "Enter";
    static CART_UPDATE_DELAY = 500;
    static BIND_BUTTONS_DELAY = 600;
    static ENDPOINTS = { DISCOUNT: "/cart/update.js" };
    constructor() {
        super(), this.initializeProperties(), this.cacheElements(), this.initializeState();
    }
    initializeProperties() {
        (this.sectionId = this.dataset.sectionId),
            (this.isUpdating = !1),
            (this.eventListeners = new Map()),
            (this.debounceTimers = new Map());
    }
    cacheElements() {
        (this.elements = {
            formDiv: this.querySelector("[data-discount-form]"),
            input: null,
            errorContainer: this.querySelector("#cartDiscountError"),
            successContainer: this.querySelector("#cartDiscountSuccess"),
            errorShipping: null,
            errorDiscount: null,
            submitBtn: null,
            pillsContainer: this.querySelector(".js-discount-pills"),
        }),
            this.elements.formDiv &&
                ((this.elements.input = this.elements.formDiv.querySelector(".js-discount-input")),
                (this.elements.submitBtn = this.elements.formDiv.querySelector(".js-discount-submit"))),
            this.elements.errorContainer &&
                ((this.elements.errorShipping = this.elements.errorContainer.querySelector(".js-error-shipping")),
                (this.elements.errorDiscount = this.elements.errorContainer.querySelector(".js-error-discount")));
    }
    initializeState() {
        this.boundHandlers = {
            handleDiscountSubmit: this.handleDiscountSubmit.bind(this),
            handleKeydown: this.handleKeydown.bind(this),
            handleFormSubmit: this.handleFormSubmit.bind(this),
            handleCartUpdate: this.handleCartUpdate.bind(this),
            handleDOMReady: this.handleDOMReady.bind(this),
            handleRemoveClick: this.handleRemoveClick.bind(this),
        };
    }
    connectedCallback() {
        this.setupEventListeners(), this.bindRemoveButtons();
    }
    disconnectedCallback() {
        this.cleanup();
    }
    setupEventListeners() {
        this.setupFormEvents(), this.setupCartUpdateListener(), this.setupRemoveButtonsDelegation();
    }
    setupFormEvents() {
        var e;
        this.elements.formDiv &&
            !this.elements.formDiv.dataset.eventBound &&
            ((this.elements.formDiv.dataset.eventBound = "true"),
            this.elements.submitBtn &&
                this.addEventListener(this.elements.submitBtn, "click", this.boundHandlers.handleDiscountSubmit),
            this.elements.input &&
                this.addEventListener(this.elements.input, "keydown", this.boundHandlers.handleKeydown),
            (e = document.getElementById("cartForm"))) &&
            this.addEventListener(e, "submit", this.boundHandlers.handleFormSubmit);
    }
    setupCartUpdateListener() {
        this.addEventListener(document, "cart:update", this.boundHandlers.handleCartUpdate),
            "loading" === document.readyState
                ? this.addEventListener(document, "DOMContentLoaded", this.boundHandlers.handleDOMReady)
                : this.boundHandlers.handleDOMReady();
    }
    setupRemoveButtonsDelegation() {
        this.elements.pillsContainer &&
            !this.elements.pillsContainer.dataset.delegationBound &&
            ((this.elements.pillsContainer.dataset.delegationBound = "true"),
            this.addEventListener(this.elements.pillsContainer, "click", this.boundHandlers.handleRemoveClick));
            console.log("removebuttons")
    }
    addEventListener(e, t, s) {
        e.addEventListener(t, s);
        var i = e.tagName + "-" + t;
        this.eventListeners.has(i) || this.eventListeners.set(i, []),
            this.eventListeners.get(i).push({ element: e, event: t, handler: s });
    }
    removeEventListener(t, e, s) {
        t.removeEventListener(e, s);
        var i,
            e = t.tagName + "-" + e,
            e = this.eventListeners.get(e);
        e && -1 < (i = e.findIndex((e) => e.element === t && e.handler === s)) && e.splice(i, 1);
    }
    handleKeydown(e) {
        e.key === ECXCartDiscount.ENTER_KEY && (e.preventDefault(), this.handleDiscountSubmit(e));
    }
    handleFormSubmit(e) {
        var t = document.activeElement;
        if (this.isDiscountInputActive(t)) return e.preventDefault(), this.handleDiscountSubmit(e), !1;
    }
    handleCartUpdate(e) {
        "discount" === e.detail?.source && this.debounceBindRemoveButtons();
    }
    handleDOMReady() {
        this.debounce("dom-ready", () => this.bindRemoveButtons(), 100);
    }
    handleRemoveClick(e) {
        var t = e.target.closest(".js-remove-discount");
        t &&
            (e.preventDefault(), e.stopPropagation(), this.hideMessages(), (e = t.dataset.removeDiscount)) &&
            this.processDiscountRemoval(e);
    }
    debounce(e, t, s) {
        this.debounceTimers.has(e) && clearTimeout(this.debounceTimers.get(e));
        s = setTimeout(() => {
            t(), this.debounceTimers.delete(e);
        }, s);
        this.debounceTimers.set(e, s);
    }
    debounceBindRemoveButtons() {
        this.debounce("bind-buttons", () => this.bindRemoveButtons(), ECXCartDiscount.BIND_BUTTONS_DELAY);
    }
    isDiscountInputActive(e) {
        return "discount" === e?.name && e.closest("[data-discount-form]");
    }
    bindRemoveButtons() {
        var e = document.querySelectorAll(".js-remove-discount:not([data-event-bound-remove])");
        0 !== e.length &&
            e.forEach((e) => {
                this.addEventListener(e, "click", (e) => this.handleDiscountRemove(e)),
                    (e.dataset.eventBoundRemove = "true");
            });
    }
    async handleDiscountSubmit(e) {
        e.preventDefault(), e.stopPropagation();
        e = this.getDiscountCodeFromInput();
        e && (await this.processDiscountApplication(e));
    }
    async handleDiscountRemove(e) {
        e.preventDefault(), e.stopPropagation(), this.hideMessages();
        e = e.currentTarget.dataset.removeDiscount;
        e && (await this.processDiscountRemoval(e));
    }
    getDiscountCodeFromInput() {
        return this.elements.input?.value.trim() || "";
    }
    async processDiscountApplication(e) {
        this.setLoading(!0), this.hideMessages();
        try {
            var t,
                s,
                i,
                n = this.getExistingDiscountCodes(),
                r = await this.applyDiscount(e);
            r.ok
                ? ((s = await r.json()),
                  (i = this.validateDiscountResponse(s, n, e)).isValid
                      ? this.handleSuccessfulDiscount()
                      : (this.clearInput(), this.showError(i.errorType)))
                : ((t = await r.json()), this.showError(t.description || "discount_code"));
        } catch (e) {
            console.error("Error applying discount:", e), this.showError("general");
        } finally {
            this.setLoading(!1);
        }
    }
    async processDiscountRemoval(t) {
        this.setLoading(!0), this.hideMessages();
        try {
            var e = this.getExistingDiscountCodes().filter((e) => e !== t);
            (await this.sendDiscountUpdateRequest(e)).ok && this.updateCartDrawer();
        } catch (e) {
            console.error("Error removing discount:", e);
        } finally {
            this.setLoading(!1);
        }
    }
    validateDiscountResponse(e, t, s) {
        return this.isDiscountNotApplicable(e, s)
            ? { isValid: !1, errorType: "discount_code" }
            : this.isShippingOnlyDiscount(e, t, s)
              ? { isValid: !1, errorType: "shipping" }
              : { isValid: !0 };
    }
    isDiscountNotApplicable(e, t) {
        return e.discount_codes?.some((e) => e.code === t && !1 === e.applicable);
    }
    isShippingOnlyDiscount(e, t, s) {
        var i;
        return (
            !!e.sections?.[this.sectionId] &&
            ((i = this.extractDiscountCodesFromHTML(e.sections[this.sectionId])),
            this.isDiscountAlreadyAppliedButNotVisible(i, t, e.discount_codes, s))
        );
    }
    extractDiscountCodesFromHTML(e) {
        e = new DOMParser().parseFromString(e, "text/html").getElementById("shopify-section-" + this.sectionId);
        return e
            ? Array.from(e.querySelectorAll("[data-discount-code]"))
                  .map((e) => e.dataset.discountCode)
                  .filter(Boolean)
            : [];
    }
    isDiscountAlreadyAppliedButNotVisible(e, t, s, i) {
        (e = e.length === t.length && e.every((e) => t.includes(e))),
            (s = s?.some((e) => e.code === i && !0 === e.applicable));
        return e && s;
    }
    async applyDiscount(e) {
        e = [...this.getExistingDiscountCodes(), e];
        return this.sendDiscountUpdateRequest(e);
    }
    async sendDiscountUpdateRequest(e) {
        return fetch(ECXCartDiscount.ENDPOINTS.DISCOUNT, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: e.join(","), sections: this.sectionId }),
        });
    }
    getExistingDiscountCodes() {
        return Array.from(this.querySelectorAll("[data-discount-code]"))
            .map((e) => e.dataset.discountCode)
            .filter(Boolean);
    }
    handleSuccessfulDiscount() {
        this.clearInput(), this.showSuccess(), this.updateCartDrawer();
    }
    clearInput() {
        this.elements.input && (this.elements.input.value = "");
    }
    updateCartDrawer() {
        this.isUpdating ||
            ((this.isUpdating = !0),
            this.dispatchCartUpdateEvent(),
            this.debounce(
                "cart-update",
                () => {
                    this.bindRemoveButtons(), (this.isUpdating = !1);
                },
                ECXCartDiscount.CART_UPDATE_DELAY
            ));
    }
    dispatchCartUpdateEvent() {
        document.dispatchEvent(
            new CustomEvent("cart:update", { detail: { source: "discount", timestamp: Date.now() } })
        );
    }
    hideMessages() {
        this.hideError(), this.hideSuccess();
    }
    showSuccess() {
        this.elements.successContainer &&
            (this.hideError(), this.elements.successContainer.classList.remove("d-none-important"));
    }
    hideSuccess() {
        this.elements.successContainer?.classList.add("d-none-important");
    }
    showError(e) {
        this.elements.errorContainer &&
            (this.hideSuccess(),
            this.elements.errorContainer.classList.remove("d-none-important"),
            this.toggleErrorTypes(e));
    }
    toggleErrorTypes(e) {
        e = "shipping" === e;
        this.elements.errorShipping?.classList.toggle("d-none-important", !e),
            this.elements.errorDiscount?.classList.toggle("d-none-important", e);
    }
    hideError() {
        this.elements.errorContainer?.classList.add("d-none-important");
    }
    setLoading(e) {
        this.toggleAttribute("loading", e),
            this.elements.formDiv?.classList.toggle("loading", e),
            this.elements.submitBtn?.toggleAttribute("disabled", e);
    }
    cleanup() {
        this.debounceTimers.forEach((e) => clearTimeout(e)),
            this.debounceTimers.clear(),
            this.eventListeners.forEach((e) => {
                e.forEach(({ element: e, event: t, handler: s }) => {
                    e.removeEventListener(t, s);
                });
            }),
            this.eventListeners.clear();
    }
}
customElements.define("ecx-cart-discount", ECXCartDiscount);
class ECXVariation extends ECXCustomComponent {
    constructor() {
        super(),
            (this.productVariations = this.$$(".js-variation-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.isQuickView = this.classList.contains("js-variation-quick-view")),
            (this.cachedData = {}),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.addEventListener("click", this.handleClick.bind(this));
    }
    handleClick(e) {
        e = e.target.closest(".js-variation-item");
        e && this.handleVariationClick(e.dataset.variationUrl);
    }
    handleVariationClick(e) {
        this.isQuickView || window.history.replaceState(null, "", e), this.fetchData(e);
    }
    async fetchData(e) {
        try {
            if (this.cachedData[e]) this.updateDOM(this.cachedData[e], e);
            else {
                var t = e + "?section_id=" + this.sectionId,
                    s = await fetch(t);
                if (!s.ok) throw new Error(`Failed to fetch product: ${s.status} ` + s.statusText);
                var i = await s.text(),
                    n = document.createElement("div");
                (n.innerHTML = i), (this.cachedData[e] = n), await this.preloadImages(n), this.updateDOM(n, e);
            }
        } catch (e) {
            console.error("Error fetching product variation:", e);
        }
    }
    preloadImages(e) {
        var e = e.querySelectorAll('img[src]:not([loading="lazy"])');
        return 0 === e.length
            ? Promise.resolve()
            : ((e = Array.from(e).map(
                  (t) =>
                      new Promise((e) => {
                          t.complete ? e() : ((t.onload = () => e()), (t.onerror = () => e()));
                      })
              )),
              Promise.all(e));
    }
    updateDOM(e, t) {
        var s = this.isQuickView ? "dialogBodyQuickView" : this.sectionId,
            i = document.querySelector("#" + s);
        if (e && i) {
            var n = e.querySelector(".js-main-product");
            if (
                (n && n.removeAttribute("data-animate"),
                this.isQuickView
                    ? (n = e.querySelector(".js-quick-view-container")) &&
                      ((i.innerHTML = n.innerHTML),
                      (n =
                          document.querySelector("#dialogQuickShop .js-view-full-btn a") ||
                          document.querySelector(".js-quick-view-drawer .js-view-full-btn a"))) &&
                      t &&
                      (n.href = t)
                    : (i.parentElement.innerHTML = e.children[0].innerHTML),
                window.Shopify?.PaymentButton)
            ) {
                let e = document.querySelector("#" + s);
                requestAnimationFrame(() => {
                    Shopify.PaymentButton.init(),
                        setTimeout(() => {
                            e.querySelectorAll(".shopify-payment-button").forEach((e) => {
                                e.removeAttribute("data-observed"),
                                    ECXCustomComponent.enhancePaymentButtons(e),
                                    e.dataset.observed ||
                                        (new MutationObserver(() => {
                                            ECXCustomComponent.enhancePaymentButtons(e);
                                        }).observe(e, { childList: !0, subtree: !0 }),
                                        (e.dataset.observed = "true"));
                            });
                        }, 250);
                });
            }
        } else console.warn("Product elements not found in current or new product");
    }
}
customElements.define("ecx-variation", ECXVariation);
class ECXMarqueeSection extends ECXCustomComponent {
    constructor() {
        super(),
            (this.marqueeWrapper = this.$(".js-marquee-container")),
            (this.marqueeList = this.$(".js-marquee-list")),
            (this.marqueeListAll = this.$$(".js-marquee-list")),
            (this.normalSpeed = parseFloat(this.getAttribute("normal-speed")) / 2 || 1),
            (this.stopSpeed = parseFloat(this.getAttribute("hover-speed")) || 0),
            (this.direction = this.getAttribute("direction")),
            (this.loop = parseInt(this.marqueeWrapper.getAttribute("loop-marquee"))),
            (this.speed = this.normalSpeed),
            (this.isRTL = ECXHelper.isRTL),
            this.init();
    }
    onResize() {
        (this.resizeObserver = new ResizeObserver((e) => {
            (this.marqueeListWidth = this.marqueeList.offsetWidth),
                (this.currentPosition = 0),
                (this.currentPositionReverse = this.isRTL ? this.marqueeListWidth : -this.marqueeListWidth),
                (this.minWidthValue = window.innerWidth / (this.loop - 1)),
                this.checkWidth(),
                (this.currentPositionReverse = this.isRTL ? this.newWidth : -this.newWidth);
        })),
            this.resizeObserver.observe(this);
    }
    init() {
        this.onResize(), this.startAnimation(), this.bindHoverEvents();
    }
    checkWidth() {
        this.loop * this.marqueeListWidth < window.innerWidth
            ? (this.marqueeListAll.forEach((e) => {
                  e.style.minWidth = this.minWidthValue + "px";
              }),
              (this.newWidth = this.minWidthValue))
            : (this.marqueeListAll.forEach((e) => {
                  e.style.minWidth = "";
              }),
              (this.newWidth = this.marqueeListWidth));
    }
    bindHoverEvents() {
        this.marqueeWrapper.addEventListener("mouseover", () => {
            this.speed = this.stopSpeed;
        }),
            this.marqueeWrapper.addEventListener("mouseout", () => {
                this.speed = this.normalSpeed;
            });
    }
    startAnimation() {
        this.animate();
    }
    animate() {
        "animation-reverse" == this.direction
            ? (this.isRTL
                  ? ((this.currentPositionReverse -= this.speed),
                    this.currentPositionReverse <= 0 && (this.currentPositionReverse = this.newWidth))
                  : ((this.currentPositionReverse += this.speed),
                    0 <= this.currentPositionReverse && (this.currentPositionReverse = -this.newWidth)),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPositionReverse}px)`))
            : (this.isRTL
                  ? ((this.currentPosition += this.speed),
                    this.currentPosition >= this.newWidth && (this.currentPosition = 0))
                  : ((this.currentPosition -= this.speed),
                    this.currentPosition <= -this.newWidth && (this.currentPosition = 0)),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPosition}px)`)),
            requestAnimationFrame(this.animate.bind(this));
    }
}
customElements.define("ecx-marquee-section", ECXMarqueeSection);
class ECXInfinityScroll extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.renderContainer = ECXHelper.qid("loadMoreContainer")),
            (this.loadingIndicator = this.querySelector(".js-loading-infinity-scroll")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.observer = this.registerObserver(this.loadNextPage.bind(this))), this.observer.observe(this);
    }
    registerObserver(t) {
        let s = !1;
        return new IntersectionObserver(function (e) {
            e[0].isIntersecting &&
                !s &&
                ((s = !0),
                t()
                    .then(() => (s = !1))
                    .catch(() => (s = !1)));
        });
    }
    loadNextPage() {
        var { nextUrl: e, totalPages: t } = this.dataset,
            s = parseInt(this.dataset.currentPage) + 1;
        return t < s
            ? (this.observer.disconnect(), Promise.resolve())
            : (this.loadingIndicator.classList.remove("hidden"),
              fetch(e.replace(/page=[0-9]+/, "page=" + s))
                  .then((e) => (this.loadingIndicator.classList.add("hidden"), e.text()))
                  .then((e) => {
                      var t = document.createElement("div"),
                          e = ((t.innerHTML = e), t.querySelector("#loadMoreContainer").innerHTML);
                      this.renderContainer.insertAdjacentHTML("beforeend", e);
                  })
                  .catch((e) => {
                      console.error(e);
                  })
                  .finally(() => {
                      this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
                  }));
    }
}
customElements.define("ecx-infinity-scroll", ECXInfinityScroll);
class ECXNewsletterPopup extends ECXCustomComponent {
    constructor() {
        super(),
            (this.properties = JSON.parse(this.dataset.props || "{}")),
            (this.myStorage = window.localStorage),
            (this.sessionStorageName = Shopify.theme.name.toLowerCase() + "-newsletter-popup-display"),
            (this.cartNotificationSessionKey = Shopify.theme.name.toLowerCase() + "-cart-notification-popup-shown"),
            (this.bodyElement = ECXHelper.qs("body")),
            (this.cartNotification = ECXHelper.qs("ecx-cart-noti")),
            (this.cartDrawer = ECXHelper.qs("ecx-cart-drwr")),
            (this.cartShowType = this.bodyElement ? this.bodyElement.dataset.cartShowType : "show_popup_noti"),
            (this.isOpen = !1),
            (this.buffer = 100),
            (this.myScrollHeight = document.body.scrollHeight || ECXHelper.qde.scrollHeight || 0),
            (this.myWindowHeight = window.innerHeight || ECXHelper.qde.clientHeight || 0),
            (this.contentLoaded = !1),
            (this.contentContainer = this.$("[data-deferred-content]")),
            (this.contentTemplate = this.$(".js-newsletter-content-template")),
            (this.elms = {
                close_btn: this.$(".js-popup-close-btn"),
                body: this.bodyElement,
                trigger_btn: ECXHelper.qs(".js-newsletter-popup-trigger"),
                overlay: this.$(".js-newsletter-popup-overlay"),
            }),
            (this.trigger = this.dataset.trigger || "reaching-to-footer"),
            (this.delayTime = this.dataset.delayTime || "session"),
            (this.delayDays = parseInt(this.dataset.delayDays || 30)),
            (this.delayUntil = parseInt(this.dataset.delayUntil || 0)),
            (this.showOnlyOnIndex = this.hasAttribute("data-show-only-on-index")),
            (this.showOnlyForVisitors = this.hasAttribute("data-show-only-for-visitors")),
            (this.stickyPopupEnabled = !!this.elms.trigger_btn),
            (this.stickyStorageKey = Shopify.theme.name.toLowerCase() + "-sticky-popup-dismissed"),
            (this.manuallyClosedInSession = !1),
            (this.boundScrollEventHandle = this.onScrollEventHandle.bind(this)),
            (this.boundOnLoadUserAction = this.onUserAction.bind(this)),
            (this.boundCloseBtnClickHandle = this.onCloseBtnClickHandle.bind(this)),
            (this.boundTriggerBtnClickHandle = this.onTriggerBtnClickHandle.bind(this)),
            (this.boundStickyCloseBtnClickHandle = this.onStickyCloseBtnClickHandle.bind(this)),
            this.init();
    }
    loadDeferredContent() {
        if (!this.contentLoaded && this.contentTemplate && this.contentContainer)
            try {
                var e = this.contentTemplate.content.cloneNode(!0);
                (this.contentContainer.innerHTML = ""), this.contentContainer.appendChild(e), (this.contentLoaded = !0);
            } catch (e) {
                console.error("Error loading deferred newsletter popup content:", e),
                    (this.contentContainer.innerHTML =
                        '<div class="newsletter-popup-error">Content could not be loaded</div>');
            }
    }
    initializeLoadedComponents() {
        this.contentContainer.querySelectorAll("[is], [data-ui-component]").forEach((e) => {
            e.tagName.toLowerCase().startsWith("ecx-") && "function" == typeof e.init && e.init();
        });
    }
    init() {
        (this.showOnlyOnIndex && !window.location.pathname.match(/^\/$|^\/\?/)) ||
            (this.bindEventHandlers(),
            this.getPopupStatus()
                ? this.initStickyPopup()
                : (this.initTrigger(),
                  this.initStickyPopup(),
                  Shopify.designMode &&
                      this.dataset.sectionId &&
                      (this.editorHelper = new ECXPopupEditorHelper(this, this.dataset.sectionId))));
    }
    bindEventHandlers() {
        this.elms.close_btn && this.elms.close_btn.addEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.overlay && this.elms.overlay.addEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.trigger_btn &&
                (this.elms.trigger_btn.addEventListener("click", this.boundTriggerBtnClickHandle),
                (this.stickyCloseBtn = this.elms.trigger_btn.querySelector(".icon-close, svg")),
                this.stickyCloseBtn) &&
                this.stickyCloseBtn.addEventListener("click", this.boundStickyCloseBtnClickHandle),
            (this.userEventTypes = ["mouseenter", "touchstart", "mouseover"]),
            this.userEventTypes.forEach((e) => {
                this.bodyElement.addEventListener(e, this.boundOnLoadUserAction);
            }),
            this.popupAttrObserve();
    }
    disconnectedCallback() {
        this.elms.close_btn && this.elms.close_btn.removeEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.overlay && this.elms.overlay.removeEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.trigger_btn &&
                (this.elms.trigger_btn.removeEventListener("click", this.boundTriggerBtnClickHandle),
                this.stickyCloseBtn) &&
                this.stickyCloseBtn.removeEventListener("click", this.boundStickyCloseBtnClickHandle),
            this.userEventTypes &&
                this.bodyElement &&
                this.userEventTypes.forEach((e) => {
                    this.bodyElement.removeEventListener(e, this.boundOnLoadUserAction);
                }),
            "reaching-to-footer" === this.trigger && window.removeEventListener("scroll", this.boundScrollEventHandle),
            this.cartNotification &&
                this.cartNotificationHandler &&
                this.cartNotification.removeEventListener("closed", this.cartNotificationHandler),
            this.cartDrawer &&
                this.cartDrawerHandler &&
                this.cartDrawer.removeEventListener("closed", this.cartDrawerHandler),
            this.delayTimeoutId && clearTimeout(this.delayTimeoutId),
            this.popupAttrObserver && (this.popupAttrObserver.disconnect(), (this.popupAttrObserver = null)),
            super.disconnectedCallback && super.disconnectedCallback();
    }
    initTrigger() {
        switch (this.trigger) {
            case "reaching-to-footer":
                window.addEventListener("scroll", this.boundScrollEventHandle);
                break;
            case "after-closing-cart-notification":
                "show_popup_noti" === this.cartShowType && this.cartNotification
                    ? ((this.cartNotificationHandler = (e) => {
                          try {
                              "true" === sessionStorage.getItem(this.cartNotificationSessionKey) ||
                                  (this.togglePopup(!0),
                                  sessionStorage.setItem(this.cartNotificationSessionKey, "true"));
                          } catch (e) {
                              console.warn("Error handling cart notification:", e);
                          }
                      }),
                      this.cartNotification.addEventListener("closed", this.cartNotificationHandler))
                    : "show_drawer" === this.cartShowType &&
                      this.cartDrawer &&
                      ((this.cartDrawerHandler = (e) => {
                          try {
                              "true" === sessionStorage.getItem(this.cartNotificationSessionKey) ||
                                  (this.togglePopup(!0),
                                  sessionStorage.setItem(this.cartNotificationSessionKey, "true"));
                          } catch (e) {
                              console.warn("Error handling cart drawer:", e);
                          }
                      }),
                      this.cartDrawer.addEventListener("closed", this.cartDrawerHandler));
                break;
            case "delay-after-page-load":
                this.delayTimeoutId = setTimeout(() => {
                    try {
                        this.getPopupStatus() || this.togglePopup(!0);
                    } catch (e) {
                        console.warn("Error in delay trigger:", e);
                    }
                }, 1e3 * this.delayUntil);
        }
    }
    initStickyPopup() {
        this.stickyPopupEnabled &&
            (this.toggleStickyPopup(!1),
            this.getStickyPopupDismissedStatus() || (this.getPopupStatus() && this.toggleStickyPopup(!0)));
    }
    onUserAction(e) {
        this.classList.contains("d-none") && this.classList.remove("d-none"),
            e.currentTarget.removeEventListener(e.type, this.onLoadUserAction);
    }
    onScrollEventHandle(e) {
        var t, s;
        "reaching-to-footer" !== this.trigger
            ? window.removeEventListener("scroll", this.boundScrollEventHandle)
            : ((this.myScrollHeight = document.body.scrollHeight || ECXHelper.qde.scrollHeight || 0),
              (t =
                  (window.pageYOffset || ECXHelper.qde.scrollTop || document.body.scrollTop || 0) +
                      this.buffer +
                      this.myWindowHeight >=
                  this.myScrollHeight),
              (s = this.getPopupStatus()),
              !t ||
                  (null !== this.getAttribute("open") && "" !== this.getAttribute("open")) ||
                  s ||
                  this.manuallyClosedInSession ||
                  this.togglePopup(!0));
    }
    onTriggerBtnClickHandle(e) {
        e.preventDefault(), this.togglePopup(!0);
    }
    onStickyCloseBtnClickHandle(e) {
        e.preventDefault(),
            e.stopPropagation(),
            this.toggleStickyPopup(!1),
            "after-closing-cart-notification" === this.trigger
                ? (sessionStorage.setItem(this.cartNotificationSessionKey, "true"),
                  sessionStorage.setItem(this.stickyStorageKey, "true"))
                : "days" === this.delayTime
                  ? ((e = new Date().getTime() + 24 * this.delayDays * 60 * 60 * 1e3),
                    this.myStorage.setItem(this.sessionStorageName, e.toString()),
                    this.myStorage.setItem(this.stickyStorageKey, e.toString()))
                  : (this.setStickyPopupDismissedStatus(!0), this.setPopupStatus());
    }
    onCloseBtnClickHandle(e) {
        e.preventDefault(),
            (this.manuallyClosedInSession = !0),
            "after-closing-cart-notification" === this.trigger &&
                sessionStorage.setItem(this.cartNotificationSessionKey, "true"),
            this.togglePopup(!1);
    }
    togglePopup(e) {
        var t = this.$(".js-success");
        e && !t
            ? (this.stickyPopupEnabled && this.toggleStickyPopup(!1), this.toggleOpen(!0))
            : (this.toggleOpen(!1),
              this.setPopupStatus(),
              this.stickyPopupEnabled &&
                  !this.getStickyPopupDismissedStatus() &&
                  setTimeout(() => {
                      this.toggleStickyPopup(!0);
                  }, 500));
    }
    toggleOpen(e) {
        e
            ? (this.loadDeferredContent(),
              this.elms.overlay &&
                  (this.elms.overlay.classList.add("animate-in"), this.elms.overlay.classList.remove("animate-out")),
              this.elms.body.classList.add("is-newsletter-popup-show"),
              this.setAttribute("open", !0),
              this.classList.remove("is-closing"))
            : (this.classList.add("is-closing"),
              this.elms.overlay &&
                  (this.elms.overlay.classList.add("animate-out"), this.elms.overlay.classList.remove("animate-in")),
              setTimeout(() => {
                  this.classList.remove("is-closing"),
                      this.removeAttribute("open"),
                      this.elms.body.classList.remove("is-newsletter-popup-show"),
                      ECXHelper.removeTrapFocus();
              }, 350));
    }
    setCookie(t, e) {
        try {
            document.cookie = t + `=${e}; path=/;`;
        } catch (e) {
            console.warn(`Failed to set cookie ${t}:`, e);
        }
    }
    getCookie(t) {
        try {
            var e = document.cookie.match(new RegExp("(^| )" + t + "=([^;]+)"));
            return e ? e[2] : null;
        } catch (e) {
            return console.warn(`Failed to get cookie ${t}:`, e), null;
        }
    }
    removeCookie(t) {
        try {
            document.cookie = t + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        } catch (e) {
            console.warn(`Failed to remove cookie ${t}:`, e);
        }
    }
    setStorageValue(t, e, s = null) {
        try {
            var i = s || this.delayTime,
                n = new Date();
            switch (i) {
                case "session":
                    sessionStorage.setItem(t, String(e));
                    break;
                case "cookies":
                    this.setCookie(t, String(e));
                    break;
                case "days":
                    var r = n.getTime() + 24 * this.delayDays * 60 * 60 * 1e3;
                    this.myStorage.setItem(t, String(r));
                    break;
                default:
                    sessionStorage.setItem(t, String(e));
            }
        } catch (e) {
            console.warn(`Failed to set storage for ${t}:`, e);
        }
    }
    removeStorageValue(t, e = null) {
        try {
            switch (e || this.delayTime) {
                case "session":
                    sessionStorage.removeItem(t);
                    break;
                case "cookies":
                    this.removeCookie(t);
                    break;
                default:
                    this.myStorage.removeItem(t);
            }
        } catch (e) {
            console.warn(`Failed to remove storage for ${t}:`, e);
        }
    }
    getStorageValue(t, e = null) {
        if (Shopify.designMode) return null;
        try {
            switch (e || this.delayTime) {
                case "session":
                    return sessionStorage.getItem(t);
                case "cookies":
                    return this.getCookie(t);
                case "days":
                    var s,
                        i = this.myStorage.getItem(t);
                    return i
                        ? ((s = new Date().getTime()), parseInt(i) <= s ? (this.myStorage.removeItem(t), null) : i)
                        : null;
                default:
                    return sessionStorage.getItem(t);
            }
        } catch (e) {
            return console.warn(`Failed to get storage for ${t}:`, e), null;
        }
    }
    setPopupStatus() {
        this.setStorageValue(this.sessionStorageName, "true");
    }
    getPopupStatus() {
        var e;
        return (
            !Shopify.designMode &&
            ((e = this.getStorageValue(this.sessionStorageName)), "days" === this.delayTime ? null !== e : "true" === e)
        );
    }
    setStickyPopupDismissedStatus(e) {
        e ? this.setStorageValue(this.stickyStorageKey, "true") : this.removeStorageValue(this.stickyStorageKey);
    }
    getStickyPopupDismissedStatus() {
        var e;
        return (
            !Shopify.designMode &&
            ((e = this.getStorageValue(this.stickyStorageKey)), "days" === this.delayTime ? null !== e : "true" === e)
        );
    }
    toggleStickyPopup(e) {
        this.elms.trigger_btn &&
            (e
                ? this.elms.trigger_btn.classList.add("is-visible")
                : this.elms.trigger_btn.classList.remove("is-visible"));
    }
    popupAttrObserve() {
        try {
            (this.popupAttrObserver = new MutationObserver((e, t) => {
                e.forEach(async (e) => {
                    try {
                        var t;
                        "open" === e.attributeName &&
                            (this.hasAttribute("open")
                                ? (await this.animationsComplete(),
                                  this.dispatchEvent(new Event("opened")),
                                  ECXHelper.trapFocus(this),
                                  (t = this.querySelector('input[type="email"]')) && t.focus())
                                : this.dispatchEvent(new Event("closed")));
                    } catch (e) {
                        console.warn("Error handling popup attribute change:", e);
                    }
                });
            })),
                this.popupAttrObserver.observe(this, { attributes: !0 });
        } catch (e) {
            console.error("Failed to initialize popup attribute observer:", e);
        }
    }
    animationsComplete() {
        try {
            return Promise.allSettled(this.getAnimations().map((e) => e.finished));
        } catch (e) {
            return console.warn("Error waiting for animations to complete:", e), Promise.resolve();
        }
    }
}
customElements.define("ecx-newsletter-popup", ECXNewsletterPopup);
class ECXImageATF extends HTMLElement {
    constructor() {
        super(),
            (this.imageElement = null),
            (this.pictureElement = null),
            (this.loadAttempted = !1),
            (this.intersectionObserver = null),
            (this.mutationObserver = null),
            (this.parallaxWrapper = null),
            (this.parallaxHandler = null),
            (this.parallaxResizeHandler = null),
            (this.parallaxRaf = null),
            (this.parallaxTop = 0),
            (this.speed = 0.15);
    }
    connectedCallback() {
        this.findImage() ? this.init() : this.waitForImage(), this.setupIntersectionObserver(), this.initParallax();
    }
    findImage() {
        return (
            (this.pictureElement = this.querySelector("picture")),
            (this.imageElement = this.pictureElement?.querySelector("img") || this.querySelector("img")),
            this.imageElement
        );
    }
    waitForImage() {
        this.mutationObserver?.disconnect(),
            (this.mutationObserver = new MutationObserver(() => {
                this.findImage() && (this.mutationObserver.disconnect(), (this.mutationObserver = null), this.init());
            })),
            this.mutationObserver.observe(this, { childList: !0, subtree: !0 });
    }
    init() {
        this.imageElement &&
            (this.imageElement.src && this.imageElement.complete && 0 !== this.imageElement.naturalHeight
                ? ((this.loadAttempted = !0), this.handleImageLoad())
                : this.imageElement.complete && 0 !== this.imageElement.naturalHeight
                  ? this.handleImageLoad()
                  : (this.imageElement.addEventListener("load", () => this.handleImageLoad(), { once: !0 }),
                    this.imageElement.addEventListener(
                        "error",
                        () => {
                            this.classList.add("image-loader--error"),
                                console.warn("Image failed to load:", this.imageElement?.src || "unknown source"),
                                this.cleanup();
                        },
                        { once: !0 }
                    )));
    }
    setupIntersectionObserver() {
        this.intersectionObserver?.disconnect(),
            (this.intersectionObserver = new IntersectionObserver(
                (e) => {
                    e[0].isIntersecting && !this.loadAttempted && ((this.loadAttempted = !0), this.loadImage());
                },
                { rootMargin: "50px 0px", threshold: 0.01 }
            )),
            this.intersectionObserver.observe(this);
    }
    loadImage() {
        var e;
        this.imageElement &&
            (this.imageElement.removeAttribute("loading"),
            this.pictureElement?.querySelectorAll("source[data-srcset]").forEach((e) => {
                (e.srcset = e.getAttribute("data-srcset")), e.removeAttribute("data-srcset");
            }),
            (e = this.imageElement.getAttribute("data-src")) &&
                !this.imageElement.src &&
                ((this.imageElement.src = e), this.imageElement.removeAttribute("data-src")),
            (e = this.imageElement.getAttribute("data-srcset"))) &&
            !this.imageElement.srcset &&
            ((this.imageElement.srcset = e), this.imageElement.removeAttribute("data-srcset"));
    }
    handleImageLoad() {
        this.classList.add("image-loader--loaded"), this.cleanup();
    }
    cleanup() {
        this.intersectionObserver?.disconnect(),
            this.mutationObserver?.disconnect(),
            (this.intersectionObserver = this.mutationObserver = null);
    }
    initParallax() {
        if (((this.parallaxWrapper = this.closest('[data-ecx-parallax="true"]')), this.parallaxWrapper)) {
            if (CSS.supports("animation-timeline", "scroll()")) return;
            this.parallaxTarget = this;
        } else {
            if ("true" !== this.dataset.ecxParallaxInner) return;
            if (
                (((this.parallaxWrapper = this).parallaxTarget = this.querySelector("ecx-slideshow-load-img")),
                !this.parallaxTarget)
            )
                return;
        }
        (this.parallaxHandler = () => {
            this.parallaxRaf || (this.parallaxRaf = requestAnimationFrame(this.setAnimation.bind(this)));
        }),
            (this.parallaxResizeHandler = () => {
                this.recalculate(),
                    this.parallaxRaf || (this.parallaxRaf = requestAnimationFrame(this.setAnimation.bind(this)));
            }),
            document.addEventListener("scroll", this.parallaxHandler, { passive: !0 }),
            window.addEventListener("resize", this.parallaxResizeHandler);
        let s = new IntersectionObserver((e) => {
            var t = ECXHelper.qde.scrollTop,
                e = e[0].boundingClientRect;
            (this.parallaxTop = e.top + t + this.parallaxWrapper.offsetHeight / 2),
                requestAnimationFrame(this.setAnimation.bind(this)),
                s.disconnect();
        });
        s.observe(this.parallaxWrapper);
    }
    recalculate() {
        var e, t;
        this.parallaxWrapper &&
            ((e = ECXHelper.qde.scrollTop),
            (t = this.parallaxWrapper.getBoundingClientRect()),
            (this.parallaxTop = t.top + e + this.parallaxWrapper.offsetHeight / 2));
    }
    setAnimation() {
        this.parallaxRaf = null;
        var e = ECXHelper.qde.scrollTop,
            e = (window.innerHeight / 2 - (this.parallaxTop - e)) * this.speed;
        this.parallaxTarget.style.transform = `translate3d(0px, ${e}px, 0px)`;
    }
    disconnectedCallback() {
        this.cleanup(),
            (this.loadAttempted = !1),
            this.parallaxHandler &&
                (document.removeEventListener("scroll", this.parallaxHandler),
                window.removeEventListener("resize", this.parallaxResizeHandler),
                (this.parallaxHandler = null),
                (this.parallaxResizeHandler = null));
    }
}
if (
    (customElements.define("ecx-image-atf", ECXImageATF),
    "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", () => ECXCustomComponent.initGlobalFeatures())
        : ECXCustomComponent.initGlobalFeatures(),
    !customElements.get("ecx-predictive-srch"))
) {
    class d9 extends ECXCustomComponent {
        constructor() {
            super(),
                (this.cachedRequests = new Map()),
                (this.resultsPanelMaxHeight = 0),
                (this.notificationMessage =
                    this.dataset.noti ||
                    "Quick Search section is currently hidden. Please enable the Quick Search section in the theme editor to use this feature."),
                (this.elms = {
                    predictive_search_form: this.$(".js-predictive-search-form"),
                    predictive_search_input: this.$(".js-predictive-search-input"),
                    predictive_search_results: this.$(".js-predictive-search-results"),
                    predictive_search_result_panel: this.$(".js-predictive-search-results-panel"),
                    predictive_search_message_placeholder: this.$(".js-predictive-search-message-placeholder"),
                    predictive_search_loading: this.$(".js-predictive-search-loading"),
                    predictive_close_button: this.$(".js-predictive-search-close-trigger"),
                    predictive_overlay: this.$(".js-predictive-search-results-panel-overlay"),
                    header: this.closest("ecx-header"),
                    header_search_open_trigger: this.closest("ecx-header")?.querySelector(".js-search-open-trigger"),
                    body: document.body,
                    enable_predictive: "true" === this.dataset.enablePredictive,
                }),
                (this.url = {
                    searchUrl: routes.predictive_search_url,
                    queryParameters: {
                        section_id: "ecx-predictive-srch",
                        resources: { limit: 10, options: { unavailable_products: "last", fields: "" } },
                    },
                }),
                (this.shopifyFeaturesJson = JSON.parse(
                    ECXHelper.qs('#shopify-features[type="application/json"]').textContent
                )),
                (this.code = ""),
                this.elms.enable_predictive && this.bindEventHandlers();
        }
        bindEventHandlers() {
            this.elms.predictive_search_form.addEventListener("submit", this.onSubmitHandle.bind(this)),
                this.elms.predictive_search_input.addEventListener(
                    "input",
                    ECXHelper.debounce((e) => {
                        this.onInputHandle(e);
                    }, 300).bind(this)
                ),
                this.elms.predictive_search_input.addEventListener("focus", this.onInputFocusHandle.bind(this)),
                this.elms.predictive_close_button.addEventListener("click", this.closeSearchResults.bind(this)),
                this.elms.predictive_overlay &&
                    this.elms.predictive_overlay.addEventListener("click", this.closeSearchResults.bind(this)),
                this.addEventListener("keyup", (e) => {
                    (this.code = e.code.toUpperCase()), "ESCAPE" === e.code.toUpperCase() && this.closeSearchResults();
                }),
                Shopify.designMode &&
                    this.dataset.sectionId &&
                    (this.editorHelper = new ECXPredictiveSearchEditorHelper(this, this.dataset.sectionId));
        }
        onSubmitHandle(e) {
            this.getSearchTerm() || e.preventDefault();
        }
        onInputFocusHandle(e) {
            var t = this.getSearchTerm();
            this.openSearchResults(t);
        }
        getSearchTerm() {
            return this.elms.predictive_search_input.value.trim();
        }
        openSearchResults(e) {
            e.length
                ? this.togglePlaceHolderMessage(!1)
                : (this.resetSearchResultPanel(),
                  this.togglePlaceHolderMessage(!0),
                  this.toggleLoading(!1),
                  this.toggleLoadingContainer(!1),
                  this.toggleResults(!1)),
                this.toggleOpen(!0),
                this.toggleSearchResults(!0),
                this.elms.predictive_search_input.setAttribute("aria-expanded", !0);
        }
        resetSearchResultPanel() {
            this.elms.predictive_search_result_panel.innerHTML = "";
        }
        toggleResults(e) {
            e
                ? (this.setAttribute("results", !0),
                  setTimeout(
                      function () {
                          this.classList.add("is-result-show");
                      }.bind(this),
                      300
                  ))
                : (this.removeAttribute("results"), this.classList.remove("is-result-show"));
        }
        toggleOpen(e) {
            e
                ? (this.setAttribute("open", !0),
                  document.body.classList.add("header--predictive-search-open"),
                  this.elms.body.classList.add("o-hidden"))
                : (this.removeAttribute("open"),
                  document.body.classList.remove("header--predictive-search-open"),
                  this.elms.body.classList.remove("o-hidden"));
        }
        async onInputHandle(e) {
            var t;
            this.shopifyFeaturesJson.predictiveSearch &&
                "ESCAPE" !== this.code &&
                ((t = this.getSearchTerm()), this.openSearchResults(t), this.resetSearchResultPanel(), t.length) &&
                ((t = await this.getSearchResults(t)), this.renderSearchResultPanel(t));
        }
        renderSearchResultPanel(e) {
            (this.elms.predictive_search_result_panel.innerHTML = e),
                this.toggleResults(!0),
                this.toggleLoading(!1),
                this.toggleLoadingContainer(!1),
                Shopify.designMode || ECXHelper.trapFocus(this);
        }
        async getSearchResults(e) {
            var t = e.replace(/\s/g, "-").toLowerCase(),
                s = this.cachedRequests.get(t);
            return s || ((s = await this.fetchResults(e)), this.cachedRequests.set(t, s), s);
        }
        onSubmitHandle(e) {
            this.getSearchTerm() || e.preventDefault();
        }
        async fetchResults(e) {
            (e = `${this.url.searchUrl}?q=${encodeURIComponent(e)}&resources[limit_scope]=each&section_id=predictive-search`),
                this.toggleLoading(!0),
                this.toggleLoadingContainer(!0),
                (e = await fetch(e)
                    .then((e) => {
                        if (e.ok) return e.text();
                        throw new Error(e.status);
                    })
                    .then(
                        (e) => (
                            this.toggleLoading(!1),
                            this.toggleLoadingContainer(!1),
                            new DOMParser()
                                .parseFromString(e, "text/html")
                                .querySelector("#shopify-section-predictive-search").innerHTML
                        )
                    )
                    .catch((e) => (console.error(e), "")));
            return e;
        }
        toggleSearchResults(e) {
            (e = this.shopifyFeaturesJson.predictiveSearch ? e : !1)
                ? this.elms.predictive_search_results.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_results.setAttribute("hidden", !0);
        }
        toggleLoading(e) {
            e
                ? this.elms.predictive_search_loading.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_loading.setAttribute("hidden", !0);
        }
        togglePlaceHolderMessage(e) {
            e
                ? this.elms.predictive_search_message_placeholder.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_message_placeholder.setAttribute("hidden", !0);
        }
        toggleLoadingContainer(e) {
            e ? this.setAttribute("loading", !0) : this.removeAttribute("loading");
        }
        closeSearchResults(e = !1) {
            this.toggleOpen(!1),
                this.toggleLoading(!1),
                this.toggleLoadingContainer(!1),
                this.togglePlaceHolderMessage(!1),
                this.toggleResults(!1),
                this.resetSearchResultPanel(),
                this.toggleSearchResults(!1),
                this.elms.header_search_open_trigger &&
                    !e &&
                    ECXHelper.removeTrapFocus(this.elms.header_search_open_trigger),
                (this.resultsPanelMaxHeight = 0),
                this.elms.predictive_search_result_panel.removeAttribute("style"),
                (this.elms.predictive_search_input.value = ""),
                this.elms.predictive_search_input.setAttribute("aria-expanded", !1);
        }
        calculateResultsPanelMaxHeight() {
            return (
                (this.resultsPanelMaxHeight =
                    window.innerHeight - ECXHelper.qid("shopify-section-header").getBoundingClientRect().bottom),
                this.resultsPanelMaxHeight
            );
        }
    }
    customElements.define("ecx-predictive-srch", d9);
}
class ECXMainSearch extends HTMLElement {
    constructor() {
        super(),
            (this.hasProduct = null !== this.querySelector(".js-main-search-result-product")),
            this.hasProduct || this.querySelector(".filter--vertical").classList.add("d-none-important");
    }
}
customElements.define("ecx-srch", ECXMainSearch);
class ECXBeforeAfter extends ECXCustomComponent {
    constructor() {
        super(),
            (this.container = this.$(".before-after__container")),
            (this.beforeLayer = this.$(".before-after__before")),
            (this.slider = this.$(".before-after__slider")),
            (this.isDragging = !1);
    }
    connectedCallback() {
        this.bindEvents();
    }
    bindEvents() {
        var e = this.$(".before-after__slider-handle");
        e &&
            (e.addEventListener("pointerdown", this.onPointerDown.bind(this)),
            document.addEventListener("pointermove", this.onPointerMove.bind(this)),
            document.addEventListener("pointerup", this.onPointerUp.bind(this)));
    }
    onPointerDown(e) {
        e.preventDefault(), (this.isDragging = !0), (this.container.style.cursor = "ew-resize");
    }
    onPointerMove(e) {
        var t;
        this.isDragging &&
            (e.preventDefault(),
            (t = this.container.getBoundingClientRect()),
            (e = ((e.clientX - t.left) / t.width) * 100),
            (e = Math.max(0, Math.min(100, e))),
            this.updatePosition(e));
    }
    onPointerUp() {
        this.isDragging && ((this.isDragging = !1), (this.container.style.cursor = ""));
    }
    updatePosition(e) {
        (this.beforeLayer.style.clipPath = "inset(0 " + (100 - e) + "% 0 0)"), (this.slider.style.left = e + "%");
    }
}
if ((customElements.define("ecx-before-after", ECXBeforeAfter), !customElements.get("ecx-slideshow-swiper"))) {
    class Q9 extends HTMLElement {
        connectedCallback() {
            (this.sectionId = this.dataset.sectionId),
                (this.swiperEl = this.querySelector(".sws-swiper")),
                (this.prevEl = this.querySelector(".sws-nav-btn--prev")),
                (this.nextEl = this.querySelector(".sws-nav-btn--next")),
                (this.paginationEl = this.querySelector(".sws-pagination")),
                window.Swiper ? this.initSwiper() : this.loadSwiperAssets(),
                window.Shopify &&
                    window.Shopify.designMode &&
                    (document.addEventListener(
                        "shopify:section:load",
                        (this._onLoad = (e) => {
                            e.detail.sectionId === this.sectionId &&
                                ((this.swiperEl = this.querySelector(".sws-swiper")),
                                (this.prevEl = this.querySelector(".sws-nav-btn--prev")),
                                (this.nextEl = this.querySelector(".sws-nav-btn--next")),
                                (this.paginationEl = this.querySelector(".sws-pagination")),
                                this.initSwiper());
                        })
                    ),
                    document.addEventListener(
                        "shopify:section:unload",
                        (this._onUnload = (e) => {
                            e.detail.sectionId === this.sectionId &&
                                this.swiper &&
                                (this.swiper.destroy(!0, !0), (this.swiper = null));
                        })
                    ),
                    document.addEventListener(
                        "shopify:block:select",
                        (this._onBlockSelect = (e) => {
                            this.swiper &&
                                (e = e.target.closest(".sws-slide")) &&
                                -1 !== (e = Array.from(e.parentElement.children).indexOf(e)) &&
                                this.swiper.slideToLoop(e);
                        })
                    ));
        }
        disconnectedCallback() {
            this._onLoad && document.removeEventListener("shopify:section:load", this._onLoad),
                this._onUnload && document.removeEventListener("shopify:section:unload", this._onUnload),
                this._onBlockSelect && document.removeEventListener("shopify:block:select", this._onBlockSelect),
                this.swiper && this.swiper.destroy(!0, !0);
        }
        loadSwiperAssets() {
            var e, t;
            document.querySelector('link[href*="swiper@8"]') ||
                (((t = document.createElement("link")).rel = "stylesheet"),
                (t.href = "https://unpkg.com/swiper@8/swiper-bundle.min.css"),
                document.head.appendChild(t)),
                document.querySelector('script[src*="swiper@8"], script[src*="swiper-bundle"]')
                    ? (e = setInterval(
                          function () {
                              window.Swiper && (clearInterval(e), this.initSwiper());
                          }.bind(this),
                          50
                      ))
                    : (((t = document.createElement("script")).src = "https://unpkg.com/swiper@8/swiper-bundle.min.js"),
                      (t.onload = this.initSwiper.bind(this)),
                      document.head.appendChild(t));
        }
        initSwiper() {
            var e, t;
            this.swiper && this.swiper.destroy(!0, !0),
                this.swiperEl &&
                    "undefined" != typeof Swiper &&
                    ((t = {
                        loop: (t = "true" === (e = this.dataset).loop),
                        loopAdditionalSlides: t ? parseInt(e.slidesDesktop) || 3 : 0,
                        slidesPerView: parseInt(e.slidesMobile) || 1,
                        spaceBetween: parseInt(e.spaceBetween) || 0,
                        freeMode: "true" === e.freeMode,
                        centeredSlides: "true" === e.centered,
                        watchOverflow: !0,
                        grabCursor: !0,
                        mousewheel: { forceToAxis: !0, releaseOnEdges: !0 },
                        breakpoints: {
                            768: {
                                slidesPerView: parseInt(e.slidesTablet) || Math.min(parseInt(e.slidesDesktop) || 3, 4),
                                spaceBetween: parseInt(e.spaceBetween) || 0,
                            },
                            1024: {
                                slidesPerView: parseInt(e.slidesDesktop) || 3,
                                spaceBetween: parseInt(e.spaceBetween) || 0,
                            },
                        },
                    }),
                    "true" === e.showPagination &&
                        this.paginationEl &&
                        (t.pagination = { el: this.paginationEl, clickable: !0 }),
                    "true" === e.showNavigation &&
                        this.prevEl &&
                        this.nextEl &&
                        (t.navigation = { prevEl: this.prevEl, nextEl: this.nextEl }),
                    "true" === e.autoplay &&
                        (t.autoplay = {
                            delay: parseInt(e.autoplayDelay) || 5e3,
                            disableOnInteraction: !1,
                            pauseOnMouseEnter: !0,
                        }),
                    (this.swiper = new Swiper(this.swiperEl, t)));
        }
    }
    customElements.define("ecx-slideshow-swiper", Q9);
}
if (!customElements.get("ecx-swiper-slider")) {
    class ak extends HTMLElement {
        connectedCallback() {
            (this.swiperEl = this.querySelector(".sis__swiper")),
                (this.prevBtn = this.querySelector(".sis__btn--prev")),
                (this.nextBtn = this.querySelector(".sis__btn--next")),
                (this.paginationEl = this.querySelector(".sis__pagination")),
                window.Swiper ? this.init() : this.loadSwiper(),
                window.Shopify &&
                    window.Shopify.designMode &&
                    (document.addEventListener("shopify:section:load", this.onSectionLoad.bind(this)),
                    document.addEventListener("shopify:section:unload", this.onSectionUnload.bind(this)),
                    document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this)));
        }
        loadSwiper() {
            document.querySelector('link[href*="swiper-bundle"]') ||
                (((e = document.createElement("link")).rel = "stylesheet"),
                (e.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"),
                document.head.appendChild(e));
            if (document.querySelector('script[src*="swiper-bundle"]')) {
                var t = setInterval(
                    function () {
                        window.Swiper && (clearInterval(t), this.init());
                    }.bind(this),
                    50
                );
            } else {
                var e = document.createElement("script");
                (e.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"),
                    (e.onload = this.init.bind(this)),
                    document.head.appendChild(e);
            }
        }
        init() {
            this.swiper && this.swiper.destroy(!0, !0);
            var e = this.dataset,
                t = parseInt(e.slidesDesktop) || 4,
                s = parseInt(e.slidesTablet) || 3,
                i = parseInt(e.slidesMobile) || 1,
                n = parseInt(e.spaceBetween) || 0,
                r = "true" === e.loop,
                o = "true" === e.centered,
                a = "true" === e.freeMode,
                l = "true" === e.autoplay,
                h = parseInt(e.autoplayDelay) || 5e3,
                d = "true" === e.showNavigation,
                e = "true" === e.showPagination,
                i = {
                    slidesPerView: i,
                    spaceBetween: n,
                    centeredSlides: o,
                    loop: r,
                    freeMode: a,
                    grabCursor: !0,
                    speed: 500,
                    touchRatio: 1,
                    touchStartPreventDefault: !1,
                    watchOverflow: !0,
                    breakpoints: {
                        768: { slidesPerView: s, spaceBetween: n },
                        1024: { slidesPerView: t, spaceBetween: n },
                    },
                };
            d && this.prevBtn && this.nextBtn && (i.navigation = { prevEl: this.prevBtn, nextEl: this.nextBtn }),
                e && this.paginationEl && (i.pagination = { el: this.paginationEl, clickable: !0 }),
                l && (i.autoplay = { delay: h, disableOnInteraction: !1, pauseOnMouseEnter: !0 }),
                (this.swiper = new Swiper(this.swiperEl, i));
        }
        onSectionLoad(e) {
            e.detail.sectionId === this.dataset.sectionId && this.init();
        }
        onSectionUnload(e) {
            e.detail.sectionId === this.dataset.sectionId &&
                this.swiper &&
                (this.swiper.destroy(!0, !0), (this.swiper = null));
        }
        onBlockSelect(e) {
            this.swiper &&
                (e = e.target.closest(".sis-slide")) &&
                -1 !== (e = Array.from(e.parentElement.children).indexOf(e)) &&
                this.swiper.slideToLoop(e);
        }
    }
    customElements.define("ecx-swiper-slider", ak);
}
if (!customElements.get("ecx-img-carousel")) {
    class vk extends HTMLElement {
        connectedCallback() {
            (this.swiperEl = this.querySelector(".ics__swiper")),
                (this.prevBtn = this.querySelector(".ics__btn--prev")),
                (this.nextBtn = this.querySelector(".ics__btn--next")),
                (this.paginationEl = this.querySelector(".ics__pagination")),
                window.Swiper ? this.init() : this.loadSwiper();
        }
        loadSwiper() {
            document.querySelector('link[href*="swiper-bundle"]') ||
                (((e = document.createElement("link")).rel = "stylesheet"),
                (e.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"),
                document.head.appendChild(e));
            if (document.querySelector('script[src*="swiper-bundle"]')) {
                var t = setInterval(
                    function () {
                        window.Swiper && (clearInterval(t), this.init());
                    }.bind(this),
                    50
                );
            } else {
                var e = document.createElement("script");
                (e.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"),
                    (e.onload = this.init.bind(this)),
                    document.head.appendChild(e);
            }
        }
        init() {
            var e = this.dataset,
                t = parseInt(e.slidesDesktop) || 4,
                s = parseInt(e.slidesTablet) || 3,
                i = parseInt(e.slidesMobile) || 1,
                n = parseInt(e.spaceBetween) || 0,
                r = "true" === e.loop,
                o = "true" === e.centered,
                a = "true" === e.freeMode,
                l = "true" === e.autoplay,
                h = parseInt(e.autoplayDelay) || 5e3,
                d = "true" === e.showNavigation,
                e = "true" === e.showPagination,
                i = {
                    slidesPerView: i,
                    spaceBetween: n,
                    centeredSlides: o,
                    loop: r,
                    freeMode: a,
                    grabCursor: !0,
                    speed: 500,
                    touchRatio: 1,
                    touchStartPreventDefault: !1,
                    breakpoints: {
                        768: { slidesPerView: s, spaceBetween: n },
                        1024: { slidesPerView: t, spaceBetween: n },
                    },
                };
            d && this.prevBtn && this.nextBtn && (i.navigation = { prevEl: this.prevBtn, nextEl: this.nextBtn }),
                e && this.paginationEl && (i.pagination = { el: this.paginationEl, clickable: !0 }),
                l && (i.autoplay = { delay: h, disableOnInteraction: !1, pauseOnMouseEnter: !0 }),
                (this.swiper = new Swiper(this.swiperEl, i));
        }
    }
    customElements.define("ecx-img-carousel", vk);
}
if (!customElements.get("ecx-faq-navigator")) {
    class Lk extends HTMLElement {
        connectedCallback() {
            (this._sectionId = this.dataset.sectionId),
                (this._tabs = Array.from(this.querySelectorAll(".fn-tab"))),
                (this._groups = Array.from(this.querySelectorAll(".fn-group"))),
                (this._onTabClick = this._handleTabClick.bind(this)),
                (this._onAccordionClick = this._handleAccordionClick.bind(this));
            var e = this.querySelector(".fn-tabs"),
                t = this.querySelector(".fn-content");
            e && e.addEventListener("click", this._onTabClick),
                t && t.addEventListener("click", this._onAccordionClick),
                window.Shopify &&
                    window.Shopify.designMode &&
                    (document.addEventListener(
                        "shopify:section:load",
                        (this._onSectionLoad = function (e) {
                            e.detail.sectionId === this._sectionId &&
                                ((this._tabs = Array.from(this.querySelectorAll(".fn-tab"))),
                                (this._groups = Array.from(this.querySelectorAll(".fn-group"))));
                        }.bind(this))
                    ),
                    document.addEventListener(
                        "shopify:block:select",
                        (this._onBlockSelect = function (e) {
                            e.detail.sectionId === this._sectionId &&
                                (e = this.querySelector('.fn-tab[data-block-id="' + e.detail.blockId + '"]')) &&
                                this._activateTab(e.dataset.tab);
                        }.bind(this))
                    ),
                    document.addEventListener(
                        "shopify:section:unload",
                        (this._onSectionUnload = function (e) {
                            e.detail.sectionId === this._sectionId && this.disconnectedCallback();
                        }.bind(this))
                    ));
        }
        disconnectedCallback() {
            var e = this.querySelector(".fn-tabs"),
                t = this.querySelector(".fn-content");
            e && e.removeEventListener("click", this._onTabClick),
                t && t.removeEventListener("click", this._onAccordionClick),
                this._onSectionLoad && document.removeEventListener("shopify:section:load", this._onSectionLoad),
                this._onSectionUnload && document.removeEventListener("shopify:section:unload", this._onSectionUnload),
                this._onBlockSelect && document.removeEventListener("shopify:block:select", this._onBlockSelect);
        }
        _activateTab(e) {
            this._tabs.forEach(function (e) {
                e.classList.remove("active"), e.setAttribute("aria-selected", "false");
            }),
                this._groups.forEach(function (e) {
                    e.classList.remove("active"),
                        e.querySelectorAll(".fn-item.open").forEach(function (e) {
                            e.classList.remove("open"),
                                e.querySelector(".fn-question").setAttribute("aria-expanded", "false");
                            e = e.querySelector(".fn-answer");
                            e && (e.style.maxHeight = "0px");
                        });
                });
            var t = this.querySelector('.fn-tab[data-tab="' + e + '"]'),
                e = this.querySelector('.fn-group[data-group="' + e + '"]');
            t && (t.classList.add("active"), t.setAttribute("aria-selected", "true")), e && e.classList.add("active");
        }
        _handleTabClick(e) {
            e = e.target.closest(".fn-tab");
            e && this._activateTab(e.dataset.tab);
        }
        _handleAccordionClick(e) {
            var t,
                s,
                i,
                e = e.target.closest(".fn-question");
            e &&
                ((t = e.closest(".fn-item")),
                (i = e.closest(".fn-group")),
                (s = t.classList.contains("open")),
                i.querySelectorAll(".fn-item.open").forEach(function (e) {
                    e.classList.remove("open"), e.querySelector(".fn-question").setAttribute("aria-expanded", "false");
                    e = e.querySelector(".fn-answer");
                    e && (e.style.maxHeight = "0px");
                }),
                !s) &&
                (t.classList.add("open"),
                e.setAttribute("aria-expanded", "true"),
                (i = t.querySelector(".fn-answer"))) &&
                (i.style.maxHeight = i.scrollHeight + "px");
        }
    }
    customElements.define("ecx-faq-navigator", Lk);
}
if (!customElements.get("ecx-stats-counter")) {
    class jl extends HTMLElement {
        connectedCallback() {
            (this._items = Array.from(this.querySelectorAll("[data-counter-target]"))),
                this._items.length &&
                    ((this._observer = new IntersectionObserver(this._onIntersect.bind(this), { threshold: 0.2 })),
                    this._observer.observe(this));
        }
        disconnectedCallback() {
            this._observer && this._observer.disconnect();
        }
        _onIntersect(e) {
            e.forEach(
                function (e) {
                    e.isIntersecting && (this._observer.disconnect(), this._animateAll());
                }.bind(this)
            );
        }
        _animateAll() {
            this._items.forEach(function (e) {
                var i,
                    n = parseFloat(e.dataset.counterTarget) || 0,
                    r = parseInt(e.dataset.counterDecimals) || 0,
                    o = parseInt(e.dataset.counterDuration) || 2e3,
                    a = e.querySelector(".sc-value");
                a &&
                    ((i = null),
                    requestAnimationFrame(function e(t) {
                        i = i || t;
                        var t = Math.min((t - i) / o, 1),
                            s = (1 === t ? 1 : 1 - Math.pow(2, -10 * t)) * n;
                        (a.textContent = s.toFixed(r).replace(/\B(?=(\d{3})+(?!\d))/g, ",")),
                            t < 1 && requestAnimationFrame(e);
                    }));
            });
        }
    }
    customElements.define("ecx-stats-counter", jl);
}
if (!customElements.get("ecx-animated-heading")) {
    class xl extends HTMLElement {
        constructor() {
            super(),
                (this.textEl = null),
                (this.wordEls = []),
                (this.pinWrapper = null),
                (this.scrollHandler = null),
                (this.resizeHandler = null),
                (this.raf = null),
                (this.observer = null),
                (this.scrollStart = 0),
                (this.sectionTop = 0),
                (this.pinTop = 0),
                (this.pinScrollRange = 0);
        }
        connectedCallback() {
            var e;
            (this.textEl = this.querySelector(".js-ecx-ah-text")),
                this.textEl &&
                    "true" === this.dataset.reveal &&
                    (this.splitWords(),
                    (e = this.parentElement?.hasAttribute("data-ecx-ah-pin")),
                    "fixed" === this.dataset.revealMode && e
                        ? ((this.pinWrapper = this.parentElement), this.initFixedSticky())
                        : this.initNatural());
        }
        splitWords() {
            var e = this.textEl.textContent.trim().split(/\s+/);
            let s = document.createDocumentFragment();
            e.forEach((e, t) => {
                0 < t && s.appendChild(document.createTextNode(" "));
                t = document.createElement("span");
                (t.className = "ecx-ah-word"), (t.textContent = e), s.appendChild(t);
            }),
                (this.textEl.innerHTML = ""),
                this.textEl.classList.add("is-split"),
                this.textEl.appendChild(s),
                (this.wordEls = Array.from(this.textEl.querySelectorAll(".ecx-ah-word")));
        }
        initFixedSticky() {
            (this.scrollHandler = () => {
                this.raf || (this.raf = requestAnimationFrame(this.updatePinFill.bind(this)));
            }),
                (this.resizeHandler = () => {
                    this.recalculatePin(),
                        this.raf || (this.raf = requestAnimationFrame(this.updatePinFill.bind(this)));
                }),
                window.addEventListener("resize", this.resizeHandler),
                (this.observer = new IntersectionObserver(
                    (e) => {
                        e[0].isIntersecting &&
                            (this.recalculatePin(),
                            document.addEventListener("scroll", this.scrollHandler, { passive: !0 }),
                            requestAnimationFrame(this.updatePinFill.bind(this)),
                            this.observer.disconnect(),
                            (this.observer = null));
                    },
                    { threshold: 0 }
                )),
                this.observer.observe(this.pinWrapper);
        }
        recalculatePin() {
            var e = window.scrollY || document.documentElement.scrollTop;
            (this.pinTop = this.pinWrapper.getBoundingClientRect().top + e),
                (this.pinScrollRange = this.pinWrapper.offsetHeight - this.offsetHeight);
        }
        updatePinFill() {
            this.raf = null;
            var e = window.scrollY || document.documentElement.scrollTop,
                e = Math.max(0, Math.min(100, ((e - this.pinTop) / this.pinScrollRange) * 100));
            this.applyWordFills(e);
        }
        initNatural() {
            (this.scrollHandler = () => {
                this.raf || (this.raf = requestAnimationFrame(this.updateNaturalFill.bind(this)));
            }),
                (this.resizeHandler = () => {
                    this.raf || (this.raf = requestAnimationFrame(this.updateNaturalFill.bind(this)));
                }),
                window.addEventListener("resize", this.resizeHandler),
                (this.observer = new IntersectionObserver(
                    (e) => {
                        e[0].isIntersecting &&
                            (document.addEventListener("scroll", this.scrollHandler, { passive: !0 }),
                            requestAnimationFrame(this.updateNaturalFill.bind(this)),
                            this.observer.disconnect(),
                            (this.observer = null));
                    },
                    { threshold: 0 }
                )),
                this.observer.observe(this);
        }
        updateNaturalFill() {
            this.raf = null;
            var e = window.innerHeight,
                t = this.textEl.getBoundingClientRect(),
                t = Math.max(0, Math.min(100, ((e - t.top) / e) * 100));
            this.applyWordFills(t);
        }
        applyWordFills(s) {
            let i = this.wordEls.length;
            this.wordEls.forEach((e, t) => {
                t = Math.max(0, Math.min(100, ((s - (t / i) * 100) / (100 / i)) * 100));
                e.style.setProperty("--ecx-ah-fill", t.toFixed(2) + "%");
            });
        }
        disconnectedCallback() {
            this.scrollHandler &&
                (document.removeEventListener("scroll", this.scrollHandler), (this.scrollHandler = null)),
                this.resizeHandler &&
                    (window.removeEventListener("resize", this.resizeHandler), (this.resizeHandler = null)),
                this.observer && (this.observer.disconnect(), (this.observer = null));
        }
    }
    customElements.define("ecx-animated-heading", xl);
}
if (!customElements.get("ecx-age-verification")) {
    class Rl extends ECXCustomComponent {
        constructor() {
            super(),
                (this.storageKey = this.dataset.storageKey),
                (this.rememberDays = parseInt(this.dataset.rememberDays, 10) || 30),
                (this.denyUrl = this.dataset.denyUrl);
        }
        connectedCallback() {
            this.init();
        }
        init() {
            (this.elms = {
                confirmBtn: this.$(".js-age-verification-confirm"),
                denyBtn: this.$(".js-age-verification-deny"),
            }),
                this.bindEventHandlers(),
                Shopify.designMode
                    ? (this.editorHelper = new ECXPopupEditorHelper(this, this.dataset.section))
                    : this.isVerified() || this.open();
        }
        bindEventHandlers() {
            this.elms.confirmBtn?.addEventListener("click", this.onConfirm.bind(this)),
                this.elms.denyBtn?.addEventListener("click", this.onDeny.bind(this));
        }
        togglePopup(e) {
            e ? this.open() : this.close();
        }
        open() {
            document.body.classList.add("is-age-verification-show"),
                this.setAttribute("open", ""),
                ECXHelper.trapFocus(this, this.elms.confirmBtn);
        }
        close() {
            document.body.classList.remove("is-age-verification-show"),
                this.removeAttribute("open"),
                ECXHelper.removeTrapFocus();
        }
        onConfirm() {
            this.saveVerification(), this.close();
        }
        onDeny() {
            this.denyUrl ? (window.location.href = this.denyUrl) : window.history.back();
        }
        saveVerification() {
            var e = Date.now() + 24 * this.rememberDays * 60 * 60 * 1e3;
            localStorage.setItem(this.storageKey, e.toString());
        }
        isVerified() {
            var e = parseInt(localStorage.getItem(this.storageKey), 10);
            return !(!e || (Date.now() > e && (localStorage.removeItem(this.storageKey), 1)));
        }
    }
    customElements.define("ecx-age-verification", Rl);
}
// coupan code slider
class CouponSlider {
    constructor(section) {
        this.section = section;
        this.wrapper = section.querySelector('.coupon-slider-section');
        this.track = section.querySelector(".coupon-track");
        this.slides = [...section.querySelectorAll(".coupon-slide")];
        this.dots = [...section.querySelectorAll(".coupon-dot")];
        this.progress = section.querySelector(".coupon-progress-fill");

        this.current = 0;
        this.startTime = null;
        this.raf = null;
        this.interval = null;

        this.delay = 3000 ;
        this.autoplay = 'true' ;
        this.count = this.slides.length;

        if (!this.track || this.count === 0) return;

        this.init();
    }

  init() {
    this.goTo(0, false);

    if (this.count <= 1) {
      const bottom = this.section.querySelector(".coupon-bottom");
      if (bottom) bottom.style.display = "none";
      return;
    }

    this.bindEvents();

    if (this.autoplay) {
      this.play();
    }
  }

  bindEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        this.goTo(Number(dot.dataset.index));
        this.restart();
      });
    });

    this.section.addEventListener("mouseenter", () => {
      this.pause();
    });

    this.section.addEventListener("mouseleave", () => {
      if (this.autoplay) this.play();
    });

    this.section.addEventListener("click", (e) => {
      const btn = e.target.closest(".coupon-copy-btn");

      if (!btn) return;

      navigator.clipboard.writeText(btn.dataset.code);

      const text = btn.textContent;

      btn.textContent = "Copied!";
      btn.classList.add("copied");

      setTimeout(() => {
        btn.textContent = text;
        btn.classList.remove("copied");
      }, 1500);
    });

    // Swipe
    let startX = 0;

    this.section.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    });

    this.section.addEventListener("touchend", (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) < 40) return;

      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }

      this.restart();
    });
  }

  goTo(index, animate = true) {
    if (!animate) {
      this.track.style.transition = "none";
    } else {
      this.track.style.transition = "transform .45s ease";
    }

    this.current = index;

    this.track.style.transform = `translateX(-${index * 100}%)`;

    this.dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });

    requestAnimationFrame(() => {
      this.track.style.transition = "transform .45s ease";
    });

    this.resetProgress();
  }

  next() {
    let next = this.current + 1;

    if (next >= this.count) next = 0;

    this.goTo(next);
  }

  prev() {
    let prev = this.current - 1;

    if (prev < 0) prev = this.count - 1;

    this.goTo(prev);
  }

  play() {
    this.pause();

    this.interval = setInterval(() => {
    this.next();
    }, this.delay);
    this.animateProgress();
  }

  pause() {
    clearInterval(this.interval);
    cancelAnimationFrame(this.raf);
  }

  restart() {
    if (!this.autoplay) return;

    this.play();
  }

  resetProgress() {
    if (this.progress) {
      this.progress.style.width = "0%";
    }
  }

    animateProgress() {
        if (!this.progress) return;

        cancelAnimationFrame(this.raf);

        this.progress.style.width = "0%";

        const start = performance.now();

        const animate = (now) => {
            const elapsed = now - start;
            const percent = Math.min((elapsed / this.delay) * 100, 100);

            this.progress.style.width = percent + "%";

            if (percent < 100) {
            this.raf = requestAnimationFrame(animate);
            }
        };

        this.raf = requestAnimationFrame(animate);
    }
}

function initCouponSliders() {
  document.querySelectorAll(".coupon-slider-section").forEach((section) => {
    if (section.dataset.init === "true") return;

    section.dataset.init = "true";

    new CouponSlider(section);
  });
}

document.addEventListener("DOMContentLoaded", initCouponSliders);
document.addEventListener("shopify:section:load", initCouponSliders);